/* ============================================================================
   landing-buda.js — Interactividad de la Landing Mágica (Módulo E)

   Vanilla puro, sin librerías. TODO es defensivo: si un nodo no existe (una
   sección se desactivó, o el metafield estaba blank), la función retorna sin
   romper. Se ejecuta una vez tras DOMContentLoaded.

   Piezas:
     • Rotador de announcement (fade cada 4s)
     • Selector de variantes (pills) → actualiza input[name=id] del form
     • Widget OFERTA DEL DÍA → setea input[name=quantity] + precio mostrado
     • Countdown a medianoche local
     • Carrusel UGC (scroll-snap + flechas)
     • Sticky ATC móvil (aparece tras scroll > 600px, hace submit del form)
   ============================================================================ */

(function () {
  'use strict';

  // ── SKIN OSCURO DE CTA POR DOMINIO (dictado dueño 16-sep-2026) ────────────
  // Este mismo archivo (y landing-buda.css) se despliega BYTE A BYTE en las DOS
  // tiendas MX — Soy Buda y NovaStore, ver scripts/subir-tema-landing.mjs líneas
  // 78-79 — así que ninguna regla nueva puede vivir sin ámbito: se pintaría
  // también en NovaStore, que el encargo prohíbe tocar.
  // Se ancla al DOMINIO REAL de la tienda (soybuda.mx / su myshopify.com), NO a
  // un campo del metafield (`codSkin.modo`): medido en vivo, al menos un registro
  // (pack-coleccion-sagrado-corazon) tiene `codSkin: null` pese a ser Soy Buda, así
  // que ese campo puede faltar. El dominio nunca falta.
  // Se ejecuta ANTES de ready() — en cuanto el script parsea, no en DOMContentLoaded
  // — para minimizar el parpadeo, mismo criterio que ya usan `.lb-reveal` y
  // `.lb2-skin-buda` (ambas activadas por JS en este mismo archivo).
  // Caso 7 (16-sep-2026): NovaStore recibe la MISMA mejora de estilo, con SU
  // color de marca — mismo mecanismo, gate por dominio, misma forma exacta que
  // el bloque de arriba (ver landing-buda.css: html.lb-skin-nova define sus
  // propios tokens --lbcta-* con el naranja #D4653D en vez del cobre).
  try {
    var _lbHost = String((window.location && window.location.hostname) || '').toLowerCase();
    if (/(^|\.)(soybuda\.mx|soybudamex\.myshopify\.com)$/.test(_lbHost)) {
      document.documentElement.classList.add('lb-skin-buda');
    } else if (/(^|\.)(compranovastore\.com|61c0c4-0f\.myshopify\.com)$/.test(_lbHost)) {
      document.documentElement.classList.add('lb-skin-nova');
    }
  } catch (e) {}

  // ── UNA SOLA VEZ POR PÁGINA (velocidad MX, CORDI 21-oct-2026) ─────────────
  //   Si el <script> llegara a emitirse dos veces (dos snippets, un template con
  //   main + snippet), la 2ª copia NO arranca: dos copias = dos juegos de
  //   listeners en el CTA = doble overlay y doble orden (ver el comentario
  //   "Gate v2 CRÍTICO" de landing-buda-main.liquid). Va DESPUÉS del bloque del
  //   skin, que es idempotente (classList.add).
  try {
    if (window.__lbBudaCargado) return;
    window.__lbBudaCargado = true;
  } catch (e) {}

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ── CADA INIT DE LA ZONA DE COMPRA CORRE UNA SOLA VEZ (velocidad MX, 21-oct) ──
  //   La zona de compra (initBuyBox, initCartForm, initStickyOffers, initCod) se
  //   arranca ANTES de DOMContentLoaded cuando su HTML ya está parseado (ver el
  //   ARRANQUE TEMPRANO al final del archivo) y ready() la vuelve a llamar en
  //   DOMContentLoaded: el 2º llamado tiene que ser un no-op. initBuyBox NO tenía
  //   guard propio — enlazarlo dos veces haría, p. ej., que el stepper sume de a 2.
  var _lbHecho = {};
  function lbYaCorrio(nombre) {
    if (_lbHecho[nombre]) return true;
    _lbHecho[nombre] = true;
    return false;
  }

  // DEFENSIVO (vivía dentro de initCod): con COD propio, ningún botón de Releasit
  // (app-embed que se auto-inyecta) debe quedar visible — pintaría un checkout
  // paralelo que ignora nuestro overlay. El gate real es el <button type=button>
  // del Liquid; esto solo oculta residuos. Idempotente. Con el arranque temprano se
  // REPITE en DOMContentLoaded (los residuos inyectados entre medias también caen).
  function lbOcultarRestosReleasit() {
    try {
      document.querySelectorAll(
        '[id*="releasit"], [class*="releasit"], .rebolt-cod-form, #ReleasitCodForm'
      ).forEach(function (n) { if (n && n.style) n.style.display = 'none'; });
    } catch (e) {}
  }

  // ── CAPI helpers (D2) ────────────────────────────────────────────────────────
  // uuidV4: id de evento estable por FINALIZAR — el MISMO valor viaja en el
  // payload (attr.eventId) y en TODAS las llamadas fbq Purchase (visible Y flush),
  // para que Meta dedupe el Purchase del pixel contra el Purchase server-side (CAPI).
  // Sin dependencias: usa crypto.randomUUID / getRandomValues si existe, con
  // fallback a Math.random (basta como identificador de dedupe, no es criptográfico).
  function uuidV4() {
    try {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
      if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        var b = new Uint8Array(16);
        crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40; // versión 4
        b[8] = (b[8] & 0x3f) | 0x80; // variante
        var h = [];
        for (var i = 0; i < 256; i++) h[i] = (i + 0x100).toString(16).slice(1);
        return h[b[0]] + h[b[1]] + h[b[2]] + h[b[3]] + '-' + h[b[4]] + h[b[5]] + '-' +
               h[b[6]] + h[b[7]] + '-' + h[b[8]] + h[b[9]] + '-' +
               h[b[10]] + h[b[11]] + h[b[12]] + h[b[13]] + h[b[14]] + h[b[15]];
      }
    } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // leerCookie: lee una cookie por nombre del document.cookie de la landing.
  // El fetch a /ordenar va cross-origin (endpoint ngrok) SIN credentials, así que
  // las cookies del dominio de la tienda (_fbp / _fbc de Meta) JAMÁS llegan solas:
  // se leen aquí y se meten explícitas en el payload (attr). Devuelve '' si falta.
  function leerCookie(nombre) {
    try {
      var pares = String(document.cookie || '').split(';');
      for (var i = 0; i < pares.length; i++) {
        var p = pares[i].trim();
        if (p.indexOf(nombre + '=') === 0) return decodeURIComponent(p.slice(nombre.length + 1));
      }
    } catch (e) {}
    return '';
  }

  // construirAttr: arma el bloque attr:{fbp,fbc,url,eventId} para el payload.
  // - fbp: cookie _fbp tal cual.
  // - fbc: cookie _fbc; si no existe pero la URL trae fbclid, se sintetiza el
  //   formato Meta 'fb.1.<ts>.<fbclid>'.
  // - Retrocompat: si no hay cookies ni fbclid, esos campos se OMITEN (no van
  //   como '' ni null) — el server los valida por formato y attr queda sin ellos.
  function construirAttr(eventId) {
    var attr = { url: (function () { try { return location.href; } catch (e) { return ''; } })(), eventId: eventId };
    var fbp = leerCookie('_fbp');
    if (fbp) attr.fbp = fbp;
    var fbc = leerCookie('_fbc');
    if (!fbc) {
      try {
        var m = String(location.search || '').match(/[?&]fbclid=([^&]+)/);
        if (m && m[1]) fbc = 'fb.1.' + Date.now() + '.' + decodeURIComponent(m[1]);
      } catch (e) {}
    }
    if (fbc) attr.fbc = fbc;
    return attr;
  }

  // ── Sticky adhesivo v2: estado compartido entre initStickyOffers y initCodV2 ──
  //   El sticky [data-lb-sticky-offers] se REPARENTA a document.body (escapa de
  //   ancestros con transform de Dawn que rompen position:fixed) y es SIEMPRE
  //   visible desde el load. Mientras el overlay v2 está abierto se OCULTA y al
  //   cerrar se re-muestra. Estas dos funciones son el hook que initCodV2 usa
  //   (openOverlay2/closeOverlay2) sin conocer el nodo del sticky.
  var _lbStickyOffersBar = null;
  var _lbStickyOffersOverlayOpen = false; // overlay v2 abierto → sticky SIEMPRE oculto
  var _lbStickyOffersEval = null;         // re-evalúa la condición de scroll (la instala initStickyOffers)
  var _lbStickyPadPrev = null;            // padding-bottom inline del <body> antes de sumarle los 90px
  function ocultarStickyOffers() {
    _lbStickyOffersOverlayOpen = true;
    if (_lbStickyOffersBar) _lbStickyOffersBar.style.display = 'none';
  }
  function mostrarStickyOffers() {
    _lbStickyOffersOverlayOpen = false;
    if (_lbStickyOffersBar) _lbStickyOffersBar.style.display = '';
    // NO mostrar a ciegas (corrección dueño ronda 6): al cerrar el overlay se
    // RE-EVALÚA la condición de scroll — solo reaparece si el usuario sigue
    // más abajo de la píldora de la página.
    if (_lbStickyOffersEval) _lbStickyOffersEval();
  }

  // NOTA sobre el dinero: Liquid es la ÚNICA fuente de verdad del formato. Cada
  // tier renderiza su precio/comparación ya formateados (`| money`) en los
  // data-attrs data-tier-precio-money / data-tier-comp-money; selectTier solo
  // COPIA esos strings a los nodos de precio. No se reformatea en JS (evita el
  // bug de money_format y los centavos falsos en monedas sin decimales).

  // ── CASO 2 (dueño 28-jul) · PUENTE «adicionales → botón de la PÁGINA» ───────
  //   "Si selecciono la pulsera y el anillo, el precio en el botón no cambia."
  //   Diagnóstico: actualizarStickyTier (dentro de initBuyBox) arma el texto SOLO
  //   con el precio del tier y jamás mira los checks; los checks (ticksState) viven
  //   en OTRO closure (initCodV2, dentro de initCod). No se hablaban.
  //   Este puente de MÓDULO los conecta sin exponer nada en window:
  //     · initCodV2 registra un proveedor de extras → {cuantos, total}.
  //     · initBuyBox registra cómo repintar el botón (con el último pack elegido).
  //     · cualquiera de los dos lados puede pedir un repintado.
  //   Si no hay adicionales (o initCodV2 no corre) el proveedor queda null y el
  //   botón se comporta EXACTAMENTE como antes → retrocompat total.
  //   ⚠️ El puente es solo DISPLAY: la verdad de los precios sigue siendo el
  //   servidor (src/cod/router.js recalcula el desglose con los del metafield).
  var _lbExtrasProvider = null;  // () => { cuantos:Number, total:Number }
  var _lbStickyRepaint = null;   // () => void  (lo instala initBuyBox)
  function lbExtrasInfo() {
    if (typeof _lbExtrasProvider !== 'function') return null;
    try {
      var r = _lbExtrasProvider();
      var cuantos = r ? Number(r.cuantos) : 0;
      if (!Number.isFinite(cuantos) || cuantos <= 0) return null;
      var total = r ? Number(r.total) : 0;
      return { cuantos: cuantos, total: Number.isFinite(total) && total > 0 ? total : 0 };
    } catch (e) { return null; }
  }
  function lbRegistrarExtras(fn) { _lbExtrasProvider = fn; lbRepintarSticky(); }
  function lbRepintarSticky() {
    if (typeof _lbStickyRepaint !== 'function') return;
    try { _lbStickyRepaint(); } catch (e) {}
  }

  // ── CASO 5 · «la foto GRANDE cambia al elegir» (dueño, 04-sep-2026) ──────────
  //   Desde el 17-jul, elegir un color en el selector de una unidad cambiaba SOLO
  //   la miniatura de 120px de esa fila (.lb-tier-unit__thumb). La galería de
  //   arriba —la foto por la que el cliente decide— se quedaba quieta, así que la
  //   feature estaba a medias. Este es el puente: initGallery deja aquí una forma
  //   de saltar a la diapositiva de una foto e initBuyBox la llama cuando el
  //   cliente cambia un selector.
  //   El puente es OPCIONAL en las dos direcciones: sin galería en la página
  //   (queda null) o sin foto por variante, todo se comporta como antes.
  var _lbGaleriaIrAImagen = null; // (url) => bool  (lo instala initGallery)

  // La MISMA foto llega con dos formas distintas: el thumb la pide a 120×120 con
  // crop y la galería a 900 de ancho, así que las query strings NUNCA coinciden
  // (?crop=center&height=120&width=120 vs ?width=900). Lo estable es la RUTA del
  // CDN (/cdn/shop/files/<archivo>), y por ahí se comparan.
  function lbRutaImagen(u) {
    var s = String(u == null ? '' : u).trim();
    if (!s) return '';
    s = s.split('?')[0].split('#')[0];
    var m = s.match(/^(?:https?:)?\/\/[^/]+(\/.+)$/); // //host/ruta y https://host/ruta
    return m ? m[1] : s;
  }
  // Escape de HTML a nivel de MÓDULO (initCod tiene el suyo, `escapaHtml`, en su
  // propio closure). Todo texto que entre por innerHTML pasa por aquí.
  function lbEscHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Convierte un string de dinero ya formateado ("$1,398.00", "1.398,00") a número.
  // Toma solo dígitos y el ÚLTIMO separador decimal; best-effort.
  // 📍 28-jul: SUBIDA a scope de módulo (vivía dentro de initCod) porque el puente
  // del CASO 2 la necesita también en initBuyBox. Las llamadas de initCod/initCodV2
  // resuelven igual por cadena de scopes — comportamiento idéntico.
  function precioNumerico(money) {
    var s = String(money == null ? '' : money).replace(/[^\d.,]/g, '');
    if (!s) return 0;
    var ultimaComa = s.lastIndexOf(','), ultimoPunto = s.lastIndexOf('.');
    var sepDecimal = ultimaComa > ultimoPunto ? ',' : '.';
    var entero, dec = '';
    var idx = s.lastIndexOf(sepDecimal);
    // Solo se trata como decimal si hay 1-2 dígitos tras el separador (si no, es de miles).
    if (idx >= 0 && s.length - idx - 1 <= 2 && s.length - idx - 1 >= 1) {
      entero = s.slice(0, idx).replace(/[.,]/g, '');
      dec = s.slice(idx + 1);
    } else {
      entero = s.replace(/[.,]/g, '');
    }
    var n = Number(entero + (dec ? '.' + dec : ''));
    return Number.isFinite(n) ? n : 0;
  }

  // ── Config COD del metafield, leída UNA vez ────────────────────────────────
  //   [data-lb-cod-config] es el ÚNICO JSON que el tema emite al cliente (lo
  //   escriben landing-buda-main.liquid y el snippet inline). Varias funciones ya
  //   lo parsean por su cuenta; este helper es SOLO para las claves nuevas (gates
  //   A4/A10) y no toca ninguna de esas lecturas. Sin nodo / JSON roto → {}.
  var _lbCodCfgCache;
  function lbCodConfig() {
    if (_lbCodCfgCache !== undefined) return _lbCodCfgCache;
    _lbCodCfgCache = {};
    try {
      var n = document.querySelector('[data-lb-cod-config]');
      if (n) _lbCodCfgCache = JSON.parse(n.textContent || '{}') || {};
    } catch (e) { _lbCodCfgCache = {}; }
    return _lbCodCfgCache;
  }
  // Objeto codSticky del metafield (o null). Las claves NUEVAS viven aquí porque
  // el tema ya lo emite: agregar una clave de primer nivel exigiría tocar los dos
  // .liquid, que no están en el alcance de este cambio.
  function lbCodSticky() {
    var c = lbCodConfig();
    return (c && c.codSticky && typeof c.codSticky === 'object') ? c.codSticky : null;
  }

  // ── MONEDA DE LA TIENDA (dueño, 29-oct) ──────────────────────────────────────
  //   Este archivo sirve a las dos tiendas de México Y a la colombiana (mismo asset).
  //   En Colombia el formulario propio (cod-co.liquid) se esconde cuando el producto
  //   está agotado, y entonces la píldora abre ESTE overlay: salía «en casi todo
  //   MÉXICO 🇲🇽», «$59,000.00 MXN» y «Envío gratis 🇲🇽» en una tienda que cobra en
  //   pesos colombianos. Los cuatro textos que nombran país, bandera o moneda salen
  //   de aquí. Fuente: `moneda` del JSON [data-lb-cod-config] (shop.currency, lo
  //   emite el snippet); respaldo, el data-moneda del nodo de cod-mejoras; sin dato
  //   → pesos mexicanos, o sea la conducta de siempre: en las tiendas de México todo
  //   queda BYTE A BYTE como antes.
  var _lbMonedaCache;
  function lbMonedaTienda() {
    if (_lbMonedaCache !== undefined) return _lbMonedaCache;
    var m = '';
    try {
      var c = lbCodConfig();
      if (c && typeof c.moneda === 'string') m = c.moneda;
      if (!m) {
        var n = document.querySelector('[data-cod-mejoras][data-moneda]');
        if (n) m = n.getAttribute('data-moneda') || '';
      }
    } catch (e) { m = ''; }
    m = String(m || '').trim().toUpperCase();
    _lbMonedaCache = /^[A-Z]{3}$/.test(m) ? m : "MXN"; // comillas dobles a propósito: el build de Varelú las vuelve "COP"
    return _lbMonedaCache;
  }
  function lbEsMxn() { return lbMonedaTienda() === "MXN"; }
  // «PAGO CONTRA ENTREGA 🚚 en casi todo MÉXICO 🇲🇽» / «… en casi toda COLOMBIA 🇨🇴».
  // Fuera de esas dos monedas no se inventa país: se deja sólo el rótulo.
  function lbPaisCod() {
    var m = lbMonedaTienda();
    if (m === "MXN") return ' en casi todo MÉXICO 🇲🇽';
    if (m === 'COP') return ' en casi toda COLOMBIA 🇨🇴';
    return '';
  }
  // Sublínea de los botones de pago. En México lleva el envío gratis y la bandera
  // (CASO 6, dueño 27-jul); en Colombia el dueño pidió sólo «Paga al recibir» (29-oct).
  function lbSubPago() { return lbEsMxn() ? 'Paga al recibir · Envío gratis 🇲🇽' : 'Paga al recibir'; }
  function lbRotuloCod() { return lbEsMxn() ? 'PAGO CONTRA ENTREGA 🇲🇽' : 'PAGO CONTRA ENTREGA'; }

  // ══ A4 · BARRA ADHESIVA — DECISIÓN PURA ══════════════════════════════════
  //   PURA. ¿Debe verse la barra adhesiva, dado el rect del CTA inline?
  //
  //   siempreVisible !== true  → REGLA DE HOY, BIT A BIT: la barra aparece SOLO
  //     cuando el CTA ya salió por ARRIBA del viewport (rect.bottom <= 0). Es el
  //     default: sin la clave nueva en el metafield NADA cambia en las landings
  //     vivas (la Blusa tiene campaña corriendo).
  //   siempreVisible === true  → la barra aparece siempre que el CTA NO esté
  //     visible, sea porque quedó arriba O porque todavía está más abajo. Así
  //     hay botón de compra en pantalla desde el primer scroll, y se quita sola
  //     cuando el botón real entra a cuadro.
  //
  //   Cualquier número no finito (rect sin medir, viewport 0, JSDOM) cae a la
  //   regla de hoy: jamás decide un NaN.
  function lbStickyDebeVerse(rect, altoViewport, siempreVisible) {
    if (!rect) return false;
    var bottom = Number(rect.bottom);
    if (!Number.isFinite(bottom)) return false;
    if (siempreVisible !== true) return bottom <= 0;
    var top = Number(rect.top);
    var h = Number(altoViewport);
    if (!Number.isFinite(top) || !Number.isFinite(h) || h <= 0) return bottom <= 0;
    var ctaVisible = (bottom > 0 && top < h);
    return !ctaVisible;
  }

  //   PURA. Texto (SIN escapar) del botón COD para el pack elegido.
  //   sigueTier !== true → EXACTO el de hoy ("HOY 2x1: 2 Piezas por $799").
  //   sigueTier === true → el NOMBRE del tier elegido + su precio ("Pack 3 piezas
  //     · $999.00"), que es lo que el cliente acaba de tocar. Si el tier no tiene
  //     nombre legible se cae al texto de hoy (nunca un título vacío).
  function lbTextoPackCOD(n, precioMoney, etiqueta, tierTitulo, sigueTier) {
    var base = (n === 2 ? 'HOY 2x1: ' : 'HOY: ') + n + ' ' + etiqueta + ' por ' + precioMoney;
    if (sigueTier !== true) return base;
    var t = String(tierTitulo == null ? '' : tierTitulo).replace(/\s+/g, ' ').trim();
    if (!t) return base;
    return t + ' · ' + precioMoney;
  }

  // ── Announcement rotativo ─────────────────────────────────────────────────
  function initAnnouncement() {
    var items = document.querySelectorAll('[data-lb-announce] .lb-announce__item');
    if (items.length < 2) return;
    var i = 0;
    items.forEach(function (el, idx) { el.hidden = idx !== 0; });
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 4000);
  }

  // ── Estado compartido de compra (variante + pack) ─────────────────────────
  function initBuyBox() {
    if (lbYaCorrio('buybox')) return; // velocidad 21-oct: temprano o en DCL, nunca dos veces
    var form = document.querySelector('[data-lb-form]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');

    // Variantes serializadas por Liquid.
    var variants = [];
    var dataNode = document.querySelector('[data-lb-variants]');
    if (dataNode) {
      try { variants = JSON.parse(dataNode.textContent || '[]'); } catch (e) { variants = []; }
    }

    // FEATURE (dueño 17-jul): mapa VALOR-de-color → foto para el thumb por-unidad.
    // Emitido por el Liquid como <script type="application/json" data-lb-variant-imgs>
    // {"Dorado":"url120","Plateado":"url120"} — SOLO con packsVariantes + variantes con
    // featured_image. Sin el nodo (o mapa vacío) → hasVariantImgs=false → cero thumbs.
    var variantImgs = {};
    var vimgsNode = document.querySelector('[data-lb-variant-imgs]');
    if (vimgsNode) {
      try { variantImgs = JSON.parse(vimgsNode.textContent || '{}') || {}; } catch (e) { variantImgs = {}; }
    }
    var hasVariantImgs = variantImgs && typeof variantImgs === 'object' && Object.keys(variantImgs).length > 0;

    var selected = {}; // { optionName: value }
    // Semilla: la variante marcada como default en el id inicial.
    if (idInput && variants.length) {
      var cur = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || variants[0];
      if (cur && Array.isArray(cur.options)) {
        cur.optionNames && cur.optionNames.forEach(function (name, idx) { selected[name] = cur.options[idx]; });
      }
    }

    // Encuentra la variante que matchea la selección actual (o la primera).
    function matchVariant() {
      if (!variants.length) return null;
      var names = Object.keys(selected);
      if (!names.length) return variants[0];
      return variants.find(function (v) {
        return names.every(function (n) {
          var idx = (v.optionNames || []).indexOf(n);
          return idx >= 0 && v.options[idx] === selected[n];
        });
      }) || null;
    }

    function syncVariant() {
      var v = matchVariant();
      if (v && idInput) idInput.value = v.id;
      // Marca pills activas + deshabilita las no disponibles para esa combinación.
      form.querySelectorAll('.lb-pill').forEach(function (pill) {
        var name = pill.getAttribute('data-option-name');
        var val = pill.getAttribute('data-option-value');
        pill.classList.toggle('is-active', selected[name] === val);
      });
    }

    // Pills de variante
    form.querySelectorAll('.lb-pill').forEach(function (pill) {
      pill.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (pill.hasAttribute('disabled')) return;
        selected[pill.getAttribute('data-option-name')] = pill.getAttribute('data-option-value');
        syncVariant();
        // FEATURE A: al cambiar la variante base, los tiers aún NO abiertos deben
        // re-prefillarse con la nueva selección la próxima vez que se muestren; el
        // tier activo re-sincroniza sus propiedades vía onPillChange (definido abajo).
        if (typeof onPillChange === 'function') onPillChange();
      });
    });
    syncVariant();

    // ── Widget de packs ──────────────────────────────────────────────────
    var priceNow = document.querySelector('[data-lb-price-now]');
    var priceWas = document.querySelector('[data-lb-price-was]');
    var stickyNow = document.querySelector('[data-lb-sticky-now]');
    var stickyWas = document.querySelector('[data-lb-sticky-was]');

    // ── Formato de dinero para el TIER ABIERTO (stepper − N +) ────────────────
    //   Liquid sigue siendo la fuente de verdad del FORMATO: el precio inicial del
    //   tier ya viene formateado en data-tier-precio-money (`| money`). Para el
    //   recálculo VIVO (unit × N, comparación proporcional) NO reformateamos a ciegas
    //   con un patrón hardcodeado (rompería money_format y metería centavos falsos en
    //   monedas sin decimales): EXTRAEMOS el patrón (prefijo, separadores, nº de
    //   decimales, sufijo) del propio string formateado del tier y reusamos ESE patrón.
    //   patronMoneda('$1,999.00') → {pre:'$', suf:'', miles:',', dec:'.', decN:2}.
    //   milesFallback (opcional): separador de miles a usar cuando el string base
    //   NO lo trae (precio < 1000 → nunca se vio uno). Sin él, un recálculo ≥1000
    //   salía "$1665.00" (miles perdido). Se deriva del comp-money si existe, o coma.
    function patronMoneda(money, milesFallback) {
      var s = String(money == null ? '' : money);
      var first = s.search(/\d/);
      if (first < 0) return { pre: s, suf: '', miles: milesFallback || ',', dec: '.', decN: 2 };
      var last = s.length - 1;
      while (last >= 0 && !/\d/.test(s[last])) last--;
      var pre = s.slice(0, first);
      var suf = s.slice(last + 1);
      var nucleo = s.slice(first, last + 1); // solo dígitos y separadores
      var ultComa = nucleo.lastIndexOf(','), ultPunto = nucleo.lastIndexOf('.');
      var dec = '', decN = 0, miles = '';
      var sepDec = ultComa > ultPunto ? ',' : (ultPunto > ultComa ? '.' : '');
      if (sepDec) {
        var idx = nucleo.lastIndexOf(sepDec);
        var colaDec = nucleo.slice(idx + 1).replace(/\D/g, '');
        // Solo es separador DECIMAL si tras él quedan 1-2 dígitos (si no, es de miles).
        if (colaDec.length >= 1 && colaDec.length <= 2) { dec = sepDec; decN = colaDec.length; }
      }
      // El separador de MILES es el "otro" que aparezca en la parte entera.
      var entera = dec ? nucleo.slice(0, nucleo.lastIndexOf(dec)) : nucleo;
      if (entera.indexOf(',') >= 0 && dec !== ',') miles = ',';
      else if (entera.indexOf('.') >= 0 && dec !== '.') miles = '.';
      // Si el patrón base NO trae separador de miles (precio original < 1000), usa el
      // fallback (comp-money si se pasó, si no coma) — así todo total ≥1000 recalculado
      // sale con miles consistente ("$1,665.00") en card, tachado y desglose.
      if (!miles) miles = (milesFallback && milesFallback !== dec) ? milesFallback : ',';
      return { pre: pre, suf: suf, miles: miles, dec: dec, decN: decN };
    }
    // Formatea un número con un patrón extraído por patronMoneda (mismo look que Liquid).
    function formatearConPatron(n, pat) {
      var num = Number(n);
      if (!Number.isFinite(num)) num = 0;
      var neg = num < 0; if (neg) num = -num;
      var fixed = pat.decN > 0 ? num.toFixed(pat.decN) : String(Math.round(num));
      var partes = fixed.split('.');
      if (pat.miles) partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, pat.miles);
      var cuerpo = partes[0] + (pat.decN > 0 && partes[1] != null ? pat.dec + partes[1] : '');
      return (neg ? '-' : '') + pat.pre + cuerpo + pat.suf;
    }
    // Unidades EFECTIVAS de un tier: el stepper del tier abierto guarda su N en
    // data-tier-unidades; el resto usa data-tier-n. Clamp [min, cap].
    function tierUnidades(tier) {
      if (!tier) return 1;
      var base = Number(tier.getAttribute('data-tier-n')) || 1;
      var eff = tier.hasAttribute('data-tier-unidades')
        ? (Number(tier.getAttribute('data-tier-unidades')) || base) : base;
      return eff;
    }

    // FEATURE A — variantes por unidad. Solo si el theme marcó el widget con
    // data-lb-packs-variantes (packsVariantes:true + producto con opciones reales).
    // El submit sigue siendo variante base × cantidad (Releasit lo intercepta); las
    // selecciones por unidad viajan como line item properties (properties[Unidad K]).
    var packsVariantes = !!form.querySelector('[data-lb-packs-variantes]');

    // El bloque de unidades de un tier es su hermano [data-tier-units].
    function unitsBlockFor(tier) {
      var el = tier.nextElementSibling;
      while (el) {
        if (el.hasAttribute && el.hasAttribute('data-tier-units')) return el;
        // Otro .lb-tier antes de encontrar el bloque → este tier no tiene unidades.
        if (el.classList && el.classList.contains('lb-tier')) return null;
        el = el.nextElementSibling;
      }
      return null;
    }

    // Compone el valor de properties[Unidad K] para una fila de unidad ("Talla: M, Color: Rojo").
    function composeUnitValue(unitEl) {
      var parts = [];
      unitEl.querySelectorAll('[data-unit-select]').forEach(function (sel) {
        var name = sel.getAttribute('data-option-name') || '';
        var val = sel.value || '';
        if (name && val) parts.push(name + ': ' + val);
      });
      return parts.join(', ');
    }

    // FEATURE thumb por-unidad (17-jul): la foto de una fila = la del PRIMER select cuyo
    // valor actual esté en el mapa (el select "de color"). Sin match → '' (thumb oculto).
    function unitThumbUrl(unitEl) {
      if (!hasVariantImgs || !unitEl) return '';
      var url = '';
      unitEl.querySelectorAll('[data-unit-select]').forEach(function (sel) {
        if (url) return;
        var v = sel.value || '';
        if (v && variantImgs[v]) url = variantImgs[v];
      });
      return url;
    }
    // Pinta/oculta el <img class="lb-tier-unit__thumb"> de una fila según su selección.
    function updateUnitThumb(unitEl) {
      if (!unitEl) return;
      var img = unitEl.querySelector('.lb-tier-unit__thumb');
      if (!img) return;
      var url = unitThumbUrl(unitEl);
      if (url) { if (img.getAttribute('src') !== url) img.setAttribute('src', url); img.removeAttribute('hidden'); }
      else { img.removeAttribute('src'); img.setAttribute('hidden', ''); }
    }
    // Refresca los thumbs de todas las filas de un bloque de unidades.
    function refreshBlockThumbs(block) {
      if (!hasVariantImgs || !block) return;
      block.querySelectorAll('.lb-tier-unit').forEach(function (unitEl) { updateUnitThumb(unitEl); });
    }
    // CASO 5 · lleva la GALERÍA a la foto del color que acaba de elegir esta fila.
    // Va SEPARADA de updateUnitThumb a propósito: ese refresco también corre al
    // cargar la página, al prefillar y al cambiar de pack, y mover la galería sola
    // en esos momentos sería un salto que el cliente no pidió. Aquí se llama SOLO
    // desde el 'change' de un selector, que es el gesto del cliente.
    function mostrarUnidadEnGaleria(unitEl) {
      if (!hasVariantImgs || !unitEl) return;
      if (typeof _lbGaleriaIrAImagen !== 'function') return; // página sin galería
      var url = unitThumbUrl(unitEl);
      if (!url) return;
      try { _lbGaleriaIrAImagen(url); } catch (e) {}
    }

    // Habilita SOLO las propiedades del tier activo (los inputs disabled no se envían),
    // y sincroniza su valor con los selects. Todos los demás tiers: propiedades disabled.
    function syncUnitProps(activeTier) {
      if (!packsVariantes) return;
      form.querySelectorAll('[data-tier-units]').forEach(function (block) {
        var isActive = activeTier && unitsBlockFor(activeTier) === block;
        block.querySelectorAll('.lb-tier-unit').forEach(function (unitEl) {
          var prop = unitEl.querySelector('[data-unit-prop]');
          if (!prop) return;
          if (isActive) {
            prop.value = composeUnitValue(unitEl);
            prop.disabled = false;
          } else {
            prop.disabled = true; // no se envía
          }
        });
      });
    }

    // Prefill de los selects de un tier con la variante elegida en las pills.
    // (Solo la primera vez que se abre el tier — si el cliente ya cambió una fila,
    // no la pisamos; marcamos el bloque con data-prefilled.)
    function prefillUnits(tier) {
      if (!packsVariantes) return;
      var block = unitsBlockFor(tier);
      if (!block || block.getAttribute('data-prefilled') === '1') return;
      block.querySelectorAll('[data-unit-select]').forEach(function (sel) {
        var name = sel.getAttribute('data-option-name');
        if (name && selected[name] != null) sel.value = selected[name];
      });
      block.setAttribute('data-prefilled', '1');
      refreshBlockThumbs(block); // el thumb sigue al valor recién prefillado
    }

    // ── TIER ABIERTO: stepper (− N +) ─────────────────────────────────────────
    //   El tier con [data-tier-abierto] deja subir la cantidad (min = data-tier-n,
    //   cap = data-tier-cap). Al cambiar N recalculamos el precio del tier a partir
    //   del UNITARIO (data-tier-precio / data-tier-n) y la comparación proporcional,
    //   los ESCRIBIMOS de vuelta en data-tier-precio-money / data-tier-comp-money del
    //   propio tier (fuente que lee el header, el sticky y el MODAL v2 sin cambios) y
    //   guardamos N en data-tier-unidades (lo lee leerSeleccion para el payload).
    function tierEsAbierto(tier) { return !!(tier && tier.getAttribute('data-tier-abierto') === 'true'); }
    function stepperDe(tier) { return tier ? tier.querySelector('[data-tier-stepper]') : null; }
    function minDe(tier) {
      var st = stepperDe(tier);
      return st ? (Number(st.getAttribute('data-tier-min')) || (Number(tier.getAttribute('data-tier-n')) || 1)) : (Number(tier.getAttribute('data-tier-n')) || 1);
    }
    function capDe(tier) {
      var st = stepperDe(tier);
      var c = st ? Number(st.getAttribute('data-tier-cap')) : 10;
      return Number.isFinite(c) && c > 0 ? c : 10;
    }
    // Recalcula precio/comparación del tier abierto para N unidades y los ESCRIBE en
    // los data-attrs -money (patrón de formato tomado del string original de Liquid).
    // Devuelve los strings formateados para pintar de una.
    function recomputarAbierto(tier, n) {
      var base = Number(tier.getAttribute('data-tier-n')) || 1;
      var precioRaw = Number(tier.getAttribute('data-tier-precio'));
      var compRaw = Number(tier.getAttribute('data-tier-comp'));
      // Fallback de separador de miles: el comp-money (tachado) suele venir ≥1000 y SÍ
      // trae el separador real de la tienda; lo usamos si el precio-money (<1000) no lo
      // trae. Así el precio recalculado ≥1000 no pierde los miles ("$1,665.00").
      var patComp0 = patronMoneda(tier.getAttribute('data-tier-comp-money') || '');
      var milesFallback = patComp0.miles || ',';
      // Patrón de formato: del -money original (mantiene money_format de la tienda).
      var patP = patronMoneda(tier.getAttribute('data-tier-precio-money'), milesFallback);
      var unit = (Number.isFinite(precioRaw) && base > 0) ? precioRaw / base : 0;
      var totalP = Math.round((unit * n) * 100) / 100;
      var precioMoney = formatearConPatron(totalP, patP);
      tier.setAttribute('data-tier-precio-money', precioMoney);
      var compMoney = null;
      if (Number.isFinite(compRaw) && compRaw > 0) {
        var patC = patronMoneda(tier.getAttribute('data-tier-comp-money') || tier.getAttribute('data-tier-precio-money'), milesFallback);
        var unitC = base > 0 ? compRaw / base : 0;
        var totalC = Math.round((unitC * n) * 100) / 100;
        compMoney = formatearConPatron(totalC, patC);
        tier.setAttribute('data-tier-comp-money', compMoney);
      }
      tier.setAttribute('data-tier-unidades', String(n));
      // Refresca los nodos VISIBLES de la propia card (now/was) — así el precio de la
      // card sube/baja EN VIVO junto al header/sticky, sin re-render del widget.
      var nowEl = tier.querySelector('.lb-tier__now');
      if (nowEl) nowEl.textContent = precioMoney;
      var wasEl = tier.querySelector('.lb-tier__was');
      if (wasEl) { if (compMoney != null) { wasEl.textContent = compMoney; wasEl.hidden = false; } else { wasEl.hidden = true; } }
      // "Ahorras $X · N% OFF" y "$Y c/u" — se recalculan aquí o el tier abierto los deja
      // mintiendo en cuanto el cliente sube la cantidad (el ahorro y el precio por pieza
      // dependen de N). Mismo patrón de moneda que el resto de la card.
      var saveEl = tier.querySelector('[data-lb-save]');
      if (saveEl) {
        var totalC2 = (Number.isFinite(compRaw) && compRaw > 0 && base > 0) ? Math.round((compRaw / base * n) * 100) / 100 : 0;
        if (totalC2 > totalP) {
          var amtEl = saveEl.querySelector('[data-lb-save-amt]');
          if (amtEl) amtEl.textContent = 'Ahorras ' + formatearConPatron(Math.round((totalC2 - totalP) * 100) / 100, patP);
          var pctEl = saveEl.querySelector('[data-lb-save-pct]');
          if (pctEl) {
            var pct = Math.floor(100 - (totalP / totalC2) * 100);
            if (pct > 0) { pctEl.textContent = pct + '% OFF'; pctEl.hidden = false; } else { pctEl.hidden = true; }
          }
          saveEl.hidden = false;
        } else { saveEl.hidden = true; }
      }
      return { precioMoney: precioMoney, compMoney: compMoney };
    }
    // Ajusta el bloque de unidades del tier a N filas (solo con packsVariantes):
    // clona la última fila y la re-etiqueta / re-nombra la propiedad; o recorta el
    // sobrante. Idempotente. Los selects clonados heredan la selección de la fila base.
    function crecerUnidades(tier, n) {
      if (!packsVariantes) return;
      var block = unitsBlockFor(tier);
      if (!block) return;
      var filas = [].slice.call(block.querySelectorAll('.lb-tier-unit'));
      if (!filas.length) return;
      var singular = filas[0].querySelector('.lb-tier-unit__label');
      var etiquetaBase = singular ? (singular.textContent || 'Unidad').replace(/\s*\d+\s*$/, '').trim() : 'Unidad';
      // Recortar sobrante.
      while (filas.length > n) { var last = filas.pop(); if (last && last.parentNode) last.parentNode.removeChild(last); }
      // Crecer clonando la última fila.
      while (filas.length < n) {
        var plantilla = filas[filas.length - 1];
        var nuevo = plantilla.cloneNode(true);
        filas.push(nuevo);
        block.appendChild(nuevo);
      }
      // Re-etiquetar índices + re-nombrar la propiedad + cablear el nuevo select.
      block.querySelectorAll('.lb-tier-unit').forEach(function (unitEl, i) {
        var idx = i + 1;
        unitEl.setAttribute('data-unit-index', String(idx));
        var lbl = unitEl.querySelector('.lb-tier-unit__label');
        if (lbl) lbl.textContent = etiquetaBase + ' ' + idx;
        var prop = unitEl.querySelector('[data-unit-prop]');
        if (prop) prop.setAttribute('name', 'properties[' + etiquetaBase + ' ' + idx + ']');
        unitEl.querySelectorAll('[data-unit-select]').forEach(function (sel) {
          if (sel.getAttribute('data-lb-unit-wired') === '1') return;
          sel.setAttribute('data-lb-unit-wired', '1');
          sel.addEventListener('change', function () {
            var active = form.querySelector('.lb-tier.is-active');
            if (active) syncUnitProps(active);
            var row = sel.closest ? sel.closest('.lb-tier-unit') : null;
            if (row) { updateUnitThumb(row); mostrarUnidadEnGaleria(row); }
          });
          sel.addEventListener('click', function (ev) { ev.stopPropagation(); });
        });
        updateUnitThumb(unitEl); // filas nuevas/clonadas heredan el thumb correcto
      });
    }

    // Corrección dueño 20-jul (SB-3): el texto de la píldora/CTA v2 ("HOY 2x1: 2
    // Pulseras por $799") era FIJO aunque el cliente eligiera otro pack → confusión
    // (elegía 3 por $999 y el botón seguía diciendo $799). Ahora el texto SIGUE la
    // selección: 1 → "HOY: 1 Pulsera por $599" · 2 → "HOY 2x1: 2 Pulseras por $799"
    // · N≥3 → "HOY: N Pulseras por $<total>". Pluralización simple ES (vocal→+s,
    // consonante→+es). Sin nodos lb2-sticky__t1 en la página → no-op (retrocompat).
    function pluralizarEtiqueta(s) {
      var t = String(s || 'Unidad').trim();
      if (!t) return 'Unidades';
      var last = t.charAt(t.length - 1).toLowerCase();
      return 'aeiouáéíóú'.indexOf(last) >= 0 ? t + 's' : t + 'es';
    }
    // CASO 2 (dueño 28-jul) — memoria del último pack elegido. La hace falta porque
    // el repintado también lo dispara el OTRO lado del puente (al marcar/desmarcar un
    // adicional), que no conoce ni n ni el precio del tier.
    var _tierStickyN = 0;
    var _tierStickyMoney = null;
    // A4 · GATE POR DATO (codSticky.tituloSigueTier). Ausente/false → el texto es
    // EXACTAMENTE el de hoy. true → el botón dice el nombre del pack elegido.
    // Se lee UNA vez al montar: el metafield no cambia en runtime.
    var _stkCfgBB = lbCodSticky();
    var _sigueTier = !!(_stkCfgBB && _stkCfgBB.tituloSigueTier === true);
    // Pinta los DOS botones de la página (adhesivo .lb2-sticky__t1 y píldora
    // .lb-atc--cod-pill) con el mismo contenido HTML.
    function pintarTitulosCOD(html) {
      document.querySelectorAll('.lb2-sticky__t1').forEach(function (el) { el.innerHTML = html; });
      document.querySelectorAll('.lb-atc--cod-pill .lb-atc__main').forEach(function (el) {
        el.innerHTML = '<b>' + html + '</b>';
      });
    }
    function actualizarStickyTier(n, precioMoney) {
      if (precioMoney == null) return;
      _tierStickyN = n;
      _tierStickyMoney = precioMoney;
      var singular = form.getAttribute('data-lb-singular') || 'Unidad';
      var etiqueta = n === 1 ? singular : pluralizarEtiqueta(singular);
      // A4 · con el gate encendido el título sale del tier ACTIVO (el que el
      // cliente acaba de tocar); apagado, `lbTextoPackCOD` devuelve el string de
      // siempre sin mirar el DOM.
      var tierTitulo = null;
      if (_sigueTier) {
        var tierAct0 = form.querySelector('.lb-tier.is-active');
        var nomEl0 = tierAct0 ? tierAct0.querySelector('.lb-tier__name') : null;
        if (nomEl0) tierTitulo = nomEl0.textContent;
      }
      var textoPack = lbTextoPackCOD(n, precioMoney, etiqueta, tierTitulo, _sigueTier);

      // ── CASO 2 · el botón dice el TOTAL REAL del pedido ─────────────────────
      // Sin adicionales marcados: EXACTAMENTE el texto de siempre (cero cambio).
      // Con adicionales: "TU PEDIDO: $1,531.00 MXN" + renglón de detalle
      // "3 Collares + 2 adicionales". Es un bug de CONFIANZA: el cliente marca los
      // extras, ve que el botón no se mueve y concluye que no se agregaron.
      // El formato del importe se deriva del PROPIO string del tier (patronMoneda),
      // no de un patrón hardcodeado → respeta money_format de la tienda.
      var extras = lbExtrasInfo();
      var html;
      // ⚠️ SOLO cuando los adicionales CUESTAN. Dos de las tres landings con este
      // bloque regalan un eBook ($0, marcado por default): ahí el total NO cambia y
      // reescribir el botón perdería el gancho "HOY 2x1: …" a cambio de nada. El
      // problema que reportó el dueño es "marco los extras y el precio no se mueve";
      // si el extra es gratis, el precio efectivamente no se mueve y no hay nada que
      // corregir. Verificado en el harness del Anillo 5 Emperadores (eBook $0).
      if (extras && extras.total > 0) {
        var totalPedido = precioNumerico(precioMoney) + extras.total;
        // milesFallback desde la comparación del tier activo: el precio del pack
        // puede ser < 1000 (nunca se vio su separador de miles) y el total con
        // adicionales sí pasarlo → sin esto saldría "$1531.00". Mismo truco que
        // recomputarAbierto.
        var tierAct = form.querySelector('.lb-tier.is-active') || form.querySelector('.lb-tier');
        var compRef = tierAct ? tierAct.getAttribute('data-tier-comp-money') : null;
        var pat = patronMoneda(precioMoney, compRef ? patronMoneda(compRef).miles : null);
        var totalMoney = formatearConPatron(totalPedido, pat);
        var detalle = n + ' ' + etiqueta + ' + ' + extras.cuantos +
          (extras.cuantos === 1 ? ' adicional' : ' adicionales');
        // CASO 7: "MXN" acompaña al importe y nunca se separa de él (nowrap en CSS).
        html = '<span class="lb2-tot__main">TU PEDIDO: ' + lbEscHtml(totalMoney) +
                 ' <span class="lb2-tot__cur">' + lbEscHtml(lbMonedaTienda()) + '</span></span>' +
               '<span class="lb2-tot__det">' + lbEscHtml(detalle) + '</span>';
      } else {
        html = lbEscHtml(textoPack);
      }
      pintarTitulosCOD(html);
      // CASO 6: este re-pintado borra el título del botón; si la bandera 🇲🇽 viviera
      // ahí se perdería al cambiar de pack. Va en la sublínea (que no se toca), pero
      // re-afirmamos por si acaso — la función es idempotente.
      try { asegurarBanderaCOD(); } catch (e) {}
    }
    // Puente CASO 2: el lado de los adicionales pide el repintado sin saber el pack.
    // Antes de que el cliente toque un tier no hay nada que pintar → no-op (el botón
    // conserva el título del metafield, igual que hoy).
    _lbStickyRepaint = function () {
      if (_tierStickyMoney == null) return;
      actualizarStickyTier(_tierStickyN, _tierStickyMoney);
    };

    function selectTier(tier) {
      var abierto = tierEsAbierto(tier);
      // n del pack: para el tier abierto usa las unidades EFECTIVAS del stepper
      // (data-tier-unidades, sembrado al min); para el resto, data-tier-n.
      var n = abierto ? (Number(tier.getAttribute('data-tier-unidades')) || minDe(tier)) : (Number(tier.getAttribute('data-tier-n')) || 1);
      if (qtyInput) qtyInput.value = n;
      form.querySelectorAll('.lb-tier').forEach(function (t) { t.classList.remove('is-active'); });
      // Al cambiar de tier el stepper se RESETEA a su mínimo (contrato) y se oculta el
      // de cualquier otro tier abierto.
      form.querySelectorAll('.lb-tier[data-tier-abierto="true"]').forEach(function (t) {
        var st = stepperDe(t);
        if (t !== tier) {
          t.setAttribute('data-tier-unidades', String(minDe(t)));
          recomputarAbierto(t, minDe(t));
          if (st) st.hidden = true;
        }
      });
      tier.classList.add('is-active');
      var radio = tier.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      if (abierto) {
        n = minDe(tier);                       // reset a min al (re)seleccionar
        var st = stepperDe(tier);
        if (st) { st.hidden = false; var nEl = st.querySelector('[data-stepper-n]'); if (nEl) nEl.textContent = String(n); }
        recomputarAbierto(tier, n);            // recalcula -money para N=min
        if (qtyInput) qtyInput.value = n;
      }
      // Strings de dinero YA formateados (Liquid, o recalculados por el stepper).
      var precioMoney = tier.getAttribute('data-tier-precio-money');
      var compMoney = tier.getAttribute('data-tier-comp-money'); // ausente si no hay tachado
      // Copia el precio del pack al header y al sticky.
      if (precioMoney != null && priceNow) priceNow.textContent = precioMoney;
      if (precioMoney != null && stickyNow) stickyNow.textContent = precioMoney;
      actualizarStickyTier(n, precioMoney);
      // Comparación: si el tier no tiene tachado, ocultar los nodos "was".
      if (compMoney != null) {
        if (priceWas) { priceWas.textContent = compMoney; priceWas.hidden = false; }
        if (stickyWas) { stickyWas.textContent = compMoney; stickyWas.hidden = false; }
      } else {
        if (priceWas) priceWas.hidden = true;
        if (stickyWas) stickyWas.hidden = true;
      }
      // Variantes por unidad: muestra el bloque del tier activo, oculta el resto,
      // prefilla con la variante actual y habilita/sincroniza sus propiedades.
      if (packsVariantes) {
        form.querySelectorAll('[data-tier-units]').forEach(function (b) { b.hidden = true; });
        if (abierto) crecerUnidades(tier, n); // el bloque debe tener N filas
        prefillUnits(tier);
        var block = unitsBlockFor(tier);
        if (block) block.hidden = false;
        syncUnitProps(tier);
        refreshBlockThumbs(block); // el thumb refleja la selección al (re)abrir el tier
      }
    }

    // Aplica un delta al stepper del tier abierto activo, con clamp [min, cap], y
    // re-pinta precio/comparación + filas de variante. delta = +1 / −1.
    function pasoStepper(tier, delta) {
      if (!tierEsAbierto(tier)) return;
      var st = stepperDe(tier);
      if (!st) return;
      var min = minDe(tier), cap = capDe(tier);
      var actual = Number(tier.getAttribute('data-tier-unidades')) || min;
      var n = Math.max(min, Math.min(cap, actual + delta));
      var nEl = st.querySelector('[data-stepper-n]');
      if (nEl) nEl.textContent = String(n);
      if (qtyInput) qtyInput.value = n;
      var pm = recomputarAbierto(tier, n);
      if (priceNow) priceNow.textContent = pm.precioMoney;
      if (stickyNow) stickyNow.textContent = pm.precioMoney;
      actualizarStickyTier(n, pm.precioMoney);
      if (pm.compMoney != null) {
        if (priceWas) { priceWas.textContent = pm.compMoney; priceWas.hidden = false; }
        if (stickyWas) { stickyWas.textContent = pm.compMoney; stickyWas.hidden = false; }
      }
      if (packsVariantes) {
        crecerUnidades(tier, n);
        prefillUnits(tier);
        syncUnitProps(tier);
      }
    }

    // Reacción a un cambio de variante base (pills). Re-prefilla los tiers cerrados
    // con la nueva selección; el tier abierto conserva ediciones del cliente pero
    // re-sincroniza su propiedad (por si el cliente no había tocado sus selects).
    function onPillChange() {
      if (!packsVariantes) return;
      var active = form.querySelector('.lb-tier.is-active');
      form.querySelectorAll('[data-tier-units]').forEach(function (block) {
        var isActiveBlock = active && unitsBlockFor(active) === block;
        if (!isActiveBlock) block.removeAttribute('data-prefilled'); // se re-prefilla al reabrir
      });
      if (active) { syncUnitProps(active); refreshBlockThumbs(unitsBlockFor(active)); }
    }

    // Cambio en un select de unidad → re-sincroniza la propiedad de su tier activo.
    if (packsVariantes) {
      form.querySelectorAll('[data-unit-select]').forEach(function (sel) {
        // Marca como cableado para que crecerUnidades no re-bindee las filas base.
        sel.setAttribute('data-lb-unit-wired', '1');
        sel.addEventListener('change', function () {
          var active = form.querySelector('.lb-tier.is-active');
          if (active) syncUnitProps(active);
          var row = sel.closest ? sel.closest('.lb-tier-unit') : null;
          if (row) { updateUnitThumb(row); mostrarUnidadEnGaleria(row); }
        });
        // Un click en el select NO debe activar el tier ni burbujear al label.
        sel.addEventListener('click', function (ev) { ev.stopPropagation(); });
      });
    }

    // Semilla del tier abierto: data-tier-unidades = min ANTES del primer selectTier.
    form.querySelectorAll('.lb-tier[data-tier-abierto="true"]').forEach(function (t) {
      if (!t.hasAttribute('data-tier-unidades')) t.setAttribute('data-tier-unidades', String(minDe(t)));
    });

    var tiers = form.querySelectorAll('.lb-tier');
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () { selectTier(tier); });
    });
    // Botones − / + del stepper del tier abierto. stopPropagation → el clic NO
    // activa/re-selecciona el label (que reseteato a min). preventDefault → el label
    // no dispara su acción por defecto.
    form.querySelectorAll('.lb-tier[data-tier-abierto="true"] [data-tier-stepper]').forEach(function (st) {
      var tier = st.closest ? st.closest('.lb-tier') : null;
      var dec = st.querySelector('[data-stepper-dec]');
      var inc = st.querySelector('[data-stepper-inc]');
      if (dec) dec.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); pasoStepper(tier, -1); });
      if (inc) inc.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); pasoStepper(tier, +1); });
    });
    // Selecciona el tier "popular" o el primero al arrancar.
    if (tiers.length) {
      var initial = form.querySelector('.lb-tier[data-tier-popular="true"]') || tiers[0];
      selectTier(initial);
    }
  }

  // ── CASO 1 (dueño 29-jul) · EL BOTÓN "AGREGAR AL CARRITO" MANDA LO ELEGIDO ──
  //   "En las ofertas 2x1, al agregar al carrito no agrega la oferta: solo agrega
  //    un producto y con el valor original de $799."
  //
  //   Raíz: el form del snippet llevaba `name="quantity" value="1"` LITERAL y
  //   copiaba `[data-lb-form] input[name=id]` a ciegas. Dos datos fijos:
  //     · la CANTIDAD → con 1 unidad no hay 2x1 que aplicar. El resolvedor del
  //       carrito (resolverPreciosCarrito, src/cod/router.js) ya sabe cotizar el
  //       tier — sólo hay que darle las N piezas. Agrupa por PRODUCTO, así que
  //       1 dorado + 1 plateado SON las 2 unidades del 2x1.
  //     · la VARIANTE → con `packsVariantes` el widget NO mueve input[name=id]
  //       (la elección real vive en los <select> por unidad y viaja como
  //       properties[…], que sólo el servidor COD sabe resolver). El carrito de
  //       Shopify no sabe: el cliente que eligió "Mujer+gato" recibía la variante
  //       por defecto. En contra entrega eso se paga en la puerta.
  //
  //   Este cableado lee el ESTADO REAL del widget en el momento del submit (sin
  //   estado propio que pueda desincronizarse) y compone UN RENGLÓN POR VARIANTE.
  //   Vivía inline en el snippet Liquid; se subió aquí para que haya UNA sola
  //   implementación y para poder probarla.

  // Tope de piezas por variante. Es el MISMO número que CARRITO_LIMITES.qtyMaxPorLinea
  // (src/cod/router.js) y que el cap del stepper del tier abierto: pedir más de lo
  // que el servidor acepta sólo produce un carrito que no coincide con la landing.
  // Un test de la suite compara los dos literales.
  var LB_CART_QTY_MAX = 10;

  // PURA: unidades EFECTIVAS de un tier YA renderizado. `data-tier-unidades` (lo
  // escribe el stepper del tier abierto) manda sobre `data-tier-n`. Sin tier → 1.
  // Clamp [1, cap] — jamás un NaN ni un 0 en el carrito.
  function lbUnidadesDeTier(tierEl, cap) {
    var tope = Math.trunc(Number(cap));
    if (!Number.isFinite(tope) || tope < 1) tope = LB_CART_QTY_MAX;
    if (!tierEl || typeof tierEl.getAttribute !== 'function') return 1;
    var eff = Math.trunc(Number(tierEl.getAttribute('data-tier-unidades')));
    var base = Math.trunc(Number(tierEl.getAttribute('data-tier-n')));
    var n = (Number.isFinite(eff) && eff > 0) ? eff
          : ((Number.isFinite(base) && base > 0) ? base : 1);
    return Math.max(1, Math.min(tope, n));
  }

  // PURA: lista de ids (UNO POR UNIDAD, en el orden de las filas) → renglones
  // [{id, qty}] agrupados por variante, en orden de 1ª aparición y con la cantidad
  // topada. Es lo que distingue "2 collares dorados" (1 renglón ×2) de "1 dorado +
  // 1 plateado" (2 renglones ×1) — el segundo caso NO cabe en el POST nativo.
  function lbAgruparUnidades(ids, cap) {
    var tope = Math.trunc(Number(cap));
    if (!Number.isFinite(tope) || tope < 1) tope = LB_CART_QTY_MAX;
    var orden = [], cuenta = {};
    var lista = Array.isArray(ids) ? ids : [];
    for (var i = 0; i < lista.length; i++) {
      var id = String(lista[i] == null ? '' : lista[i]).trim();
      if (!id) continue;
      if (!Object.prototype.hasOwnProperty.call(cuenta, id)) { cuenta[id] = 0; orden.push(id); }
      cuenta[id]++;
    }
    return orden.map(function (id) { return { id: id, qty: Math.min(tope, cuenta[id]) }; });
  }

  // PURA: renglones del carrito a partir del ESTADO YA LEÍDO del widget. Toda la
  // decisión de "qué se manda" vive aquí; initCartForm sólo lee el DOM.
  //   unidades  → piezas del tier elegido (lbUnidadesDeTier)
  //   baseId    → variante del input del widget (la de las pills / la por defecto)
  //   porUnidad → id elegido en cada fila de unidad; null en una posición = esa
  //               fila no resolvió (combinación agotada o inexistente) → cae a
  //               baseId, que sí existe, en vez de mandar un /cart/add que rebota.
  //               Menos filas que unidades (tier abierto recién crecido) → se
  //               repite la última, que es de la que el widget clona.
  function lbPlanCarrito(unidades, baseId, porUnidad, cap) {
    var tope = Math.trunc(Number(cap));
    if (!Number.isFinite(tope) || tope < 1) tope = LB_CART_QTY_MAX;
    var n = Math.trunc(Number(unidades));
    if (!Number.isFinite(n) || n < 1) n = 1;
    n = Math.min(tope, n);
    var base = String(baseId == null ? '' : baseId).trim();
    var filas = Array.isArray(porUnidad) ? porUnidad : [];
    var ids = [];
    for (var i = 0; i < n; i++) {
      var v = null;
      if (filas.length) v = (i < filas.length) ? filas[i] : filas[filas.length - 1];
      ids.push(v || base);
    }
    return lbAgruparUnidades(ids, tope);
  }

  function initCartForm() {
    if (lbYaCorrio('cartform')) return; // velocidad 21-oct: temprano o en DCL, nunca dos veces
    var f = document.querySelector('[data-lb-cart-form]');
    if (!f || f.getAttribute('data-lb-cart-wired') === '1') return;
    f.setAttribute('data-lb-cart-wired', '1');

    var widget = document.querySelector('[data-lb-form]');
    var dstId = f.querySelector('[data-lb-cart-id]');
    var dstQty = f.querySelector('[data-lb-cart-qty]');
    var cartUrl = f.getAttribute('data-lb-cart-url') || '/cart';
    var addUrl = f.getAttribute('action') || '/cart/add';

    var variantes = [];
    try {
      var nodoV = document.querySelector('[data-lb-variants]');
      if (nodoV) variantes = JSON.parse(nodoV.textContent || '[]');
    } catch (e) { variantes = []; }
    if (!Array.isArray(variantes)) variantes = [];

    // Variante que corresponde a la selección de UNA fila de unidad (sus <select>).
    // Una combinación AGOTADA no se manda al carrito: mejor la de por defecto (que
    // sí existe) que un /cart/add que rebota.
    function variantDeFila(fila) {
      if (!fila || !variantes.length || typeof fila.querySelectorAll !== 'function') return null;
      var sel = {};
      [].forEach.call(fila.querySelectorAll('[data-unit-select]'), function (s) {
        var n = s.getAttribute('data-option-name');
        if (n && s.value) sel[n] = s.value;
      });
      var names = Object.keys(sel);
      if (!names.length) return null;
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], ok = true;
        for (var j = 0; j < names.length; j++) {
          var idx = ((v && v.optionNames) || []).indexOf(names[j]);
          if (idx < 0 || !v.options || v.options[idx] !== sel[names[j]]) { ok = false; break; }
        }
        if (ok) return (v.available !== false) ? String(v.id) : null;
      }
      return null;
    }

    // Estado REAL → renglones del carrito. Se lee en el submit, no se cachea.
    function planLineas() {
      var tier = widget ? widget.querySelector('.lb-tier.is-active') : null;
      var n;
      if (tier) {
        n = lbUnidadesDeTier(tier, LB_CART_QTY_MAX);
      } else {
        // Sin packs no hay tiers: la cantidad es la del propio widget (initBuyBox
        // la mantiene; sin JS del widget conserva la semilla del Liquid) → 1 pieza
        // a precio normal, exactamente como los productos SIN oferta.
        var qi = widget ? widget.querySelector('input[name="quantity"]') : null;
        var qv = qi ? Math.trunc(Number(qi.value)) : 1;
        n = Math.max(1, Math.min(LB_CART_QTY_MAX, (Number.isFinite(qv) && qv > 0) ? qv : 1));
      }
      var base = widget ? widget.querySelector('input[name="id"]') : null;
      var baseId = (base && base.value) ? String(base.value)
                 : (dstId && dstId.value ? String(dstId.value) : '');
      // Bloque de unidades del tier ACTIVO (selectTier oculta los demás).
      var bloque = widget ? widget.querySelector('.lb-tier-units:not([hidden])') : null;
      var filas = bloque ? [].slice.call(bloque.querySelectorAll('.lb-tier-unit')) : [];
      var porUnidad = filas.map(function (fila) { return variantDeFila(fila); });
      return lbPlanCarrito(n, baseId, porUnidad, LB_CART_QTY_MAX);
    }

    f.addEventListener('submit', function (ev) {
      var lineas = null;
      try { lineas = planLineas(); } catch (e) { lineas = null; }
      if (!lineas || !lineas.length) return; // POST nativo con la semilla del Liquid
      // El form nativo sólo sabe UN renglón. Se le deja el PRIMERO con SU propia
      // cantidad: con una sola variante es el pedido completo y correcto; con
      // varias es la red de seguridad si el fetch falla — carrito incompleto, pero
      // JAMÁS N piezas de la variante equivocada.
      if (dstId) dstId.value = lineas[0].id;
      if (dstQty) dstQty.value = String(lineas[0].qty);
      if (lineas.length === 1 || typeof window.fetch !== 'function') return;

      ev.preventDefault();
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: lineas.map(function (l) { return { id: l.id, quantity: l.qty }; }),
        }),
      }).then(function (r) {
        if (!r || !r.ok) throw new Error('cart/add ' + (r && r.status));
        window.location.href = cartUrl;
      }).catch(function () {
        // .submit() NO vuelve a disparar el evento submit → sin bucle.
        try { f.submit(); } catch (e2) {}
      });
    });
  }

  // ── Countdown a medianoche local ──────────────────────────────────────────
  // Puede haber MÁS DE UN reloj en la página (03-ago: el dueño pidió uno arriba,
  // pegado a las preguntas del buybox, además del de siempre). Esto era un
  // `querySelector` singular: el segundo reloj se habría quedado congelado en
  // 00:00:00 para siempre — un contador parado es peor que no tener contador.
  // Un solo `setInterval` los mueve a todos; nunca uno por reloj.
  //
  // ── R13 (lote D, 05-sep-2026) · EL RELOJ DE MINUTOS DEL TESTEO ──
  // Un testeo se pauta en frío y se decide en una sesión: contar hasta medianoche no
  // aprieta nada, así que su reloj es mm:ss. La parte delicada es el ANCLA.
  //
  // Si el fin se calculara en cada carga (ahora + 15 min), el reloj volvería a 15:00
  // cada vez que el cliente recarga o vuelve atrás desde el carrito: una urgencia que
  // se resetea a la vista del cliente no es urgencia, es una mentira evidente. Por eso
  // el instante final se guarda en sessionStorage y se REUTILIZA mientras dure la
  // sesión de la pestaña. Al llegar a cero se queda en 00:00 (no se reinicia y no se
  // esconde la oferta: la oferta sigue ahí, lo que se acabó es la cuenta).
  //
  // La clave lleva la RUTA y los MINUTOS: dos testeos distintos en la misma sesión no
  // pueden compartir cuenta, y si alguien cambia `duracionMin` el ancla vieja no puede
  // sobrevivir al cambio (mostraría una duración que ya no es la de la landing).
  // sessionStorage y no localStorage: en localStorage la cuenta se acabaría para
  // siempre para ese navegador y el cliente que vuelve mañana vería 00:00 fijo.
  function anclaFinMinutos(min) {
    var ms = Math.max(1, Number(min) || 15) * 60000;
    var clave = 'lb-cd-fin:' + (location && location.pathname ? location.pathname : '/') + ':' + min;
    // Todo el acceso va en try/catch: en modo privado de algunos navegadores el mero
    // hecho de LEER sessionStorage lanza. Sin ancla el reloj sigue funcionando (cuenta
    // desde ahora), que es peor que recordar pero muchísimo mejor que no pintar nada.
    try {
      var guardado = Number(window.sessionStorage.getItem(clave));
      if (guardado && isFinite(guardado) && guardado > 0) return guardado;
    } catch (e) {}
    var fin = Date.now() + ms;
    try { window.sessionStorage.setItem(clave, String(fin)); } catch (e) {}
    return fin;
  }

  function initCountdown() {
    var relojes = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-lb-countdown]'), function (el) {
      var hh = el.querySelector('[data-lb-cd-h]');
      var mm = el.querySelector('[data-lb-cd-m]');
      var ss = el.querySelector('[data-lb-cd-s]');
      var modo = el.getAttribute('data-lb-cd-modo');
      if (modo === 'minutos') {
        // El de minutos NO tiene casilla de horas: exigir `hh` lo dejaría fuera de la
        // lista y clavado en 00:00, que es justo el fallo que este bucle arregló para
        // el segundo reloj el 03-ago.
        if (mm && ss) relojes.push({ modo: 'minutos', mm: mm, ss: ss, fin: anclaFinMinutos(el.getAttribute('data-lb-cd-min')) });
        return;
      }
      if (hh && mm && ss) relojes.push({ modo: 'medianoche', hh: hh, mm: mm, ss: ss });
    });
    if (!relojes.length) return;

    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      var diff = Math.max(0, midnight - now);
      var totH = pad(Math.floor(diff / 3600000));
      var totM = pad(Math.floor((diff % 3600000) / 60000));
      var totS = pad(Math.floor((diff % 60000) / 1000));
      for (var i = 0; i < relojes.length; i++) {
        var r = relojes[i];
        if (r.modo === 'minutos') {
          var resta = Math.max(0, r.fin - Date.now());
          r.mm.textContent = pad(Math.floor(resta / 60000));
          r.ss.textContent = pad(Math.floor((resta % 60000) / 1000));
          continue;
        }
        r.hh.textContent = totH;
        r.mm.textContent = totM;
        r.ss.textContent = totS;
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── Galería swipeable ─────────────────────────────────────────────────────
  //   Track scroll-snap con todas las media. El usuario pasa las fotos con swipe
  //   táctil nativo; dots (móvil) y thumbs (desktop) marcan el slide activo y
  //   permiten saltar a uno. El slide activo se detecta con IntersectionObserver
  //   (fallback a scrollend/scroll con debounce) para no depender de eventos que
  //   no existen en Safari viejo.
  function initGallery() {
    var gallery = document.querySelector('[data-lb-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-lb-gallery-track]');
    if (!track) return;

    var slides = [].slice.call(gallery.querySelectorAll('[data-lb-gallery-slide]'));
    if (!slides.length) return;
    var dots = [].slice.call(gallery.querySelectorAll('[data-lb-gallery-dot]'));
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-lb-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-lb-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-lb-gallery-next]');

    var current = 0;

    function setActive(idx) {
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      current = idx;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= slides.length - 1;
    }

    // Lleva el track al slide idx (swipe suave). Usa scrollLeft por offsetLeft
    // (robusto con gaps/padding; scrollIntoView movería toda la página).
    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      var target = slides[idx];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }

    // Marca activo el slide más visible (detección de swipe táctil).
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
        });
        if (best && best.intersectionRatio >= 0.5) {
          var idx = slides.indexOf(best.target);
          if (idx >= 0) setActive(idx);
        }
      }, { root: track, threshold: [0.5, 0.75] });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      // Fallback sin IntersectionObserver: calcula por scrollLeft.
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
          setActive(idx);
        });
      }, { passive: true });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(Number(dot.getAttribute('data-index')) || 0); });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(Number(thumb.getAttribute('data-index')) || 0); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    setActive(0);

    // CASO 5 · el puente para que la foto GRANDE siga al selector de color (ver
    // _lbGaleriaIrAImagen arriba). Las rutas se calculan UNA vez: los <img> de la
    // galería los pinta Liquid y no cambian en runtime.
    // Se usa goTo (scrollLeft del track), NO scrollIntoView: mover la página bajo
    // los pies del cliente mientras elige en el widget sería peor que no hacer nada.
    var rutasSlides = slides.map(function (s) {
      var im = s.querySelector('img');
      return im ? lbRutaImagen(im.getAttribute('src')) : '';
    });
    _lbGaleriaIrAImagen = function (url) {
      var ruta = lbRutaImagen(url);
      if (!ruta) return false;
      var idx = rutasSlides.indexOf(ruta);
      if (idx < 0) return false;      // esa foto no está en la galería → no se toca nada
      if (idx !== current) goTo(idx);
      return true;
    };

    // ?variant= (27-sep, Collar Mujer + gato / Mini Biblia Plateado): el anuncio
    // enlaza a una variante y el Liquid emite su foto en data-lb-gallery-inicio.
    // Se arranca en ESA diapositiva, SIN animación (el cliente aún no ve nada, no
    // es un salto bajo sus pies). Sin ?variant= el atributo no existe → no-op.
    var inicio = gallery.getAttribute('data-lb-gallery-inicio');
    var idxInicio = inicio ? rutasSlides.indexOf(lbRutaImagen(inicio)) : -1;
    if (idxInicio > 0) {
      var izq = slides[idxInicio].offsetLeft - track.offsetLeft;
      try { track.scrollTo({ left: izq, behavior: 'instant' }); } catch (e) { track.scrollLeft = izq; }
      setActive(idxInicio);
    }
  }

  // ── Carrusel UGC ──────────────────────────────────────────────────────────
  function initCarousels() {
    document.querySelectorAll('[data-lb-carousel]').forEach(function (car) {
      var track = car.querySelector('.lb-carousel__track');
      if (!track) return;
      var prev = car.querySelector('.lb-carousel__btn--prev');
      var next = car.querySelector('.lb-carousel__btn--next');
      function step(dir) { track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  // ── CASO 21 · Carrusel de reseñas DESTACADAS (arriba del rating+título) ────
  //   Gated: sin [data-lb-reviews-carousel] NO hace nada. Con 1 sola slide →
  //   estático (sin dots ni avance; sale early). Con ≥2 → scroll-snap + dots +
  //   AUTO-AVANCE ~5s. El avance se decide por RELOJ (Date.now), no contando
  //   ticks: el throttling de pestañas de fondo congela/ralentiza los timers
  //   (lección countdown 11-jul). NO avanza con document.hidden. Tocar el carrusel
  //   (touchstart/pointerdown) lo PAUSA ~10s. Cero librerías, scoped al contenedor.
  function initReviewsCarousel() {
    var box = document.querySelector('[data-lb-reviews-carousel]');
    if (!box) return;
    var track = box.querySelector('[data-lb-frev-track]');
    if (!track) return;
    var slides = [].slice.call(box.querySelectorAll('[data-lb-frev-slide]'));
    if (slides.length < 2) return;   // 1 sola destacada → estático, nada que animar
    var dots = [].slice.call(box.querySelectorAll('[data-lb-frev-dot]'));

    var current = 0;
    function setActive(idx) {
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      current = idx;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      var target = slides[idx];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }

    // Marca activo el slide más visible (swipe manual del usuario).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
        });
        if (best && best.intersectionRatio >= 0.5) {
          var idx = slides.indexOf(best.target);
          if (idx >= 0) setActive(idx);
        }
      }, { root: track, threshold: [0.5, 0.75] });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          setActive(Math.round(track.scrollLeft / (track.clientWidth || 1)));
        });
      }, { passive: true });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(Number(dot.getAttribute('data-index')) || 0); });
    });

    // ── Auto-avance por RELOJ (Date.now), no por ticks. NO se pausa por su propio
    //   scrollTo (solo touchstart/pointerdown pausan → sin auto-freno). ──
    var INTERVALO = 5000;    // ~5s entre reseñas
    var PAUSA = 10000;       // interacción → pausa ~10s
    var lastAdvance = Date.now();
    var pausedUntil = 0;
    function pausar() { pausedUntil = Date.now() + PAUSA; lastAdvance = Date.now(); }
    box.addEventListener('touchstart', pausar, { passive: true });
    box.addEventListener('pointerdown', pausar, { passive: true });

    setInterval(function () {
      var now = Date.now();
      if (document.hidden) { lastAdvance = now; return; }  // oculto: no avanza, re-basa el reloj
      if (now < pausedUntil) return;                        // pausado por interacción
      if (now - lastAdvance < INTERVALO) return;
      lastAdvance = now;
      goTo((current + 1) % slides.length);
    }, 500);

    setActive(0);
  }

  // ── Sticky ATC móvil ──────────────────────────────────────────────────────
  function initStickyAtc() {
    var bar = document.querySelector('[data-lb-sticky]');
    var buybox = document.querySelector('#lb-buybox');
    if (!bar) return;
    var btn = bar.querySelector('[data-lb-sticky-btn]');
    var form = document.querySelector('[data-lb-form]');
    // Con COD propio, el checkout lo maneja initCod (intercepta este botón por su
    // cuenta). Aquí NO disparamos el submit nativo (el form ya no tiene botón submit).
    var codMode = !!document.querySelector('[data-lb-cod-config]');

    // COD v2: si el config trae codV2 && codSticky, la barra sticky de la PÁGINA pasa
    // a estilo píldora negra borde accent (🚚 + título + subtítulo). El clic sigue
    // abriendo el overlay (lo wirea initCodV2). Sin codSticky → sticky actual intacto.
    if (codMode) {
      var cfg2 = {};
      var cfgN = document.querySelector('[data-lb-cod-config]');
      try { cfg2 = JSON.parse((cfgN && cfgN.textContent) || '{}') || {}; } catch (e) { cfg2 = {}; }
      var st = (cfg2.codV2 === true && cfg2.codSticky && typeof cfg2.codSticky === 'object') ? cfg2.codSticky : null;
      if (st && btn) {
        function escS(s) {
          return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        }
        bar.classList.add('lb2-sticky');
        btn.classList.add('lb2-sticky__btn');
        btn.innerHTML =
          '<span class="lb2-sticky__ico">🚚</span>' +
          '<span class="lb2-sticky__txt">' +
            '<span class="lb2-sticky__t1">' + escS(st.titulo || '') + '</span>' +
            (st.subtitulo ? '<span class="lb2-sticky__t2">' + escS(st.subtitulo) + '</span>' : '') +
          '</span>';
        var info = bar.querySelector('.lb-sticky-atc__info');
        if (info) info.hidden = true;
      }
    }

    if (btn && form && !codMode) {
      btn.addEventListener('click', function () {
        // Reutiliza el submit nativo del form (Releasit lo intercepta).
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
    function onScroll() {
      var show = window.scrollY > 600;
      // Ocúltalo cuando el buy box está en viewport (no estorbar el CTA real).
      if (buybox) {
        var r = buybox.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) show = false;
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Sticky bar del SNIPPET (fix móvil #6) ─────────────────────────────────
  //   El template landing-buda-main trae su propio sticky ([data-lb-sticky]); el
  //   snippet landing-buda-offers-inline NO lo traía → en el piloto no aparecía
  //   barra adhesiva. Este helper monta el sticky PROPIO del snippet
  //   ([data-lb-sticky-offers]): usa un IntersectionObserver sobre el CTA del
  //   widget — cuando el CTA sale del viewport (scroll hacia abajo) aparece la
  //   barra; cuando vuelve a verse, se oculta. El clic abre el overlay (el botón
  //   lleva [data-lb-sticky-btn], ya cableado por initCod/initCodV2).
  //   GUARD: si existe el sticky del theme ([data-lb-sticky]) NO montamos este
  //   (evita barra duplicada); el del theme ya cubre la página.
  function initStickyOffers() {
    if (lbYaCorrio('stickyOffers')) return; // velocidad 21-oct: temprano o en DCL, nunca dos veces
    var bar = document.querySelector('[data-lb-sticky-offers]');
    if (!bar) return;
    // Guard anti-duplicado: el theme landing-buda ya trae su sticky.
    if (document.querySelector('[data-lb-sticky]')) { bar.remove && bar.remove(); return; }
    // El CTA de referencia (el que abre el overlay) debe existir para poder ordenar.
    var cta = document.querySelector('[data-lb-cod-cta]');
    if (!cta) { bar.remove && bar.remove(); return; }

    // Píldora del sticky: reusa las clases lb2-sticky__* si el config es codV2 +
    // codSticky; si no, muestra el CTA genérico. El texto sale de codSticky.
    var cfg = {};
    var cfgN = document.querySelector('[data-lb-cod-config]');
    try { cfg = JSON.parse((cfgN && cfgN.textContent) || '{}') || {}; } catch (e) { cfg = {}; }
    var st = (cfg.codSticky && typeof cfg.codSticky === 'object') ? cfg.codSticky : null;
    function escS(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    var btn = bar.querySelector('[data-lb-sticky-btn]');
    if (btn && st) {
      bar.classList.add('lb2-sticky');
      btn.classList.add('lb2-sticky__btn');
      // A/B del botón (PLAN-V2 §6 · E2): si el Liquid metió el título del brazo B
      // ([data-ab-b], solo con el A/B encendido) se CONSERVA tal cual al reescribir;
      // el CSS decide cuál se ve. Sin A/B no existe → el innerHTML es el de siempre.
      var abB = btn.querySelector('[data-ab-b]');
      var abBHtml = abB ? abB.outerHTML : '';
      btn.innerHTML =
        '<span class="lb2-sticky__ico">🚚</span>' +
        '<span class="lb2-sticky__txt">' + abBHtml +
          '<span class="lb2-sticky__t1">' + escS(st.titulo || lbRotuloCod()) + '</span>' +
          (st.subtitulo ? '<span class="lb2-sticky__t2">' + escS(st.subtitulo) + '</span>' : '') +
        '</span>';
      // 🐛 28-jul (medido EN VIVO en compranovastore.com): esta línea acababa de
      // PISAR el texto que initBuyBox ya había puesto — initBuyBox corre ANTES que
      // initStickyOffers, así que el adhesivo se quedaba para siempre con el título
      // crudo del metafield ("Collar Sagrado Corazón · $799") mientras la píldora de
      // la página sí seguía el pack ("HOY 2x1: 2 Collares por $799"). Dos botones de
      // pago diciendo cosas distintas. Repintar aquí los vuelve a alinear.
      lbRepintarSticky();
    }

    // ── STICKY ADHESIVO POR SCROLL (corrección dueño ronda 6, como Releasit) ──
    // (a) REPARENT a document.body: en Dawn hay ancestros con `transform` (animaciones,
    //     will-change) que rompen `position:fixed` → el sticky quedaba anclado a un
    //     contenedor sin scroll y NUNCA aparecía en el producto real. Colgándolo del
    //     <body> el fixed se ancla al viewport de verdad.
    try { if (bar.parentNode !== document.body) document.body.appendChild(bar); } catch (e) {}
    _lbStickyOffersBar = bar;

    // (b) OCULTO al load; APARECE SOLO cuando el CTA inline se pasó (corrección dueño
    //     14-jul, exacto como Releasit): el adhesivo NO debe verse al inicio ni con
    //     scroll parcial mientras el botón "Agregar a mi pedido" (debajo de los
    //     descuentos) siga visible. Aparece justo cuando ese botón sale por ARRIBA del
    //     viewport (bottom <= 0). Antes había una 2ª pata (scrollY > 200) que lo prendía
    //     temprano → se ELIMINÓ. La aparición/desaparición la pinta CSS vía .is-visible
    //     (translateY+opacity ~200ms). `hidden` se quita YA (el estado inicial
    //     translateY(100%)+opacity:0 lo deja fuera de pantalla) para que la transición
    //     corra al togglear la clase.
    bar.hidden = false;
    var stickyOn = false; // true = el sticky debe verse (el botón inline ya se pasó)
    // A4 · GATE POR DATO (codSticky.siempreVisible). Ausente/false → la regla de
    // hoy, bit a bit (aparece solo cuando el CTA salió por ARRIBA). true → la barra
    // acompaña desde el primer scroll: se ve siempre que el CTA no esté en pantalla
    // (medido: en un móvil de 375px el CTA cae a ~1.400px, dos scrolls sin ningún
    // botón de compra a la vista). La decisión vive en la PURA `lbStickyDebeVerse`.
    var siempreVisible = !!(st && st.siempreVisible === true);
    function altoViewport() {
      return window.innerHeight ||
        (document.documentElement && document.documentElement.clientHeight) || 0;
    }
    function stickyDebeVerse(rect) {
      return lbStickyDebeVerse(rect, altoViewport(), siempreVisible);
    }
    function aplicarSticky() {
      // Overlay v2 abierto → jamás visible (ocultarStickyOffers ya puso display:none,
      // pero además NO marcamos is-visible para que al cerrar no haya flash).
      bar.classList.toggle('is-visible', stickyOn && !_lbStickyOffersOverlayOpen);
    }
    // Re-evaluación síncrona por rect: fuente única de verdad para el scroll listener,
    // el IntersectionObserver Y el recheck al cerrar el overlay (mostrarStickyOffers
    // la invoca — nunca mostrar a ciegas).
    _lbStickyOffersEval = function () {
      try {
        stickyOn = stickyDebeVerse(cta.getBoundingClientRect());
      } catch (e) {}
      aplicarSticky();
    };
    // El IO solo DISPARA la re-evaluación (cruces de la píldora por los bordes); la
    // pata "píldora ABAJO + scrollY>200" cambia SIN evento de intersección → el
    // listener de scroll corre SIEMPRE (ya no es solo fallback), pasivo y barato.
    if (typeof IntersectionObserver === 'function') {
      try {
        var io = new IntersectionObserver(function () { if (_lbStickyOffersEval) _lbStickyOffersEval(); }, { threshold: 0 });
        io.observe(cta);
      } catch (e) {}
    }
    window.addEventListener('scroll', _lbStickyOffersEval, { passive: true });
    _lbStickyOffersEval(); // estado inicial (normalmente oculto: la píldora abajo y scrollY=0)

    // (e) Padding-bottom en el <body> (~90px) para que el sticky no tape el footer /
    //     último contenido de la página. Aditivo al padding actual (no lo pisamos).
    try {
      var b = document.body;
      if (b && b.getAttribute('data-lb-sticky-pad') !== '1') {
        var cur = 0;
        try {
          var cs = window.getComputedStyle ? window.getComputedStyle(b) : null;
          cur = cs ? parseFloat(cs.paddingBottom) || 0 : 0;
        } catch (e) { cur = 0; }
        _lbStickyPadPrev = b.style.paddingBottom || ''; // para deshacerlo (lbRematarArranqueTemprano)
        b.style.paddingBottom = (cur + 90) + 'px';
        b.setAttribute('data-lb-sticky-pad', '1');
      }
    } catch (e) {}

    // (c) Ocultarlo mientras el overlay v2 esté abierto lo maneja initCodV2 vía
    //     ocultarStickyOffers()/mostrarStickyOffers() (hook compartido). (d) El clic
    //     del botón lo cablea initCod/initCodV2 (busca [data-lb-sticky-btn]).
  }

  // ══ A10 · MICRO-ANIMACIONES DE ENTRADA (reveal on scroll) ═════════════════
  //   Fade + 12px de desplazamiento cuando una sección entra a cuadro. Nada más:
  //   sin rebotes ni escalados.
  //
  //   🔒 TRES CANDADOS, en este orden. Este archivo es GLOBAL (las 2 tiendas, ~11
  //   landings vivas, una con campaña corriendo), así que el riesgo real no es que
  //   la animación se vea fea: es dejar una landing en `opacity: 0`, o sea EN
  //   BLANCO. Por eso el CSS solo aplica bajo `html.lb-reveal`, y esa clase se
  //   pone DESPUÉS de tener un IntersectionObserver construido y observando.
  //     1) GATE POR DATO: sin `codSkin.revelarAlScroll === true` no se pone la
  //        clase, no se marca ningún nodo y no se crea el observer. Cero cambio.
  //     2) prefers-reduced-motion: reduce → se sale antes de tocar nada (y además
  //        el CSS entero vive dentro de `@media (prefers-reduced-motion:
  //        no-preference)`, así que ni aunque la clase estuviera puesta).
  //     3) Sin IntersectionObserver, o si el constructor/observe lanza → se sale
  //        (o se revela todo) SIN dejar nada oculto. Más una red por tiempo: si el
  //        observer no llega a correr nunca, a los 1.5 s se revela todo; y dos
  //        barridos (3 s / 8 s) revelan cualquier sección que esté EN PANTALLA sin
  //        revelar. Contenido visible pero transparente no puede sobrevivir.
  //
  //   NUNCA se marca la zona de compra: ni la buy box, ni el bloque de ofertas, ni
  //   nada que contenga el CTA, el form, el carrito o una barra adhesiva. El botón
  //   de pago no se anima jamás.
  var LB_REVEAL_SEL = 'section.lb-section, section.lb-visuales';
  var LB_REVEAL_NUNCA = '#lb-buybox, .lb-buybox, .lb-offers-standalone, .lb-offers-pp';
  var LB_REVEAL_NUNCA_DENTRO = '[data-lb-cod-cta], [data-lb-form], [data-lb-cart-form], [data-lb-sticky], [data-lb-sticky-offers]';

  // PURA (sobre el DOM, sin efectos): ¿esta sección se puede revelar?
  function lbRevelable(el) {
    if (!el || typeof el.querySelector !== 'function') return false;
    try { if (typeof el.matches === 'function' && el.matches(LB_REVEAL_NUNCA)) return false; } catch (e) { return false; }
    try { if (el.querySelector(LB_REVEAL_NUNCA_DENTRO)) return false; } catch (e) { return false; }
    return true;
  }

  // ¿El nodo está (aunque sea en parte) dentro del viewport?
  function lbEnPantalla(el) {
    try {
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || 0;
      return r.bottom > 0 && r.top < (h || 0);
    } catch (e) { return true; } // no medible → tratarlo como visible (revelar)
  }

  function initRevealOnScroll() {
    // (1) GATE POR DATO.
    var cfg = lbCodConfig();
    var skin = (cfg && cfg.codSkin && typeof cfg.codSkin === 'object') ? cfg.codSkin : null;
    if (!skin || skin.revelarAlScroll !== true) return;

    // (2) El usuario pidió menos movimiento → no se anima nada.
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) {}

    // (3) Sin IntersectionObserver no se oculta NADA (la página queda igual que hoy).
    if (typeof IntersectionObserver !== 'function') return;

    var nodos;
    try { nodos = [].slice.call(document.querySelectorAll(LB_REVEAL_SEL)).filter(lbRevelable); }
    catch (e) { return; }
    if (!nodos.length) return;

    function revelarTodo() {
      for (var i = 0; i < nodos.length; i++) {
        try { nodos[i].classList.add('is-revealed'); } catch (e) {}
      }
    }

    var ioVivo = false; // el callback del observer llegó a correr al menos una vez
    var io;
    try {
      io = new IntersectionObserver(function (entries) {
        ioVivo = true;
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          try { entries[i].target.classList.add('is-revealed'); } catch (e) {}
          try { io.unobserve(entries[i].target); } catch (e) {}
        }
      }, { threshold: 0.01, rootMargin: '0px 0px -8% 0px' });
    } catch (e) { return; } // constructor caído → nada marcado, página intacta

    // Recién AQUÍ se marca el DOM y se enciende el CSS: con el observer ya vivo.
    for (var i = 0; i < nodos.length; i++) nodos[i].setAttribute('data-lb-reveal', '');
    try { document.documentElement.classList.add('lb-reveal'); }
    catch (e) { return; } // sin la clase el CSS no aplica → nada quedó oculto
    for (var j = 0; j < nodos.length; j++) {
      try { io.observe(nodos[j]); } catch (e) { revelarTodo(); return; }
    }

    // Red 1 — el observer nunca corrió (navegador raro, polyfill roto): se revela
    // todo y se acabó. El observer dispara en el PRIMER FRAME tras observe()
    // (~16 ms), así que 900 ms es diagnóstico, no carrera. Se eligió corto a
    // propósito: revelar de más solo cuesta la animación; revelar de menos deja
    // la landing en blanco. Ese es el único error que no se puede cometer.
    setTimeout(function () { if (!ioVivo) revelarTodo(); }, 900);
    // Red 2 — barridos: cualquier sección que esté EN PANTALLA y siga sin revelar
    // se revela. No estropea el efecto de lo que aún está más abajo.
    function barrido() {
      for (var k = 0; k < nodos.length; k++) {
        try {
          if (nodos[k].classList.contains('is-revealed')) continue;
          if (lbEnPantalla(nodos[k])) nodos[k].classList.add('is-revealed');
        } catch (e) {}
      }
    }
    setTimeout(barrido, 3000);
    setTimeout(barrido, 8000);
  }

  // ── CASO 6 (dueño 27-jul) · BANDERITA DE MÉXICO EN EL BOTÓN DE PAGO ────────
  //   "En el botón del pago se te olvidó poner la banderita de México."
  //   El texto del botón COD sale del metafield `codSticky` (lo escriben los
  //   generadores) y en varias landings quedó guardado SIN bandera —por eso falta
  //   igual en NovaStore y en Soy Buda MX—. Normalizamos EN EL CLIENTE, que es el
  //   único punto común a las dos tiendas sin tocar metafields ni generadores.
  //
  //   Dónde: al final de la SUBLÍNEA del botón ("Paga al recibir · Envío gratis 🇲🇽"),
  //   que es exactamente el mismo remate que YA usan el CTA final del checkout
  //   (.lb2-cta__l2) y el CTA de la oferta flash (.lb2-flash__yes-l2) → las cuatro
  //   superficies de pago terminan igual en las dos tiendas. La sublínea es además
  //   el único trozo estable: el TÍTULO lo reescribe actualizarStickyTier con el pack
  //   elegido ("HOY 2x1: 2 Pulseras por $799").
  //   Idempotente: si el botón ya trae 🇲🇽 en cualquier parte, no se toca nada.
  var BANDERA_MX = '🇲🇽'; // 🇲🇽
  function asegurarBanderaCOD() {
    if (!lbEsMxn()) return; // 29-oct: la bandera de México sólo en las tiendas que cobran en MXN
    var subs = document.querySelectorAll('[data-lb-cod-cta] .lb-atc__sub, [data-lb-sticky-btn] .lb2-sticky__t2');
    Array.prototype.forEach.call(subs, function (sub) {
      var btn = sub.closest ? sub.closest('button') : null;
      if (btn && String(btn.textContent || '').indexOf(BANDERA_MX) >= 0) return; // ya la tiene
      var t = String(sub.textContent || '').replace(/\s+$/, '');
      if (!t) return;                        // sublínea vacía → no inventamos texto
      sub.textContent = t + ' ' + BANDERA_MX;
    });
  }

  // ── CASO 14 (dueño 27-jul) · MATERIAL + DETALLE DE LAS OFERTAS FLASH ───────
  //   "poner al ladito del nombre en paréntesis el material de los productos… aplica
  //    para todas tanto de Soy Buda como de NovaStore… que pronto deslizar se pueda
  //    ver una pequeña descripción del producto. Eso sí, sin ir a dañar."
  //
  //   Fuente de verdad: data/flash-material-detalle.json (revisado producto por
  //   producto contra la ficha de Shopify y el landing.data, bajo la REGLA DE
  //   MATERIALES HONESTOS del dueño: "Baño de oro 18K" JAMÁS "Oro 18K"; "Cadena en
  //   acero inoxidable" cuando el acero es SOLO la cadena. El cliente COD abre el
  //   paquete antes de pagar: exagerar el material sube el rechazo en la puerta).
  //
  //   Va EMBEBIDO aquí a propósito: la oferta flash se pinta 100% en el cliente desde
  //   el metafield `codPropio.upsellFlash`, y este asset es el ÚNICO archivo que se
  //   despliega a las DOS tiendas. Meterlo en el metafield exigiría tocar generadores
  //   y republicar cada landing (fuera de alcance de este cambio).
  //   Clave = id numérico del producto Shopify (tolera gid completo o id suelto).
  var FLASH_FICHA = {
    '9806346584346': { m: 'Metal con acabado dorado', d: ['Metal con acabado dorado, ligero y resistente', 'Talla ajustable: se adapta a cualquier dedo', 'Las 5 monedas imperiales en un solo aro', 'Símbolo de prosperidad en la tradición china'] }, // ANILLO DE LA FORTUNA DE LOS 5 EMPERADORES
    '10169703334170': { m: 'Cadena en acero inoxidable', d: ['Cadena en acero inoxidable, no se oxida', 'No se oscurece ni pierde el color', 'Dos figuras entrelazadas en un abrazo', 'Regalo con significado para quien más quieres'] }, // Collar Abrazo Infinito
    '10111940231450': { m: '7 piedras naturales', d: ['7 piedras naturales con separadores dorados', 'Ajustable de 15 a 26 cm, unisex', 'Hecha a mano: no hay dos pulseras iguales', 'Los 7 colores de la tradición en tu muñeca'] }, // PULSERA ALINEACIÓN 7 CHAKRAS
    '10005232189722': { m: 'Acrílico ligero', d: ['Acrílico ligero, cómodos todo el día', 'Miden 3.5 x 3.5 cm', 'Colores vibrantes que combinan con todo', 'El colibrí simboliza alegría y renovación'] }, // ALMA DE COLIBRÍ (Aretes)
    '10040073060634': { m: 'Cadena en acero inoxidable', d: ['Cadena en acero inoxidable, no se oxida', '3 motivos: mujer+perro, hombre+perro, mujer+gato', 'Cadena de 45 cm con 5 cm de extensión', 'Un homenaje al vínculo con tu mascota'] }, // Collar Eterno Vínculo
    '9936347758874': { m: 'Obsidiana natural', d: ['Obsidiana 100% natural pulida a mano', 'Hilo ajustable, suave y resistente', 'Diseño unisex para uso diario', 'Piedra muy apreciada en la tradición'] }, // Collar Obsidiana Dorada
    '8551069221061': { m: 'Baño de oro 18K', d: ['Dije de cruz y corona con baño de oro 18K', 'Incluye su cadena a juego', 'Brillo dorado para el uso diario', 'Símbolo de fe en la tradición cristiana'] }, // Collar Cruz y Corona
    '8736958120133': { m: 'Obsidiana con Pixiu dorado', d: ['Cuentas de obsidiana con figura Pixiu dorada', 'Diseño unisex, cómoda para el uso diario', 'El Pixiu simboliza prosperidad en China', 'Un detalle con historia para regalar'] }, // Pulsera Pixiu
    '8772350705861': { m: 'Cinabrio con baño de oro 18K', d: ['Hilo rojo con cinabrio y baño de oro 18K', 'Dije con el símbolo del infinito', 'Un clásico de la tradición para regalar', 'El hilo rojo simboliza el vínculo del destino'] }, // Pulsera de Hilo Rojo
    '8705880064197': { m: 'Acero con baño de oro 18K', d: ['Acero inoxidable chapado, resiste el agua', 'Talla regulable: se ajusta a cualquier mano', 'Incluye ebook gratis de oraciones', 'El sello benedictino, símbolo de fe'] }, // Anillo de San Benito
    '8787276628165': { m: 'Baño de oro 18K', d: ['Cadena dorada con baño de oro 18K', 'Ajustable: se adapta a cualquier muñeca', 'Dije del Sagrado Corazón en rojo', 'Un símbolo de fe que llevas todo el día'] }, // Pulsera Sagrado Corazón
    '8703528206533': { m: 'Metal con páginas reales', d: ['Tapas de metal con páginas reales impresas', 'Acabado sobrio, del tamaño de un llavero', 'Incluye argolla metálica para tus llaves', 'Regalo memorable para bautizos y comuniones'] }, // Mini libro La Santa Biblia
    '8703527649477': { m: 'Acero con baño de oro 18K', d: ['Dije del corazón coronado en baño de oro 18K', 'Incluye su cadena a juego', 'Evita perfumes y agua para cuidar el brillo', 'Símbolo de fe y tradición para regalar'] }, // Collar Sagrado Corazón
    '8448379879621': { m: 'Acero inoxidable premium', d: ['Acero inoxidable: no se oxida ni se pone negro', 'Cadena de 55 cm con 5 cm de extensión', 'Elige dorado (baño oro 18K) o plateado', 'Réplica fiel de la medalla benedictina'] }, // Medalla de San Benito
  };
  // Producto SIN ficha → devuelve null y TODO queda exactamente como hoy (sin
  // paréntesis, sin desplegable): el caso 14 es aditivo, nunca degrada una oferta.
  function fichaFlash(gid) {
    var m = String(gid == null ? '' : gid).match(/(\d+)\s*$/);
    return (m && FLASH_FICHA[m[1]]) || null;
  }
  // El material REAL reemplaza al paréntesis viejo del título guardado: hay títulos
  // en metafields que todavía dicen "(ORO 18K)" y poner el material al lado los
  // DUPLICARÍA (y dejaría vivo un claim deshonesto). Se quita UN solo paréntesis
  // final, y sólo cuando hay ficha que poner en su lugar.
  //
  // 🐛 FIX 27-jul (guardián, visto EN VIVO en 4 landings de NovaStore): anclar el
  // paréntesis a `$` no bastaba. "Pulsera Sagrado Corazón ajustable (Baño de oro 18K) ❤️‍🔥"
  // trae un EMOJI DESPUÉS del paréntesis → no matcheaba → la tarjeta pintaba
  // "…(Baño de oro 18K) ❤️‍🔥 (Baño de oro 18K)", el material DOS VECES y comiéndose
  // una línea del nombre. Ahora se tolera una cola no alfanumérica (emojis, símbolos,
  // signos) y esa cola se CONSERVA: es parte del título que escribió el dueño.
  // Sin property escapes (\p{L}) a propósito: este asset corre en móviles viejos.
  function tituloSinParentesisFinal(t) {
    return String(t == null ? '' : t)
      .replace(/\s*\([^()]*\)\s*([^A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ(]*)$/, ' $1')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // ── A/B DEL BOTÓN + GRUPO DE CONTROL DEL FORMULARIO (PLAN-V2 §6 · E2) ────────
  //   El brazo lo asigna el script inline del snippet offers-inline (bloque
  //   ab-boton:inicio) y lo deja en <html data-ab-boton data-ab-asignado data-ab-exp>.
  //   Aquí solo se LEE lo que se vio en ESTA página (no la cookie) para:
  //     · llevar `ab:{exp, boton, asignado, rol}` a NIVEL RAÍZ de /ordenar (v1 y v2)
  //       y de /parcial → el servidor (src/cod/ab-ledger.js) lo valida, y si no vale
  //       lo ignora (nunca 400). `rol` = Shopify.theme.role: las vistas previas
  //       ('unpublished') se descartan allá.
  //     · llevar `codm:{grupo, asignado}` (grupo de control de cod-mejoras, D3) con la
  //       MISMA regla: solo si cod-mejoras dejó <html data-codm-grupo>.
  //     · mandar la EXPOSICIÓN (POST /ab-vista): 1 vez por visita·producto·día, tras
  //       `load` y en ocioso, text/plain (sin preflight), nunca con el override de QA
  //       (?ab_boton=) ni con agentes de bot.
  //   🔒 Sin <html data-ab-boton> ni data-codm-grupo NADA cambia: los cuerpos salen
  //   byte a byte como antes (ni la clave aparece). Todo en try/catch: el A/B jamás
  //   puede costar un pedido.
  //   Vive DENTRO del bloque que el build de Varelú quita (red + MX): allá no existe.
  var LB_AB_RE_EXP = /^[a-z0-9-]{1,40}$/;
  var LB_AB_RE_DIA = /^\d{4}-\d{2}-\d{2}$/;
  // Crawlers: la MISMA lista estrecha que el servidor (esUaDeBot en src/cod/ab-ledger.js).
  // Nada de /bot/ suelto (Cubot es una marca de teléfonos) ni de FBAN/FBAV (el
  // navegador de Facebook/Instagram ES el cliente).
  var LB_AB_RE_BOT = /\b(?:googlebot|bingbot|yandexbot|duckduckbot|baiduspider|ahrefsbot|semrushbot|applebot|petalbot|bytespider|gptbot|mj12bot|dotbot)\b|crawler|spider|facebookexternalhit|headlesschrome|lighthouse/i;
  function lbAbRolTema() {
    try {
      var t = window.Shopify && window.Shopify.theme;
      return (t && typeof t === 'object' && t.role) ? String(t.role) : null;
    } catch (e) { return null; }
  }
  // Día de México (UTC−6, sin horario de verano): el mismo que usan el script de
  // asignación y el servidor (diaMx) para agregar por día.
  function lbAbDiaMx() {
    return new Date(new Date().getTime() - 216e5).toISOString().slice(0, 10);
  }
  // El brazo que se VIO en esta página → { exp, boton, asignado, rol } o null.
  function lbAbDelPedido() {
    try {
      var h = document.documentElement;
      var boton = h.getAttribute('data-ab-boton');
      if (boton !== 'A' && boton !== 'B') return null;
      var exp = h.getAttribute('data-ab-exp') || '';
      if (!LB_AB_RE_EXP.test(exp)) return null;
      var rol = lbAbRolTema();
      // El override de QA en la tienda PUBLICADA no ensucia el experimento.
      if (h.getAttribute('data-ab-qa') === '1' && rol === 'main') return null;
      var asig = h.getAttribute('data-ab-asignado') || '';
      return { exp: exp, boton: boton, asignado: LB_AB_RE_DIA.test(asig) ? asig : null, rol: rol };
    } catch (e) { return null; }
  }
  // Grupo de control de cod-mejoras (D3) → { grupo, asignado } o null.
  function lbCodmDelPedido() {
    try {
      var h = document.documentElement;
      var g = h.getAttribute('data-codm-grupo');
      if (g !== 'control' && g !== 'mejoras') return null;
      var asig = h.getAttribute('data-codm-asignado') || '';
      return { grupo: g, asignado: LB_AB_RE_DIA.test(asig) ? asig : null };
    } catch (e) { return null; }
  }
  // Añade ab/codm a la RAÍZ del cuerpo (si existen) y devuelve el mismo objeto.
  function lbConMedicion(obj) {
    try {
      if (!obj || typeof obj !== 'object') return obj;
      var ab = lbAbDelPedido();
      if (ab) obj.ab = ab;
      var cm = lbCodmDelPedido();
      if (cm) obj.codm = cm;
    } catch (e) {}
    return obj;
  }
  var _lbAbExpuesto = false;
  function lbAbExposicion(endpoint, productGid) {
    if (_lbAbExpuesto) return;
    try {
      if (!endpoint) return;
      if (document.documentElement.getAttribute('data-ab-qa') === '1') return; // override de QA: nunca
      var ab = lbAbDelPedido();
      if (!ab) return;
      var ua = '';
      try { ua = String((navigator && navigator.userAgent) || ''); } catch (e) {}
      if (LB_AB_RE_BOT.test(ua)) return;
      var mId = String(productGid || '').match(/(\d+)\s*$/);
      var clave = 'lb_ab_vista:' + ab.exp + ':' + (mId ? mId[1] : '-') + ':' + lbAbDiaMx();
      // Una vez por visita (pestaña) · producto · día. Sin sessionStorage NO se manda:
      // contar de más inflaría el denominador; contar de menos es igual en los 2 brazos.
      try {
        if (window.sessionStorage.getItem(clave)) return;
        window.sessionStorage.setItem(clave, '1');
      } catch (e) { return; }
      _lbAbExpuesto = true;
      var cuerpo = JSON.stringify({ ab: ab, productGid: productGid || undefined });
      var url = endpoint + '/ab-vista';
      if (typeof fetch === 'function') {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: cuerpo,
          keepalive: true,
          credentials: 'omit',
        }).catch(function () {});
      } else if (navigator && typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon(url, cuerpo);
      }
    } catch (e) {}
  }
  function lbAbProgramarExposicion(endpoint, productGid) {
    try {
      var ir = function () { lbAbExposicion(endpoint, productGid); };
      var enOcio = function () {
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(ir, { timeout: 4000 });
        else setTimeout(ir, 300);
      };
      if (document.readyState === 'complete') setTimeout(enOcio, 0);
      else window.addEventListener('load', function () { setTimeout(enOcio, 0); });
    } catch (e) {}
  }

  // ── COD PROPIO (checkout contra entrega propio) ───────────────────────────
  //   Se activa SOLO si el theme renderizó el bloque [data-lb-cod-config] (metafield
  //   codPropio:true). Si no existe → esta función retorna al instante y NADA cambia
  //   (el Anillo de San Benito y demás landings siguen con Releasit/carrito nativo).
  //
  //   Flujo: el cliente ya eligió pack + variantes por unidad en el widget. Al pulsar
  //   el CTA (o el sticky) interceptamos → abrimos un overlay propio con: resumen del
  //   pack, formulario (Nombre, Apellido, WhatsApp, Estado▾→Municipio▾→CP▾→Colonia▾ en
  //   cascada vía fetch al endpoint, Dirección, Correo, Nota), honeypot 'website',
  //   [checkbox upsell tick]. Al enviar → [modal OFERTA FLASH con countdown si está
  //   configurada] → POST {endpoint}/ordenar → pantalla de gracias in-place con el
  //   orderName. Beacon de parcial (beforeunload/pagehide) si el WhatsApp está lleno y
  //   la orden no se envió. El SERVIDOR es la verdad: aquí solo mandamos
  //   {productGid, tier(unidades), variantesPorUnidad, upsells, datos, website}.
  // ── COLA DE TOQUES (velocidad MX, CORDI 21-oct-2026) ──────────────────────
  //   El snippet offers-inline trae un <script> INLINE, ANTES del botón, que
  //   instala `window.__lbCola`: si el cliente toca el botón COD antes de que
  //   este archivo lo haya conectado, el toque se GUARDA (y el botón muestra un
  //   indicador) en vez de perderse. Aquí se resuelve:
  //     · lbColaListo(abrir) — el botón ya está conectado: se marca listo y, si
  //       había un toque guardado, se abre el formulario UNA vez (síncrono: entre
  //       "conectar" y "listo" no puede colarse otro clic → jamás doble apertura).
  //     · lbColaSoltar() — no hay formulario que abrir (sin config/endpoint, o
  //       initCod falló): se quita el indicador y el toque se descarta, igual que
  //       hoy (un toque sobre un botón sin COD no hacía nada).
  //   Sin snippet (template v1) no existe `__lbCola` → las dos son no-op.
  function lbColaQuitarMarca(b) {
    if (!b) return;
    try { b.classList.remove('lb-cod-espera'); b.removeAttribute('aria-busy'); } catch (e) {}
  }
  function lbColaListo(abrir) {
    var c = window.__lbCola;
    if (!c || c.listo) return false;
    c.listo = true;
    var b = c.pend;
    c.pend = null;
    if (!b) return false;
    lbColaQuitarMarca(b);
    if (typeof abrir === 'function') { try { abrir(); } catch (e) {} }
    return true;
  }
  function lbColaSoltar() {
    var c = window.__lbCola;
    if (!c || c.listo) return;
    c.listo = true;
    var b = c.pend;
    c.pend = null;
    lbColaQuitarMarca(b);
  }

  // Ejecuta fn() UNA vez en cuanto el pixel de Meta (window.fbq) exista; tope 20 s.
  // Sin pixel en 20 s (bloqueador, harness) → silencio, igual que antes.
  function lbCuandoFbq(fn) {
    var intentos = 0;
    (function mirar() {
      if (typeof window.fbq === 'function') { try { fn(); } catch (e) {} return; }
      if (++intentos > 80) return;
      setTimeout(mirar, 250);
    })();
  }

  // ── COBERTURA (velocidad MX, CORDI 21-oct-2026) ───────────────────────────
  //   PURA. Cabeceras del GET /cobertura. Antes llevaba 'ngrok-skip-browser-warning'
  //   SIEMPRE: una cabecera propia convierte el GET en petición "no simple" y el
  //   navegador manda un OPTIONS (preflight) ANTES de cada nivel de la cascada.
  //   El endpoint ya NO es un túnel ngrok (las 44 landings apuntan al VPS), así que
  //   la cabecera solo se pone si el endpoint SIGUE siendo ngrok (por si alguien
  //   vuelve a configurar uno): ahí el aviso de ngrok-free sí rompería el JSON.
  //   Los POST (/ordenar, /parcial, /flash-vista) NO se tocan: van con
  //   Content-Type application/json y llevan preflight igual.
  function lbHeadersCobertura(endpoint) {
    var h = { 'Accept': 'application/json' };
    if (/ngrok/i.test(String(endpoint || ''))) h['ngrok-skip-browser-warning'] = 'true';
    return h;
  }
  //   PURA. La lista de ESTADOS se pide en cuanto initCod corre (no al abrir). Al
  //   abrir se usa esa respuesta; si vino vacía (red, 429) se pide de nuevo, como
  //   antes. `pre` = la promesa precargada (o null si ya se consumió); `pedir` = fetchNivel.
  function lbEstadosConPrefetch(pre, pedir) {
    if (pre && typeof pre.then === 'function') {
      return pre.then(
        function (ops) { return (ops && ops.length) ? ops : pedir({}); },
        function () { return pedir({}); }
      );
    }
    return pedir({});
  }

  function initCod() {
    if (lbYaCorrio('cod')) return; // velocidad 21-oct: temprano o en DCL, nunca dos veces
    var cfgNode = document.querySelector('[data-lb-cod-config]');
    if (!cfgNode) return; // no COD → comportamiento actual intacto

    var cfg = {};
    try { cfg = JSON.parse(cfgNode.textContent || '{}') || {}; } catch (e) { cfg = {}; }

    // ── SKIN DEL FLASH POR TIENDA (CASO 5 dueño 24-jul: estándar en TODAS las plantillas) ──
    // El skin viaja en el config (flashSkin del metafield) y se aplica como clase en <html>;
    // el CSS del skin vive en landing-buda.css (html.lb2-skin-buda …) → funciona igual en
    // landing-buda, eterno-co, cod-buda y pagepilot. Sin flag → Joya Nocturna intacto.
    if (cfg.flashSkin === 'buda') {
      try { document.documentElement.classList.add('lb2-skin-buda'); } catch (e) {}
    }

    var endpoint = String(cfg.endpoint || '').replace(/\/+$/, ''); // sin barra final
    if (!endpoint) return; // sin endpoint no hay a dónde ordenar → no interceptamos
    // ROBUSTEZ: el router vive en /api/cod. Si el endpoint configurado trae ese path con
    // algo pegado después (p.ej. ".../api/cod/ordenar", error real del 20-jul que dejó
    // los 3 forms SB MX en 404), se RECORTA a la base; si no lo incluye, se agrega — así
    // la cascada y el POST pegan a /api/cod/cobertura|ordenar|parcial sin importar cómo
    // se haya configurado el metafield.
    var mCod = endpoint.match(/^(.*\/api\/cod)(\/.*)?$/);
    endpoint = mCod ? mCod[1] : endpoint + '/api/cod';

    // ── QUE NOS DEMOS CUENTA (21-oct-2026) ───────────────────────────────────
    //   Incidente en Colombia: un formulario se quedó cargando en el iPhone del dueño y a
    //   nginx no llegó nada — esas ventas no dejan rastro. Aviso pequeño al servidor
    //   (sendBeacon a /salud-form, texto plano: sin preflight) al abrir el formulario y si
    //   la lista de ESTADOS no llega (sin ella no se puede pedir). SIN DATOS PERSONALES:
    //   motivo, handle, familia del navegador; la tienda la deduce el servidor del Origin.
    //   Una vez por motivo y por carga de página. Fire-and-forget: no cambia nada en pantalla.
    var lbSaludEnviado = {};
    var lbSaludSes = (function () { var a = 'abcdefghijklmnopqrstuvwxyz0123456789', o = ''; for (var i = 0; i < 12; i++) o += a.charAt(Math.floor(Math.random() * a.length)); return o; })();
    function lbFamiliaNav() {
      var ua = String((navigator && navigator.userAgent) || '');
      var ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && Number(navigator.maxTouchPoints) > 1);
      if (ios) {
        if (/FBAN|FBAV|Instagram/.test(ua)) return 'iphone-app';
        if (/CriOS/.test(ua)) return 'iphone-chrome';
        if (/FxiOS/.test(ua)) return 'iphone-firefox';
        if (/EdgiOS/.test(ua)) return 'iphone-edge';
        return 'iphone-safari';
      }
      if (/Android/.test(ua)) {
        if (/FBAN|FBAV|Instagram/.test(ua) || /; wv\)/.test(ua)) return 'android-app';
        if (/SamsungBrowser/.test(ua)) return 'android-samsung';
        if (/Chrome/.test(ua)) return 'android-chrome';
        return 'android-otro';
      }
      if (/Edg\//.test(ua)) return 'pc-edge';
      if (/Firefox\//.test(ua)) return 'pc-firefox';
      if (/Chrome\//.test(ua)) return 'pc-chrome';
      if (/Safari\//.test(ua)) return 'pc-safari';
      return 'otro';
    }
    function lbSalud(motivo) {
      if (lbSaludEnviado[motivo]) return;
      lbSaludEnviado[motivo] = true;
      try {
        var m = String(location.pathname || '').match(/\/products\/([^\/?#]+)/);
        var cuerpo = JSON.stringify({
          v: 1, pais: 'mx', motivo: String(motivo), handle: m ? decodeURIComponent(m[1]).slice(0, 100) : '',
          nav: lbFamiliaNav(), pantalla: 'landing', ses: lbSaludSes
        });
        var url = endpoint + '/salud-form';
        if (navigator.sendBeacon && navigator.sendBeacon(url, cuerpo)) return;
        fetch(url, { method: 'POST', body: cuerpo, keepalive: true }).catch(function () {});
      } catch (e) { /* una métrica jamás rompe el formulario */ }
    }

    // ── EL ENVÍO DEL PEDIDO (CORDI 22-oct-2026, aprobado por el dueño) ──────────
    //   1) TIEMPO LÍMITE. Si la conexión se cuelga al tocar «Finaliza tu compra», antes el
    //      botón quedaba en «Enviando…» para siempre y la venta se perdía en silencio. A los
    //      25 s sin respuesta se ABORTA la espera, el botón vuelve y se dice
    //      «No recibimos respuesta. Toca para intentar de nuevo».
    //      🔒 NO DUPLICA PEDIDOS (comprobado en src/cod/router.js, paso 5b): /ordenar
    //      reconoce el pedido repetido por su contenido — clave = WhatsApp + producto +
    //      escalón (+ unidades del tier abierto), src/cod/idempotencia.js, reservada ANTES
    //      de crear la orden en Shopify, ventana de 10 min. Un 2.º envío del MISMO pedido
    //      recibe la MISMA orden (`duplicado:true`) o un 429 «Estamos registrando tu pedido»
    //      si la primera aún se está creando. 🔒 NUNCA se reintenta solo: toca el cliente.
    //      ⚠️ Límite declarado: pasados 10 min de un envío que sí llegó, volver a tocar
    //      crearía otro pedido (igual que recargar la página y reenviar, como hasta hoy).
    //   2) TEXTO HONESTO. Un 5xx, un 502 de nginx (HTML, sin JSON) o la red caída decían
    //      «Revisa los datos e intenta de nuevo»: el cliente revisaba datos que estaban bien.
    //      Ahora: «No pudimos enviar tu pedido, intenta de nuevo». «Revisa los datos» queda
    //      sólo para un rechazo de DATOS de verdad (4xx con su motivo); si el servidor trae
    //      su propia frase (`error`), se enseña esa, como siempre.
    //   3) AVISO SIN DATOS PERSONALES: `envio_ok`, `envio_colgado`, `envio_fallido:<código>`.
    //   `window.__LB_PLAZO_ENVIO_MS` existe SÓLO para las pruebas (acorta la espera).
    var LB_PLAZO_ENVIO_MS = (function () {
      var n = Number(window.__LB_PLAZO_ENVIO_MS);
      return (isFinite(n) && n >= 100 && n <= 120000) ? n : 25000;
    })();
    var LB_TXT_COLGADO = 'No recibimos respuesta. Toca para intentar de nuevo.';
    var LB_TXT_FALLO = 'No pudimos enviar tu pedido, intenta de nuevo.';
    var LB_TXT_DATOS = 'No pudimos crear tu pedido. Revisa los datos e intenta de nuevo.';
    // Lista CERRADA de códigos (la misma que acepta salud-form.js en el servidor).
    var LB_ESTADOS_ENVIO = { 400: 1, 403: 1, 404: 1, 409: 1, 429: 1, 500: 1, 502: 1, 503: 1, 504: 1 };
    function lbCodigoEnvio(status) {
      var s = Math.floor(Number(status));
      if (!isFinite(s) || s <= 0) return 'red';
      if (LB_ESTADOS_ENVIO[s]) return String(s);
      if (s >= 500 && s <= 599) return '5xx';
      if (s >= 400 && s <= 499) return '4xx';
      return 'otro';
    }
    // Qué se le dice al cliente cuando el servidor contestó pero el pedido no salió.
    function lbTextoFallo(status, j) {
      var s = Number(status) || 0;
      if (s >= 500 || s < 400) return LB_TXT_FALLO;             // el servidor falló (o no hubo JSON)
      if (j && j.error) return String(j.error);                 // su propia frase, para el cliente
      if (j && j.motivo) return LB_TXT_DATOS;                   // un rechazo de datos sin frase
      return LB_TXT_FALLO;                                      // 4xx sin explicación (p. ej. nginx)
    }
    // POST con tiempo límite: aborta la conexión colgada y rechaza con `plazo`. Nunca
    // reintenta: quien llama decide qué ve el cliente.
    function lbEnviarConPlazo(url, init) {
      var ctrl = null;
      try { ctrl = (typeof AbortController === 'function') ? new AbortController() : null; } catch (e) { ctrl = null; }
      if (ctrl) init.signal = ctrl.signal;
      var timer = null;
      var limite = new Promise(function (_ok, rechazar) {
        timer = setTimeout(function () {
          timer = null;
          try { if (ctrl) ctrl.abort(); } catch (e) {}
          var err = new Error('plazo_vencido');
          err.plazo = true;
          rechazar(err);
        }, LB_PLAZO_ENVIO_MS);
      });
      var viaje = fetch(url, init).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; });
      });
      return Promise.race([viaje, limite]).then(
        function (v) { if (timer) { clearTimeout(timer); timer = null; } return v; },
        function (e) { if (timer) { clearTimeout(timer); timer = null; } throw e; }
      );
    }

    // ── ERRORES DE JAVASCRIPT DE NUESTROS SCRIPTS (22-oct-2026) ────────────────
    //   Sólo los que vienen de estos cinco archivos; viaja SÓLO el nombre del archivo
    //   (`js_error:<archivo>`), nunca el mensaje ni la pila. Una vez por archivo y por
    //   página, 5 como mucho por sesión del navegador. Un solo oyente por página
    //   (`__sbErroresJs`): si Colombia (cod-co.js) ya lo puso, no se cuenta dos veces.
    var LB_JS_NUESTRO = /\/(cod-co|meta-co|puente-landing-co|landing-buda|cod-mejoras)\.js\b/;
    var lbJsAvisosMem = 0;
    function lbArchivoNuestro(txt) {
      var m = String(txt || '').match(LB_JS_NUESTRO);
      return m ? m[1] + '.js' : '';
    }
    function lbAvisarErrorJs(archivo) {
      if (!archivo) return;
      var motivo = 'js_error:' + archivo;
      if (lbSaludEnviado[motivo]) return;
      var n = lbJsAvisosMem;
      try { n = Number(window.sessionStorage.getItem('sb-js-err')) || 0; } catch (e) {}
      if (n >= 5) return;
      try { window.sessionStorage.setItem('sb-js-err', String(n + 1)); } catch (e) {}
      lbJsAvisosMem = n + 1;
      lbSalud(motivo);
    }
    try {
      if (!window.__sbErroresJs) {
        window.__sbErroresJs = 'mx';
        window.addEventListener('error', function (ev) {
          try { lbAvisarErrorJs(lbArchivoNuestro(ev && ev.filename) || lbArchivoNuestro(ev && ev.error && ev.error.stack)); } catch (e) {}
        });
        window.addEventListener('unhandledrejection', function (ev) {
          try { var r = ev && ev.reason; lbAvisarErrorJs(lbArchivoNuestro(r && r.stack)); } catch (e) {}
        });
      }
    } catch (e) { /* sin oyente: el formulario sigue igual */ }

    var form = document.querySelector('[data-lb-form]');
    if (!form) return;

    // ── VELOCIDAD (CORDI 21-oct-2026) · los ESTADOS se piden YA ──────────────
    //   Antes el GET de estados salía al ABRIR el formulario: el cliente veía el
    //   <select> vacío ~1 s (preflight + ida y vuelta al VPS). Ahora sale en cuanto
    //   initCod corre (con el arranque temprano, apenas se parsea el botón) y
    //   cargarEstados/cargarEstados2 usan esa respuesta. Se consume UNA vez: si vino
    //   vacía (red, 429) se pide de nuevo al abrir, igual que antes.
    //   fetchNivel es una declaración de función de este mismo closure (hoisting) y
    //   `endpoint` ya está normalizado arriba.
    var estadosPrefetch = null;
    try { estadosPrefetch = fetchNivel({}); } catch (e) { estadosPrefetch = null; }
    function tomarEstadosPrefetch() { var p = estadosPrefetch; estadosPrefetch = null; return p; }

    // ── LOTE 2 · CASO 8 (dueño 28-jul) · FUERA LOS SELECTORES NATIVOS DUPLICADOS ──
    //   "veo aquí que se muestran cantidades, motivo, puede que lo elijan aquí en la
    //    oferta del día."
    //   En soybuda.mx/products/collar-eterno-vinculo el tema de Shopify pinta ARRIBA
    //   un "Motivo" y una "Cantidad" que el cliente ya vuelve a elegir abajo, dentro
    //   de la Oferta del Día (Collar 1 / Collar 2 con su propio selector por unidad, y
    //   la cantidad = el pack elegido). Dos controles para lo mismo = el cliente elige
    //   arriba y su elección no viaja: es un fallo de confianza justo antes de pagar.
    //
    //   MISMO CONTRATO que ya apaga el botón de pago nativo (codV2 == true, hoy en
    //   snippets/landing-buda-offers-inline.liquid ~36-47). Aquí sólo se marca el
    //   <html>; el ocultamiento vive en landing-buda.css, con el MISMO scope
    //   conservador (product-info / .product__info-container) → no toca carrito,
    //   drawer ni checkout.
    //
    //   🔒 NUNCA se oculta un control sin su reemplazo (regla que se auto-verifica en
    //   el DOM, no una suposición):
    //     · el "Motivo" nativo se apaga sólo si el widget de ofertas trae su propio
    //       selector por unidad (.lb-tier-unit__select) — si un día no lo trajera, el
    //       nativo se queda y el cliente puede elegir igual;
    //     · la "Cantidad" nativa se apaga sólo si hay tiers (la cantidad ES el pack).
    //   Escape del contrato: codConfig.selectoresNativos === 'mostrar' lo desactiva
    //   todo (lo necesitará quien devuelva el botón "Agregar al carrito" del CASO 2:
    //   ese camino sí necesita los controles nativos).
    try {
      var selNat = String(cfg.selectoresNativos || '').toLowerCase();
      if (cfg.codV2 === true && selNat !== 'mostrar') {
        var hayTiers = !!document.querySelector('.lb-tier[data-tier-n], [data-tier-n]');
        var hayUnidad = !!document.querySelector('.lb-tier-unit__select, [data-tier-units]');
        var htmlEl = document.documentElement;
        if (hayTiers && hayUnidad) htmlEl.classList.add('lb-nativo-variante-off');
        if (hayTiers) htmlEl.classList.add('lb-nativo-cantidad-off');
      }
    } catch (e) {}

    // ── FASE C (26-jul): ?oferta=pack en la URL → preselecciona el tier del Pack
    // Colección. Marca dura: data-tier-items="true" (emitida por el snippet
    // offers-inline); fallback: el nombre del tier contiene "pack" (páginas cuyo
    // template aún no emite el attr, p.ej. landing-buda-main). El click programático
    // dispara el selectTier de initBuyBox (que corre ANTES en ready()) → precio,
    // sticky y radio quedan sincronizados como si el cliente hubiera tocado el tier.
    try {
      if (/[?&]oferta=pack(?:&|$)/i.test(String(location.search || ''))) {
        var tierPack = form.querySelector('.lb-tier[data-tier-items="true"]');
        if (!tierPack) {
          form.querySelectorAll('.lb-tier').forEach(function (tEl) {
            if (tierPack) return;
            var nm = tEl.querySelector('.lb-tier__name');
            if (nm && /pack/i.test(nm.textContent || '')) tierPack = tEl;
          });
        }
        if (tierPack && !tierPack.classList.contains('is-active')) {
          try { tierPack.click(); } catch (e) {}
        }
      }
    } catch (e) {}

    // DEFENSIVO: con COD propio, ningún botón de Releasit (app-embed que se auto-inyecta)
    // debe quedar visible — pintaría un checkout paralelo que ignora nuestro overlay.
    // El gate real es el <button type=button> del Liquid; esto solo oculta residuos.
    lbOcultarRestosReleasit(); // velocidad 21-oct: la lógica de siempre, ahora reutilizable

    // PATH v1 (codV2 !== true): el overlay viejo solo sabe pintar UN tick. Con el
    // contrato v2 (upsellTick = ARRAY, FASE B 26-jul) tomamos el PRIMERO en vez de
    // dejarlo caer en silencio (un array pasa `typeof === 'object'` pero no tiene
    // `.titulo` → antes desaparecía sin rastro). El router acepta `upsells.tick`
    // legacy como voto del índice 0 → coherente extremo a extremo.
    var upsellTick = Array.isArray(cfg.upsellTick)
      ? (cfg.upsellTick[0] && typeof cfg.upsellTick[0] === 'object' ? cfg.upsellTick[0] : null)
      : (cfg.upsellTick && typeof cfg.upsellTick === 'object' ? cfg.upsellTick : null);
    var upsellFlash = cfg.upsellFlash && typeof cfg.upsellFlash === 'object' ? cfg.upsellFlash : null;
    // tienda (dominio permanente de la tienda): SOLO se usa en el beacon de /parcial.
    // El server NO la exige en /ordenar (la deriva del Origin) → no viaja en el payload de la orden.
    var tienda = String(cfg.tienda || '').trim();

    // productGid del <script data-lb-product-gid> (el theme lo emite bajo el gate codPropio).
    // El server EXIGE gid://shopify/Product/NNN en /ordenar → es load-bearing.
    var productGid = '';
    var gidNode = document.querySelector('[data-lb-product-gid]');
    if (gidNode) {
      var gidRaw = (gidNode.textContent || '').trim();
      // El nodo lo emite Liquid con `| json` → viene entre comillas ("gid://…"). Lo parseamos.
      try { var gidParsed = JSON.parse(gidRaw); if (typeof gidParsed === 'string') gidRaw = gidParsed; } catch (e) {}
      productGid = gidRaw;
    }

    // Título del producto (para el resumen "productos" del beacon parcial).
    var productoTitulo = String(cfg.productoTitulo || '').trim();

    // A/B del botón (PLAN-V2 §6 · E2): exposición tras `load`, en ocioso. No-op sin
    // <html data-ab-boton> (A/B apagado) y con el override de QA.
    lbAbProgramarExposicion(endpoint, productGid);

    // ── DECISIÓN v1 / v2 ──────────────────────────────────────────────────────
    // PRIMERA decisión del overlay. Si cfg.codV2 !== true → path v1 EXACTO (todo lo
    // de abajo, bit a bit como hoy). Si === true → overlay nuevo (clases lb2-*) que
    // replica la app Releasit, y RETORNAMOS antes del código v1 (nada de v1 corre).
    var v2 = cfg.codV2 === true;
    if (v2) { initCodV2(); return; }

    // `precioNumerico` (string de dinero formateado → número) vive ahora en el scope
    // de MÓDULO (arriba, junto al puente del CASO 2): initBuyBox también la necesita
    // para sumar los adicionales al botón. Aquí se resuelve por cadena de scopes.

    // ── Lectura del pack/variantes elegidos (DOM en vivo, al momento de abrir) ──
    // Devuelve { unidades, precioMoney, variantesPorUnidad:[{optionValues:[{optionName,name}]}] }.
    function leerSeleccion() {
      var activeTier = form.querySelector('.lb-tier.is-active') || form.querySelector('.lb-tier');
      // TIER ABIERTO: las unidades EFECTIVAS son las del stepper (data-tier-unidades),
      // no el data-tier-n base (que es el mínimo). El resto de tiers: data-tier-n.
      var baseN = activeTier ? (Number(activeTier.getAttribute('data-tier-n')) || 1) : 1;
      var unidades = (activeTier && activeTier.hasAttribute('data-tier-unidades'))
        ? (Number(activeTier.getAttribute('data-tier-unidades')) || baseN) : baseN;
      // n del PACK (metafield): el server elige el tier por este `n` (NO por unidades)
      // y escala el precio × unidades. Para el tier abierto n = data-tier-n (=3).
      var packN = baseN;
      // ¿el tier activo es ABIERTO? (stepper − N +). Lo mandamos al server para que su
      // clave de idempotencia solo diverja de n cuando REALMENTE es abierto (un tier
      // cerrado con unidades manipuladas debe caer en la clave histórica = n).
      var abierto = !!(activeTier && activeTier.getAttribute('data-tier-abierto') === 'true');
      var precioMoney = activeTier ? activeTier.getAttribute('data-tier-precio-money') : null;

      var variantesPorUnidad = [];
      // Bloque de unidades del tier activo (FEATURE A). Si existe, una fila por unidad.
      var unitsBlock = null;
      if (activeTier) {
        var el = activeTier.nextElementSibling;
        while (el) {
          if (el.hasAttribute && el.hasAttribute('data-tier-units')) { unitsBlock = el; break; }
          if (el.classList && el.classList.contains('lb-tier')) break;
          el = el.nextElementSibling;
        }
      }

      if (unitsBlock) {
        unitsBlock.querySelectorAll('.lb-tier-unit').forEach(function (unitEl) {
          var optionValues = [];
          unitEl.querySelectorAll('[data-unit-select]').forEach(function (sel) {
            var name = sel.getAttribute('data-option-name') || '';
            var val = sel.value || '';
            if (name || val) optionValues.push({ optionName: name, name: val });
          });
          variantesPorUnidad.push({ optionValues: optionValues });
        });
      } else {
        // Sin variantes por unidad: pack = variante base × unidades. Leemos la variante
        // base de las pills activas (o del input id). Repetimos la misma unidad N veces.
        var base = [];
        form.querySelectorAll('.lb-pill.is-active').forEach(function (pill) {
          base.push({
            optionName: pill.getAttribute('data-option-name') || '',
            name: pill.getAttribute('data-option-value') || '',
          });
        });
        for (var i = 0; i < unidades; i++) variantesPorUnidad.push({ optionValues: base.slice() });
      }

      return { n: packN, unidades: unidades, abierto: abierto, precioMoney: precioMoney, variantesPorUnidad: variantesPorUnidad };
    }

    // Resumen legible del pack para el overlay ("Pack de 6 · S / NEGRO, M / NEGRO…").
    function resumenPack(sel) {
      var lineas = sel.variantesPorUnidad.map(function (u, i) {
        var vals = (u.optionValues || []).map(function (ov) { return ov.name; }).filter(Boolean);
        return (i + 1) + '. ' + (vals.length ? vals.join(' / ') : '—');
      });
      return lineas;
    }

    // ── Construcción del overlay (una sola vez, lazy) ─────────────────────────
    var overlay = null;
    var els = {}; // referencias a nodos internos
    var currentSel = null;
    var enviado = false;

    // Escapa TODO texto dinámico que se inyecte por innerHTML (nombres de pack,
    // orderName, producto, colonias/municipios del catálogo, config de upsells).
    // Sin esto, un valor con < > & " ' rompería el HTML o abriría un XSS. `esc` es un
    // alias histórico usado en todo el archivo — ambos apuntan a la MISMA función real.
    function escapaHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
    function esc(s) { return escapaHtml(s); }

    function buildOverlay() {
      if (overlay) return overlay;
      overlay = document.createElement('div');
      overlay.className = 'lb-cod-overlay';
      overlay.setAttribute('data-lb-cod-overlay', '');
      overlay.hidden = true;

      // Estructura: backdrop + panel (resumen + form + gracias). El modal flash es
      // un nodo hermano dentro del overlay (se muestra por encima del panel).
      overlay.innerHTML =
        '<div class="lb-cod-backdrop" data-lb-cod-close></div>' +
        '<div class="lb-cod-panel" role="dialog" aria-modal="true" aria-label="Finalizar compra">' +
          '<button type="button" class="lb-cod-x" data-lb-cod-close aria-label="Cerrar">×</button>' +
          '<div class="lb-cod-body" data-lb-cod-formwrap>' +
            '<div class="lb-cod-summary" data-lb-cod-summary></div>' +
            '<form class="lb-cod-form" data-lb-cod-form novalidate>' +
              '<div class="lb-cod-row2">' +
                '<label class="lb-cod-field"><span>Nombre</span><input type="text" name="nombre" autocomplete="given-name" required></label>' +
                '<label class="lb-cod-field"><span>Apellido</span><input type="text" name="apellido" autocomplete="family-name" required></label>' +
              '</div>' +
              '<label class="lb-cod-field"><span>WhatsApp (10 dígitos)</span><input type="tel" name="whatsapp" inputmode="numeric" maxlength="10" autocomplete="tel" required></label>' +
              '<div class="lb-cod-row2">' +
                '<label class="lb-cod-field"><span>Estado</span><select name="estado" data-lb-cod-estado required><option value="">Selecciona…</option></select></label>' +
                '<label class="lb-cod-field"><span>Municipio / Alcaldía</span><select name="municipio" data-lb-cod-municipio required disabled><option value="">—</option></select></label>' +
              '</div>' +
              '<div class="lb-cod-row2">' +
                '<label class="lb-cod-field"><span>Código postal</span><select name="cp" data-lb-cod-cp required disabled><option value="">—</option></select></label>' +
                '<label class="lb-cod-field"><span>Colonia</span><select name="colonia" data-lb-cod-colonia disabled><option value="">—</option></select></label>' +
              '</div>' +
              '<label class="lb-cod-field"><span>Dirección (calle y número)</span><input type="text" name="direccion" autocomplete="street-address" required></label>' +
              '<label class="lb-cod-field"><span>Correo electrónico</span><input type="email" name="email" autocomplete="email"></label>' +
              '<label class="lb-cod-field"><span>Nota para el repartidor (opcional)</span><textarea name="nota" rows="2"></textarea></label>' +
              // Honeypot: oculto a humanos, tentador para bots. Si viene lleno → el
              // server responde 200 falso sin crear nada (defensa anti-spam).
              '<div class="lb-cod-hp" aria-hidden="true"><label>No llenar<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
              '<div class="lb-cod-upsell" data-lb-cod-upsell hidden></div>' +
              '<div class="lb-cod-error" data-lb-cod-error hidden></div>' +
              '<button type="submit" class="lb-atc lb-cod-submit" data-lb-cod-submit>¡FINALIZA TU COMPRA! · Paga al recibir · Envío gratis</button>' +
            '</form>' +
          '</div>' +
          '<div class="lb-cod-thanks" data-lb-cod-thanks hidden></div>' +
          '<div class="lb-cod-flash" data-lb-cod-flash hidden></div>' +
        '</div>';

      document.body.appendChild(overlay);

      // Referencias
      els.panel = overlay.querySelector('.lb-cod-panel');
      els.summary = overlay.querySelector('[data-lb-cod-summary]');
      els.form = overlay.querySelector('[data-lb-cod-form]');
      els.formwrap = overlay.querySelector('[data-lb-cod-formwrap]');
      els.estado = overlay.querySelector('[data-lb-cod-estado]');
      els.municipio = overlay.querySelector('[data-lb-cod-municipio]');
      els.cp = overlay.querySelector('[data-lb-cod-cp]');
      els.colonia = overlay.querySelector('[data-lb-cod-colonia]');
      els.upsellBox = overlay.querySelector('[data-lb-cod-upsell]');
      els.error = overlay.querySelector('[data-lb-cod-error]');
      els.submit = overlay.querySelector('[data-lb-cod-submit]');
      els.thanks = overlay.querySelector('[data-lb-cod-thanks]');
      els.flash = overlay.querySelector('[data-lb-cod-flash]');

      // Cerrar (X, backdrop)
      overlay.querySelectorAll('[data-lb-cod-close]').forEach(function (c) {
        c.addEventListener('click', closeOverlay);
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !overlay.hidden) closeOverlay();
      });

      // Upsell tick (checkbox dentro del form)
      if (upsellTick && upsellTick.titulo) {
        var precioTick = Number(upsellTick.precio || 0);
        var precioTxt = precioTick > 0 ? ('+$' + precioTick.toFixed(2)) : 'GRATIS';
        var checked = upsellTick.marcadoDefault === true ? ' checked' : '';
        els.upsellBox.hidden = false;
        els.upsellBox.innerHTML =
          '<label class="lb-cod-tick">' +
            '<input type="checkbox" data-lb-cod-tick' + checked + '>' +
            '<span class="lb-cod-tick__body">' +
              '<span class="lb-cod-tick__title">' + esc(upsellTick.titulo) + ' <b>' + precioTxt + '</b></span>' +
              (upsellTick.texto ? '<span class="lb-cod-tick__desc">' + esc(upsellTick.texto) + '</span>' : '') +
            '</span>' +
          '</label>';
      }

      // Cascada Estado → Municipio → CP → Colonia (fetch por nivel).
      wireCascada();

      // Submit del form COD
      els.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        onSubmit();
      });

      return overlay;
    }

    // ── Fetch helper (GET nivel de cascada). Devuelve [] ante error/timeout. ──
    // ROBUSTEZ (15-jul): el endpoint vive en un túnel ngrok-free que puede tardar en un
    // cold-start o caerse un instante → antes fetchNivel devolvía [] EN SILENCIO y el
    // <select> de municipio/CP quedaba vacío, y se veía como "la cascada no funciona".
    // Ahora: timeout de 8s (AbortController) + UN reintento automático tras 700ms ante
    // cualquier fallo (red/timeout/no-2xx). Se auto-sana el hipo transitorio del túnel.
    function fetchNivel(params, _retry) {
      var qs = Object.keys(params).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
      }).join('&');
      // 'ngrok-skip-browser-warning': el túnel ngrok-free inyecta una página de aviso a
      // las peticiones de navegador; este header la salta y deja pasar el JSON.
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var to = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 8000) : null;
      // Velocidad 21-oct: sin cabecera propia (salvo endpoint ngrok) → GET simple, sin OPTIONS.
      return fetch(endpoint + '/cobertura?' + qs, { method: 'GET', headers: lbHeadersCobertura(endpoint), signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (to) clearTimeout(to); if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        // El server responde { ok, nivel, items:[...] } — el campo es `items` (NO `opciones`).
        .then(function (j) { return (j && Array.isArray(j.items)) ? j.items : []; })
        .catch(function () {
          if (to) clearTimeout(to);
          // Reintento único (cold-start/hipo del túnel): espera 700ms y reintenta 1 vez.
          if (!_retry) return new Promise(function (res) { setTimeout(function () { res(fetchNivel(params, true)); }, 700); });
          return [];
        });
    }

    // Construye los <option> con createElement + textContent (inmune a XSS: el texto
    // de colonia/municipio viene del dataset, nunca debe interpretarse como HTML).
    function optionNode(value, texto) {
      var opt = document.createElement('option');
      opt.value = value == null ? '' : String(value);
      opt.textContent = texto == null ? '' : String(texto);
      return opt;
    }

    function fillSelect(sel, opciones, placeholder) {
      if (!sel) return;
      sel.textContent = ''; // limpia sin innerHTML
      sel.appendChild(optionNode('', placeholder || 'Selecciona…'));
      opciones.forEach(function (o) {
        var v = typeof o === 'string' ? o : (o && (o.nombre || o.valor || o.value) || '');
        if (v) sel.appendChild(optionNode(v, v));
      });
    }

    function resetSelect(sel, placeholder) {
      if (!sel) return;
      sel.textContent = '';
      sel.appendChild(optionNode('', placeholder || '—'));
      sel.disabled = true;
    }

    function wireCascada() {
      // Nivel 1: estados (al abrir el overlay la primera vez).
      // Niveles encadenados por onchange.
      els.estado.addEventListener('change', function () {
        resetSelect(els.municipio, '—'); resetSelect(els.cp, '—'); resetSelect(els.colonia, '—');
        var est = els.estado.value;
        if (!est) return;
        els.municipio.disabled = true;
        fetchNivel({ estado: est }).then(function (ops) {
          fillSelect(els.municipio, ops, 'Selecciona…');
          els.municipio.disabled = ops.length === 0;
        });
      });
      els.municipio.addEventListener('change', function () {
        resetSelect(els.cp, '—'); resetSelect(els.colonia, '—');
        var est = els.estado.value, mun = els.municipio.value;
        if (!est || !mun) return;
        fetchNivel({ estado: est, municipio: mun }).then(function (ops) {
          fillSelect(els.cp, ops, 'Selecciona…');
          els.cp.disabled = ops.length === 0;
        });
      });
      els.cp.addEventListener('change', function () {
        resetSelect(els.colonia, '—');
        var est = els.estado.value, mun = els.municipio.value, cp = els.cp.value;
        if (!est || !mun || !cp) return;
        fetchNivel({ estado: est, municipio: mun, cp: cp }).then(function (ops) {
          fillSelect(els.colonia, ops, ops.length ? 'Selecciona…' : 'Sin colonias');
          els.colonia.disabled = ops.length === 0;
        });
      });
    }

    var estadosCargados = false;
    function cargarEstados() {
      if (estadosCargados) return;
      lbEstadosConPrefetch(tomarEstadosPrefetch(), fetchNivel).then(function (ops) {
        if (estadosCargados) return; // otra apertura ya los pintó: no se repinta (no borra lo elegido)
        if (ops && ops.length) {
          // Solo se marca cargado si el fetch trajo estados. Si falló (red/ngrok),
          // NO se marca → se reintenta al volver a abrir el formulario (robustez).
          estadosCargados = true;
          fillSelect(els.estado, ops, 'Selecciona…');
        } else lbSalud('estados_vacios');
      });
    }

    // ── Abrir / cerrar ────────────────────────────────────────────────────────
    function openOverlay() {
      lbSalud('apertura');
      buildOverlay();
      currentSel = leerSeleccion();
      enviado = false;
      // Resumen del pack elegido.
      var lineas = resumenPack(currentSel);
      var titulo = 'Pack de ' + currentSel.unidades + (currentSel.unidades === 1 ? ' unidad' : ' unidades');
      var precio = currentSel.precioMoney ? ('<span class="lb-cod-summary__price">' + esc(currentSel.precioMoney) + '</span>') : '';
      els.summary.innerHTML =
        '<div class="lb-cod-summary__head"><span class="lb-cod-summary__title">' + esc(titulo) + '</span>' + precio + '</div>' +
        (lineas.length ? '<ul class="lb-cod-summary__list">' + lineas.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>' : '');
      // Estado inicial de la vista
      els.formwrap.hidden = false;
      els.thanks.hidden = true;
      els.thanks.innerHTML = '';
      els.flash.hidden = true;
      els.error.hidden = true;
      els.submit.disabled = false;
      cargarEstados();
      overlay.hidden = false;
      document.documentElement.classList.add('lb-cod-lock');
      // Foco al primer campo (accesibilidad).
      var first = els.form.querySelector('input[name="nombre"]');
      if (first) { try { first.focus(); } catch (e) {} }
    }

    function closeOverlay() {
      if (!overlay) return;
      overlay.hidden = true;
      // Si el modal flash estaba abierto con su countdown corriendo, hay que MATAR el
      // interval y resetear su estado: si no, el timer seguiría vivo sobre un overlay
      // cerrado y podría disparar enviarOrden a ciegas al llegar a cero.
      resetFlash();
      els.flash.hidden = true;
      document.documentElement.classList.remove('lb-cod-lock');
    }

    // ── Recolección + validación mínima cliente (el server revalida TODO) ─────
    function datosDelForm() {
      var f = els.form;
      var get = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; };
      return {
        nombre: get('nombre'),
        apellido: get('apellido'),
        whatsapp: get('whatsapp').replace(/\D/g, '').slice(-10),
        estado: get('estado'),
        municipio: get('municipio'),
        cp: get('cp'),
        colonia: get('colonia'),
        direccion: get('direccion'),
        email: get('email'),
        nota: get('nota'),
        website: get('website'), // honeypot
      };
    }

    function validarCliente(d) {
      if (!d.nombre) return 'Escribe tu nombre.';
      if (!d.apellido) return 'Escribe tu apellido.';
      if (!/^\d{10}$/.test(d.whatsapp)) return 'El WhatsApp debe tener 10 dígitos.';
      if (!d.estado) return 'Selecciona tu estado.';
      if (!d.municipio) return 'Selecciona tu municipio.';
      if (!d.cp) return 'Selecciona tu código postal.';
      if (!d.direccion) return 'Escribe tu dirección (calle y número).';
      if (d.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.email)) return 'El correo no parece válido.';
      return null;
    }

    function upsellsAceptados() {
      var out = {};
      var tick = overlay.querySelector('[data-lb-cod-tick]');
      if (upsellTick && tick && tick.checked) out.tick = true;
      if (upsellFlash && flashAceptado) out.flash = true;
      return out;
    }

    // ── OFERTA FLASH (modal con countdown, entre submit y POST) ───────────────
    var flashAceptado = false;
    var flashMostrado = false;
    var flashTimer = null; // ref del setInterval del countdown, accesible desde closeOverlay

    // Detiene el countdown y limpia el estado del flash. Se llama al cerrar el overlay
    // (X/backdrop/Escape) para que un timer huérfano no dispare enviarOrden después.
    function resetFlash() {
      if (flashTimer) { clearInterval(flashTimer); flashTimer = null; }
      flashMostrado = false;
      flashAceptado = false;
    }

    function mostrarFlash(onDecidido) {
      // Sin config o ya mostrada → seguir directo.
      if (!upsellFlash || flashMostrado) { onDecidido(); return; }
      flashMostrado = true;
      var seg = Number(upsellFlash.countdownSeg || 0);
      var precioTxt = '';
      if (upsellFlash.precioFinal != null) precioTxt = '$' + Number(upsellFlash.precioFinal).toFixed(2);
      else if (upsellFlash.descuentoPct != null) precioTxt = '-' + Number(upsellFlash.descuentoPct) + '%';
      els.flash.innerHTML =
        '<div class="lb-cod-flash__card">' +
          (upsellFlash.imagen ? '<img class="lb-cod-flash__img" src="' + esc(upsellFlash.imagen) + '" alt="">' : '') +
          '<div class="lb-cod-flash__title">' + esc(upsellFlash.titulo) + '</div>' +
          (upsellFlash.copy ? '<div class="lb-cod-flash__copy">' + esc(upsellFlash.copy) + '</div>' : '') +
          (precioTxt ? '<div class="lb-cod-flash__price">' + precioTxt + '</div>' : '') +
          (seg > 0 ? '<div class="lb-cod-flash__cd" data-lb-cod-cd></div>' : '') +
          '<button type="button" class="lb-atc lb-cod-flash__yes" data-lb-cod-flash-yes>Agregar a mi pedido</button>' +
          '<button type="button" class="lb-cod-flash__no" data-lb-cod-flash-no>No, gracias</button>' +
        '</div>';
      els.flash.hidden = false;

      function cerrarFlash(acepta) {
        flashAceptado = acepta;
        if (flashTimer) { clearInterval(flashTimer); flashTimer = null; }
        els.flash.hidden = true;
        onDecidido();
      }
      els.flash.querySelector('[data-lb-cod-flash-yes]').addEventListener('click', function () { cerrarFlash(true); });
      els.flash.querySelector('[data-lb-cod-flash-no]').addEventListener('click', function () { cerrarFlash(false); });

      if (seg > 0) {
        var restante = Math.round(seg);
        var cdEl = els.flash.querySelector('[data-lb-cod-cd]');
        var pinta = function () {
          var m = Math.floor(restante / 60), s = restante % 60;
          if (cdEl) cdEl.textContent = 'Termina en ' + m + ':' + String(s).padStart(2, '0');
        };
        pinta();
        flashTimer = setInterval(function () {
          restante -= 1;
          if (restante <= 0) { cerrarFlash(false); return; } // se acabó el tiempo → sin upsell
          pinta();
        }, 1000);
      }
    }

    // ── Envío de la orden ─────────────────────────────────────────────────────
    function onSubmit() {
      var d = datosDelForm();
      // Honeypot: si viene lleno, fingimos éxito sin llamar al server (anti-bot).
      if (d.website) { mostrarGracias(null); return; }
      var err = validarCliente(d);
      if (err) { showError(err); return; }
      hideError();

      // Modal flash primero (si está configurado), luego POST.
      mostrarFlash(function () {
        enviarOrden(d);
      });
    }

    function enviarOrden(d) {
      els.submit.disabled = true;
      els.submit.textContent = 'Enviando…';
      // lbConMedicion: `ab`/`codm` en la raíz SOLO si la página los trae (A/B, E2).
      var payload = lbConMedicion({
        productGid: productGid || undefined,
        // n = tier del metafield (server elige el pack por n); unidades = cantidad real
        // (= n salvo en el tier abierto, donde unidades ≥ n). Para tiers normales n===unidades
        // → payload idéntico al de antes (el server lee n ?? unidades). `abierto` deja al
        // server saber si el tier ADMITE escalar (su clave idem solo diverge si es abierto).
        tier: { n: currentSel.n, unidades: currentSel.unidades, abierto: currentSel.abierto === true },
        variantesPorUnidad: currentSel.variantesPorUnidad,
        upsells: upsellsAceptados(),
        datos: {
          nombre: d.nombre, apellido: d.apellido, whatsapp: d.whatsapp,
          estado: d.estado, municipio: d.municipio, cp: d.cp, colonia: d.colonia,
          direccion: d.direccion, email: d.email, nota: d.nota,
        },
        website: d.website, // honeypot (vacío en humanos)
        // D2 (CAPI): fbp/fbc/url/eventId para el match de Conversions API + dedupe.
        // v1 no dispara fbq Purchase → un eventId fresco por envío basta para el CAPI.
        attr: construirAttr(uuidV4()),
      });
      // ⏱️ Tiempo límite de 25 s y textos honestos: ver «EL ENVÍO DEL PEDIDO» arriba.
      var respondio = false;
      lbEnviarConPlazo(endpoint + '/ordenar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'ngrok-skip-browser-warning': 'true' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          respondio = true;
          if (res.ok && res.j && res.j.ok) {
            enviado = true;
            lbSalud('envio_ok');
            mostrarGracias(res.j.orderName || null);
          } else {
            lbSalud('envio_fallido:' + lbCodigoEnvio(res.status));
            showError(lbTextoFallo(res.status, res.j));
            els.submit.disabled = false;
            els.submit.textContent = '¡FINALIZA TU COMPRA! · Paga al recibir · Envío gratis';
          }
        })
        .catch(function (err) {
          if (enviado) return; // el pedido salió: lo que lanzó fue pintar las gracias
          if (err && err.plazo) { lbSalud('envio_colgado'); showError(LB_TXT_COLGADO); }
          else { if (!respondio) lbSalud('envio_fallido:red'); showError(LB_TXT_FALLO); }
          els.submit.disabled = false;
          els.submit.textContent = '¡FINALIZA TU COMPRA! · Paga al recibir · Envío gratis';
        });
    }

    function mostrarGracias(orderName) {
      enviado = true;
      els.formwrap.hidden = true;
      els.flash.hidden = true;
      els.thanks.hidden = false;
      els.thanks.innerHTML =
        '<div class="lb-cod-thanks__ico">✓</div>' +
        '<div class="lb-cod-thanks__title">¡Pedido confirmado!</div>' +
        '<div class="lb-cod-thanks__msg">Gracias por tu compra.' +
          (orderName ? ' Tu número de orden es <b>' + esc(orderName) + '</b>.' : '') +
          ' Te contactaremos por WhatsApp para coordinar la entrega. Pagas al recibir.</div>' +
        '<button type="button" class="lb-atc lb-cod-thanks__close" data-lb-cod-close>Entendido</button>';
      els.thanks.querySelectorAll('[data-lb-cod-close]').forEach(function (c) {
        c.addEventListener('click', closeOverlay);
      });
    }

    function showError(msg) { if (els.error) { els.error.textContent = msg; els.error.hidden = false; } }
    function hideError() { if (els.error) els.error.hidden = true; }

    // ── Interceptores del CTA + sticky + submit nativo ────────────────────────
    // CTA principal (type=button con data-lb-cod-cta).
    var cta = form.querySelector('[data-lb-cod-cta]');
    if (cta) cta.addEventListener('click', function (ev) { ev.preventDefault(); openOverlay(); });

    // Sticky móvil: abre el overlay en vez del submit nativo.
    var stickyBtn = document.querySelector('[data-lb-sticky-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function (ev) { ev.preventDefault(); openOverlay(); });

    // Defensa: si algo intenta el submit nativo del form (Enter, Releasit residual),
    // lo frenamos y abrimos el overlay en su lugar.
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (overlay && !overlay.hidden) return; // ya abierto (submit interno lo maneja su propio handler)
      openOverlay();
    });
    // Cola de toques (velocidad 21-oct): el botón YA está conectado. Si el cliente lo
    // tocó antes, se abre ahora — una sola vez (ver lbColaListo).
    lbColaListo(openOverlay);

    // ── Beacon de parcial (recuperación de carrito propio) ────────────────────
    // Si el cliente escribió su WhatsApp pero no envió la orden, reportamos un parcial
    // al cerrar la pestaña (best-effort, sendBeacon). El server espera { phone, nombre,
    // productos(string), valor(number), cp, tienda? } + los datos de entrega opcionales
    // { apellido, estado, municipio, colonia, direccion }.
    var parcialEnviado = false; // en móvil, pagehide dispara al cambiar de pestaña → un
                                // solo beacon por sesión (evita duplicados pagehide/beforeunload).

    // Datos de ENTREGA que el formulario ya capturó y el beacon tiraba en el navegador.
    // Sin ellos, el bot de WhatsApp termina preguntando por escrito exactamente lo que
    // el cliente ya tecleó (apellido, estado, municipio, colonia, dirección). Van SOLO
    // si traen contenido y recortados a 120 caracteres: el payload tiene que seguir
    // chico porque keepalive topa en 64KB. Son OPCIONALES a propósito — un server que
    // todavía no los conozca los ignora al armar su registro (no rechaza el body).
    // Hoisted en initCod: la sirven los DOS beacons (v1 aquí, v2 dentro de initCodV2).
    function agregarDatosEntrega(body, d) {
      ['apellido', 'estado', 'municipio', 'colonia', 'direccion'].forEach(function (k) {
        var v = String((d && d[k]) || '').trim();
        if (v) body[k] = v.slice(0, 120);
      });
      return body;
    }
    function reportarParcial() {
      if (parcialEnviado || enviado || !overlay || overlay.hidden) return;
      var wEl = els.form && els.form.querySelector('[name="whatsapp"]');
      var whats = wEl ? String(wEl.value || '').replace(/\D/g, '').slice(-10) : '';
      if (!/^\d{10}$/.test(whats)) return; // sin WhatsApp real → nada que recuperar
      var d = datosDelForm();
      if (d.website) return; // honeypot → no reportamos bots
      // Resumen del pack y precio del tier (lo que el router persiste como productos/valor).
      var productosTxt = '';
      var valorNum = 0;
      if (currentSel) {
        productosTxt = 'Pack ' + currentSel.unidades + ' × ' + (productoTitulo || 'producto');
        valorNum = precioNumerico(currentSel.precioMoney);
      }
      var body = {
        phone: whats,
        nombre: d.nombre || '',
        productos: productosTxt,
        valor: valorNum,
        cp: d.cp || '',
        tienda: tienda || undefined,
        fuente: 'cod-form',
      };
      agregarDatosEntrega(body, d); // apellido/estado/municipio/colonia/dirección (si los hay)
      lbConMedicion(body); // A/B (E2): `ab`/`codm` solo si la página los trae
      // fetch keepalive (NO sendBeacon): sendBeacon no permite headers custom y el
      // 'ngrok-skip-browser-warning' es necesario para saltar el aviso de ngrok-free.
      // keepalive:true permite que la petición sobreviva al cierre de la pestaña.
      try {
        fetch(endpoint + '/parcial', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
          body: JSON.stringify(body),
          keepalive: true,
        }).catch(function () {});
        parcialEnviado = true;
      } catch (e) {}
    }
    window.addEventListener('pagehide', reportarParcial);
    window.addEventListener('beforeunload', reportarParcial);

    // ════════════════════════════════════════════════════════════════════════
    // COD v2 — overlay réplica de la app Releasit (clases lb2-*). Namespaced,
    // aislado del path v1 (arriba). Reusa las funciones puras hoisted de initCod:
    // leerSeleccion, precioNumerico, escapaHtml/esc, fetchNivel, optionNode,
    // fillSelect, resetSelect. Tiene su propio overlay/els2/timers.
    // ════════════════════════════════════════════════════════════════════════
    function initCodV2() {
      var skin = (cfg.codSkin && typeof cfg.codSkin === 'object') ? cfg.codSkin : {};
      var sticky = (cfg.codSticky && typeof cfg.codSticky === 'object') ? cfg.codSticky : null;
      // FASE B (26-jul): upsellTick puede ser un OBJETO legacy o un ARRAY de 1..4
      // ofertas (checkbox con foto). Normalizamos SIEMPRE a lista — con el objeto
      // único el comportamiento es idéntico al de antes (retrocompat total).
      // ⚠️ DOS invariantes que NO se pueden romper:
      //  (1) El CAP de 4 debe coincidir con TICK_MAX del router (src/cod/router.js):
      //      si el metafield trajera más, el server ignoraría los sobrantes y la
      //      landing cobraría de más en pantalla.
      //  (2) El ÍNDICE es el contrato con el server (body.upsells.ticks = {idx:bool}
      //      y el router recorre el array del metafield por posición). Por eso ticks2
      //      conserva las POSICIONES ORIGINALES y NO se compacta: si filtráramos los
      //      items inválidos, el índice 0 del cliente apuntaría al item 1 del server
      //      → el cliente marcaría una oferta y le cobrarían OTRA.
      var TICKS_MAX = 4;
      var ticks2 = Array.isArray(cfg.upsellTick)
        ? cfg.upsellTick.slice(0, TICKS_MAX)
        : ((cfg.upsellTick && typeof cfg.upsellTick === 'object') ? [cfg.upsellTick] : []);
      // Un item solo es pintable/cobrable con título; los inválidos se SALTAN en el
      // render (conservando su hueco de índice) — mismo criterio que el router.
      function tickValido(t) { return !!(t && typeof t === 'object' && t.titulo); }
      function ticksCuantos() {
        var n = 0;
        ticks2.forEach(function (t) { if (tickValido(t)) n++; });
        return n;
      }
      // Estado ÚNICO de los checks (fuente de verdad compartida entre las tarjetas de
      // la LANDING y las del OVERLAY — dos juegos de checkboxes sincronizados):
      // idx → bool. Arranca en marcadoDefault por item.
      var ticksState = {};
      ticks2.forEach(function (t, i) { ticksState[i] = tickValido(t) && t.marcadoDefault === true; });
      // CASO 2 (28-jul): publicamos los adicionales marcados al puente de módulo para
      // que el botón de la PÁGINA (initBuyBox, otro closure) pueda decir el total
      // real. Es solo lectura/DISPLAY — la fuente de verdad sigue siendo ticksState
      // aquí y el recálculo del servidor al ordenar. `ticksMarcados` está declarada
      // más abajo en este mismo closure (hoisting de function declarations).
      lbRegistrarExtras(function () {
        var marcados = ticksMarcados();
        var total = 0;
        marcados.forEach(function (m) {
          var p = Number(m.t.precio);
          if (Number.isFinite(p) && p > 0) total += p;
        });
        return { cuantos: marcados.length, total: total };
      });
      // Cadena de upsells: normaliza objeto legacy | array | ausente → array.
      var chain = Array.isArray(cfg.upsellFlash)
        ? cfg.upsellFlash.slice()
        : (cfg.upsellFlash && typeof cfg.upsellFlash === 'object' ? [cfg.upsellFlash] : []);

      // Formateador de moneda para SUMAS (no reusa | money de Liquid porque son
      // totales calculados en JS). Copia el patrón "$ 1,234.00" (2 decimales, coma
      // de miles). NO se llama formatMoney (test 11f prohíbe ese nombre).
      function formatearMoneda(n) {
        var num = Number(n);
        if (!Number.isFinite(num)) num = 0;
        var s = num.toFixed(2);
        var partes = s.split('.');
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return '$' + partes.join('.');
      }

      // Miniatura del producto: primer .lb-tier__thumb del widget, si no la og:image.
      function thumbProducto() {
        var t = document.querySelector('.lb-tier__thumb img, .lb-tier__thumb');
        if (t) {
          if (t.tagName === 'IMG' && t.src) return t.src;
          var inner = t.querySelector && t.querySelector('img');
          if (inner && inner.src) return inner.src;
        }
        var og = document.querySelector('meta[property="og:image"]');
        return og ? (og.getAttribute('content') || '') : '';
      }

      // Lee los tiers del widget de la página (los .lb-tier ya renderizados por Liquid).
      function leerTiersPagina() {
        var out = [];
        form.querySelectorAll('.lb-tier').forEach(function (tierEl) {
          var n = Number(tierEl.getAttribute('data-tier-n')) || 1;
          var nameEl = tierEl.querySelector('.lb-tier__name');
          var badgeEl = tierEl.querySelector('.lb-tier__badge');
          var stEl = tierEl.querySelector('[data-tier-stepper]');
          out.push({
            el: tierEl,
            n: n,
            label: nameEl ? (nameEl.textContent || '').trim() : ('Pack de ' + n),
            badge: badgeEl ? (badgeEl.textContent || '').trim() : '',
            popular: tierEl.getAttribute('data-tier-popular') === 'true',
            abierto: tierEl.getAttribute('data-tier-abierto') === 'true',
            min: stEl ? (Number(stEl.getAttribute('data-tier-min')) || n) : n,
            cap: stEl ? (Number(stEl.getAttribute('data-tier-cap')) || 10) : n,
            precioMoney: tierEl.getAttribute('data-tier-precio-money') || '',
            compMoney: tierEl.getAttribute('data-tier-comp-money') || '',
          });
        });
        return out;
      }

      // SVG inline para los íconos de campo (currentColor, sin recursos externos).
      var ICON = {
        persona: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
        tel: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
        pin: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
        pinmas: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><line x1="12" y1="7" x2="12" y2="13"/><line x1="9" y1="10" x2="15" y2="10"/></svg>',
        arroba: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"/></svg>',
        nota: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/></svg>',
      };

      // ── Estado v2 ─────────────────────────────────────────────────────────
      var overlay2 = null;
      var e2 = {};                 // referencias a nodos internos
      var currentSel2 = null;      // selección del pack (leerSeleccion)
      var tiersPagina = [];        // tiers leídos del widget
      var activoN = null;          // n del tier activo en el modal
      var enviado2 = false;
      var aceptados = [];          // [{id, qty}] de la cadena de upsells
      var estadosCargados2 = false;
      // A1 (ronda 6.5) — LA ORDEN NUNCA SE PIERDE: datosPendientes2 guarda los datos
      // VÁLIDOS del FINALIZAR mientras la cadena de upsells corre. Cualquier salida
      // (✕/Escape → enviar y mostrar gracias; pagehide/pestaña oculta → flush con
      // fetch keepalive) envía la orden con los upsells aceptados hasta ese momento
      // en vez de abortarla. postEnVuelo2 = guard anti doble POST /ordenar.
      var datosPendientes2 = null;
      var postEnVuelo2 = false;
      // D2 (CAPI): id de evento generado al FINALIZAR — estable durante toda la vida
      // de esta orden. Va en el payload (attr.eventId) Y en TODAS las llamadas fbq
      // Purchase (visible y flush) para que Meta dedupe pixel vs CAPI server-side.
      var eventId2 = null;
      // ⏱️ (22-oct) EL REINTENTO REUSA EL MISMO eventId. Si un envío se quedó SIN respuesta
      // definitiva (colgado, red, 5xx, 429), la orden pudo crearse en el servidor —y con ella
      // el Purchase de CAPI con ESE eventId—. El reintento del MISMO pedido recibe la misma
      // orden (`duplicado:true`) y dispara el Purchase del pixel: con un eventId nuevo, Meta
      // contaría la compra DOS veces. Se reusa sólo si el pedido es el mismo que el servidor
      // deduplica (WhatsApp + producto + escalón + unidades); otro pedido, otro id.
      var reintento2 = null;   // { clave, eventId } del último envío sin respuesta definitiva
      function claveEnvio2(d) {
        var s = currentSel2 || {};
        return [d && d.whatsapp, productGid, s.n, s.unidades, s.abierto === true].join('|');
      }
      function cadenaEnVuelo2() {
        // "En vuelo" = FINALIZAR ya validó (procesando2) y la orden aún no salió.
        return !!(procesando2 && !enviado2 && datosPendientes2);
      }

      // Timers de la cadena: UN SOLO timer activo. abortarCadena limpia TODOS.
      var flashTimer2 = null;
      var flashIdx = 0;
      var cadenaAbortada = false;
      var onCadenaFin = null;
      // Full-screen de ofertas en móvil (<640px, fix móvil #5): mientras la cadena
      // corre en celular, el formulario se OCULTA y cada oferta ocupa TODO el panel.
      // Al terminar/errorar se restaura. Este flag recuerda que hay que restaurar.
      var flashFullscreen = false;

      function limpiarTimers() {
        if (flashTimer2) { clearInterval(flashTimer2); flashTimer2 = null; }
      }

      // ── Caso 15: foto flash al MÁXIMO sin hueco (medición determinista) ─────────
      // SOLO en fullscreen (móvil <640). El CSS deja la foto en
      //   max-height: min(44vh, calc(100dvh − var(--lb2-flash-reserva)))  (fallback 540px).
      // Aquí medimos la reserva REAL (todo lo que NO es la foto: cabecera, textos,
      // precio, timer, selector y los 2 botones) y la escribimos → la foto toma
      // EXACTAMENTE el alto que sobra (hueco → buffer, ~8px).
      //
      // MODELO (planner):  reserva = padV(card) + nonImg + actions + buffer.
      // OJO: nonImg NO se puede leer como (scroll.scrollHeight − img.offsetHeight): el
      // scroll (.lb2-flash__scroll) es flex:1 1 auto — se ESTIRA para anclar los botones
      // abajo — así que cuando el contenido no llena la caja (que es JUSTO el hueco a
      // corregir) scrollHeight === clientHeight (la caja estirada), no el contenido real
      // → la fórmula del scrollHeight se vuelve CIRCULAR y el hueco EMPEORA (verificado
      // en vivo con render puppeteer del CSS real). Medimos nonImg de forma robusta vía
      // el HUECO observable a la reserva vigente:
      //     reservaNueva = reservaActual − hueco + buffer      (hueco = actions.top − ancla.bottom)
      // Converge en UN solo paso a padV+nonImg+actions+buffer: el hueco lleva coeficiente
      // +1 sobre reservaActual y la cancela (deadbeat) → NO hay loop de realimentación
      // (el texto no depende del alto de la foto). Determinismo v7 intacto: la foto sigue
      // siendo max-height fijo + object-fit:contain, cero flex-grow. Si faltan nodos o la
      // imagen aún no tiene layout (cargando), NO se toca la var → queda el fallback 540
      // del CSS (comportamiento seguro actual).
      var FLASH_RESERVA_BUFFER = 8;
      function medirReservaFlash() {
        if (!flashFullscreen || !e2.flash || e2.flash.hidden) return;
        var scroll = e2.flash.querySelector('.lb2-flash__scroll');
        var actions = e2.flash.querySelector('.lb2-flash__actions');
        // Ancla = último contenido real DEL SCROLL. ⚠️ Buscar SOLO dentro del scroll
        // (fix escéptico v9, 26-jul): el selector de cantidad se movió al FOOTER, y si
        // el ancla lo encontrara allí, hueco = actions.top − qty.bottom daría SIEMPRE
        // −44px → la reserva crecería sin converger y la foto se encogería sola en
        // cada resize del teléfono. El reloj es hoy el último contenido del scroll.
        var ancla = scroll ? (scroll.querySelector('.lb2-flash__cd') || scroll.lastElementChild) : null;
        if (!scroll || !actions || !ancla) return;              // sin nodos → fallback 540
        // Imagen aún sin layout (cargando): re-mediremos en su onload.
        var img = e2.flash.querySelector('.lb2-flash__img');
        if (img && !img.offsetHeight) return;
        var hueco = actions.getBoundingClientRect().top - ancla.getBoundingClientRect().bottom;
        if (!isFinite(hueco)) return;
        var cur = parseFloat(getComputedStyle(e2.flash).getPropertyValue('--lb2-flash-reserva'));
        if (!isFinite(cur)) cur = 540;
        // Sólo actuar si hay hueco RECLAMABLE (> buffer → agrandar la foto) o si el
        // selector se salió por abajo (hueco < 0 → encoger la foto para recuperarlo).
        // Con 0 ≤ hueco ≤ buffer el estado ya es óptimo (foto máxima, selector visible)
        // → NO tocar: así un producto de contenido alto —cuya reserva ya rondaba 540 sin
        // hueco— no encoge la foto sin motivo. Converge en un paso (deadbeat).
        // GUARD DE SATURACIÓN (fix 26-jul, medido en vivo: reserva 226→177→128→79 sin
        // converger): si hay hueco reclamable pero la foto YA está en su techo (52vh),
        // agrandarla es imposible — el hueco es legítimo y perseguirlo solo corre la
        // reserva hasta 0 en cada resize. El deadbeat asume d(foto)/d(reserva) = −1;
        // con la foto saturada esa derivada es 0 → no actuar.
        if (hueco > FLASH_RESERVA_BUFFER && img) {
          var vhAlto = window.innerHeight || 0;
          // 0.62 = el techo v9.5 (62vh). Si la foto ya lo tocó, el hueco restante es
          // legítimo y no se persigue (evita el runaway de reserva medido en vivo).
          if (img.getBoundingClientRect().height >= 0.62 * vhAlto - 2) return;
        }
        if (hueco > FLASH_RESERVA_BUFFER || hueco < 0) {
          var reserva = Math.round(cur - hueco + FLASH_RESERVA_BUFFER);
          if (reserva < 0) reserva = 0;                          // cota de cordura
          if (reserva > 700) reserva = 700;                      // cota superior (foto jamás < piso 230 por reserva loca)
          e2.flash.style.setProperty('--lb2-flash-reserva', reserva + 'px');
        }
      }
      // Re-medir en resize / rotación (registro único, gated por flashFullscreen).
      var reservaListenersOn = false;
      function initReservaListeners() {
        if (reservaListenersOn) return;
        reservaListenersOn = true;
        var onR = function () { if (flashFullscreen) requestAnimationFrame(medirReservaFlash); };
        try {
          window.addEventListener('resize', onR);
          window.addEventListener('orientationchange', onR);
        } catch (e) {}
      }

      // ── Candado de scroll iOS (fix móvil #2) ────────────────────────────────
      // iOS Safari ignora `overflow:hidden` en <html>/<body>: la página de atrás
      // "se mueve" bajo el overlay. El patrón robusto es fijar el body en su
      // posición actual (position:fixed; top:-scrollY) y restaurar el scroll al
      // cerrar. Guardamos el scrollY para TODOS los paths de cierre (X, backdrop,
      // Escape, Entendido). Idempotente: no re-guarda si ya está bloqueado.
      var scrollYGuardado = 0;
      var lockActivo = false;
      function bloquearScrollIOS() {
        if (lockActivo) return;
        lockActivo = true;
        scrollYGuardado = window.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || 0;
        var b = document.body;
        if (b) {
          b.style.position = 'fixed';
          b.style.top = (-scrollYGuardado) + 'px';
          b.style.left = '0';
          b.style.right = '0';
          b.style.width = '100%';
          b.classList.add('lb2-lock-ios');
        }
        document.documentElement.classList.add('lb-cod-lock');
        // Kill del auto-zoom iOS mientras el overlay esté abierto (corrección dueño 2026-07-11).
        bloquearZoomIOS();
      }
      function restaurarScrollIOS() {
        if (!lockActivo) return;
        lockActivo = false;
        restaurarZoomIOS();
        var b = document.body;
        if (b) {
          b.style.position = '';
          b.style.top = '';
          b.style.left = '';
          b.style.right = '';
          b.style.width = '';
          b.classList.remove('lb2-lock-ios');
        }
        document.documentElement.classList.remove('lb-cod-lock');
        try { window.scrollTo(0, scrollYGuardado); } catch (e) {}
      }

      // ── Kill del zoom automático de iOS (corrección dueño 2026-07-11) ────────
      // Safari iOS hace AUTO-ZOOM sobre cualquier control con font-size < 16px al
      // enfocarlo → el zoom recortaba los labels y "descuadraba" el modal (el bug de
      // los labels cortados que vio el dueño). Doble defensa: (1) todos los controles
      // del overlay ya son ≥16px por CSS; (2) mientras el overlay esté abierto forzamos
      // el <meta viewport> a maximum-scale=1 / user-scalable=0, y lo RESTAURAMOS tal
      // cual estaba al cerrar (X, backdrop, Escape, Entendido, error-restore). Si el
      // meta no existía, lo creamos y lo QUITAMOS al cerrar (no dejamos rastro).
      var vpMeta = null;                 // ref del <meta name=viewport>
      var vpContentPrev = null;          // content original (null si no existía → lo creamos)
      var vpCreado = false;              // true si nosotros creamos el meta
      var zoomBloqueado = false;
      var VP_LOCK = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0';
      function bloquearZoomIOS() {
        if (zoomBloqueado) return;
        zoomBloqueado = true;
        try {
          vpMeta = document.querySelector('meta[name="viewport"]');
          if (vpMeta) {
            vpContentPrev = vpMeta.getAttribute('content');
            vpCreado = false;
          } else {
            vpMeta = document.createElement('meta');
            vpMeta.setAttribute('name', 'viewport');
            (document.head || document.documentElement).appendChild(vpMeta);
            vpContentPrev = null;
            vpCreado = true;
          }
          vpMeta.setAttribute('content', VP_LOCK);
        } catch (e) {}
      }
      function restaurarZoomIOS() {
        if (!zoomBloqueado) return;
        zoomBloqueado = false;
        try {
          if (vpMeta) {
            if (vpCreado) {
              if (vpMeta.parentNode) vpMeta.parentNode.removeChild(vpMeta);
            } else if (vpContentPrev != null) {
              vpMeta.setAttribute('content', vpContentPrev);
            } else {
              vpMeta.removeAttribute('content');
            }
          }
        } catch (e) {}
        vpMeta = null; vpContentPrev = null; vpCreado = false;
      }
      // ¿viewport de celular? (< 640/900). Se calcula al abrir (no se cachea:
      // el usuario puede rotar el dispositivo entre aperturas).
      function esMovilAncho(bp) {
        var w = window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || 1024;
        return w < (bp || 900);
      }

      // ── Skin: aplica codSkin como CSS vars en el nodo raíz del overlay ──────
      function aplicarSkin(root) {
        var modo = String(skin.modo || '').toLowerCase();
        // Defaults claros (NovaStore). Modo 'oscuro' (Soy Buda): accent buda + panel greige.
        var def = (modo === 'oscuro')
          ? { accent: '#BD7F60', accentText: '#ffffff', bg: '#EAE3D9', text: '#1C1712', card: '#F3EEE6', ctaBg: '#141414', ctaText: '#ffffff', ctaBorder: '#BD7F60' }
          : { accent: '#D4653D', accentText: '#ffffff', bg: '#EDE8E0', text: '#1C1712', card: '#F6F1EA', ctaBg: '#141414', ctaText: '#ffffff', ctaBorder: '#D4653D' };
        function v(k, d) { return (skin[k] != null && skin[k] !== '') ? String(skin[k]) : d; }
        root.style.setProperty('--lb2-accent', v('accent', def.accent));
        root.style.setProperty('--lb2-accent-text', v('accentText', def.accentText));
        root.style.setProperty('--lb2-bg', v('bg', def.bg));
        root.style.setProperty('--lb2-text', v('text', def.text));
        root.style.setProperty('--lb2-card', v('card', def.card));
        root.style.setProperty('--lb2-cta-bg', v('ctaBg', def.ctaBg));
        root.style.setProperty('--lb2-cta-text', v('ctaText', def.ctaText));
        root.style.setProperty('--lb2-cta-border', v('ctaBorder', def.ctaBorder));
      }

      // ── Cascada v2 (Estado → Municipio → CP). ──────────────────────────────
      // OJO v2: la COLONIA es un INPUT de texto (no cascada) → NO se hace fetch de
      // colonias y ningún nivel toca e2.colonia. El path v1 conserva el <select> de
      // colonia en cascada (wireCascada, sin cambios).
      // Placeholders v2 = el nombre del campo (réplica app Releasit): la 1ª opción vacía
      // muestra "Estado"/"Municipio / Delegación"/"Código postal" en negrita oscura.
      function wireCascada2() {
        e2.estado.addEventListener('change', function () {
          resetSelect(e2.municipio, 'Municipio / Delegación'); resetSelect(e2.cp, 'Código postal');
          var est = e2.estado.value;
          if (!est) return;
          e2.municipio.disabled = true;
          fetchNivel({ estado: est }).then(function (ops) {
            fillSelect(e2.municipio, ops, 'Municipio / Delegación');
            e2.municipio.disabled = ops.length === 0;
          });
        });
        e2.municipio.addEventListener('change', function () {
          resetSelect(e2.cp, 'Código postal');
          var est = e2.estado.value, mun = e2.municipio.value;
          if (!est || !mun) return;
          fetchNivel({ estado: est, municipio: mun }).then(function (ops) {
            fillSelect(e2.cp, ops, 'Código postal');
            e2.cp.disabled = ops.length === 0;
          });
        });
      }
      function cargarEstados2() {
        if (estadosCargados2) return;
        // Velocidad 21-oct: usa los estados precargados al iniciar (ver tomarEstadosPrefetch).
        lbEstadosConPrefetch(tomarEstadosPrefetch(), fetchNivel).then(function (ops) {
          if (estadosCargados2) return; // otra apertura ya los pintó: no se repinta (no borra lo elegido)
          if (ops && ops.length) { estadosCargados2 = true; fillSelect(e2.estado, ops, 'Estado'); }
          else lbSalud('estados_vacios');
        });
      }

      // ── Cálculo del desglose (misma matemática Releasit) ───────────────────
      // subtotal = comparación del tier activo (o precio) + Σ precioBase de upsells
      //            aceptados (por qty) + Σ comparacion (o precio) de los TICKS marcados.
      // total    = precio tier + Σ precioFinal (por qty) + Σ precio de los ticks marcados.
      // descuentos = subtotal − total (nunca negativo).
      function tierActivo() {
        for (var i = 0; i < tiersPagina.length; i++) if (tiersPagina[i].n === activoN) return tiersPagina[i];
        return tiersPagina[0] || null;
      }
      // FASE B: ticks marcados según el ESTADO compartido (no el DOM — hay checkboxes
      // duplicados en landing y overlay; ticksState es la única verdad).
      function ticksMarcados() {
        var out = [];
        ticks2.forEach(function (t, i) {
          if (tickValido(t) && ticksState[i] === true) out.push({ idx: i, t: t });
        });
        return out;
      }
      function ofertaPorId(id) {
        for (var i = 0; i < chain.length; i++) if (String(chain[i].id) === String(id)) return chain[i];
        return null;
      }
      function calcDesglose() {
        var ta = tierActivo();
        // Precio/comparación SIEMPRE en vivo desde el elemento del widget (el stepper
        // del tier abierto reescribe data-tier-*-money ahí). Fallback al string cacheado.
        var pMoney = (ta && ta.el && ta.el.getAttribute('data-tier-precio-money')) || (ta ? ta.precioMoney : '');
        var cMoney = (ta && ta.el && ta.el.getAttribute('data-tier-comp-money')) || (ta ? ta.compMoney : '');
        var precioTier = pMoney ? precioNumerico(pMoney) : 0;
        var compTier = cMoney ? precioNumerico(cMoney) : precioTier;
        var subtotal = compTier;
        var totalUpsells = 0, subUpsells = 0;
        var filasUpsell = [];
        aceptados.forEach(function (a) {
          var of = ofertaPorId(a.id);
          if (!of) return;
          var qty = Number(a.qty) || 1;
          var pf = Number(of.precioFinal) || 0;
          var pb = Number(of.precioBase) || pf;
          totalUpsells += pf * qty;
          subUpsells += pb * qty;
          filasUpsell.push({ titulo: of.titulo || 'Oferta', qty: qty, precioFinal: pf * qty });
        });
        subtotal += subUpsells;
        // FASE B: suma TODOS los ticks marcados (antes: uno solo). El tick entra al
        // SUBTOTAL por su `comparacion` (precio de lista) igual que el flash entra por
        // su `precioBase` → la aritmética que ve el cliente sigue cerrando
        // (Subtotal − Descuentos = TOTAL). Sin esto, un tick que CUESTA sumaba al total
        // sin sumar al subtotal: "Subtotal $799 … TOTAL $1231" y descuento negativo.
        // Tick gratis sin comparación (eBook) → aporta 0 a ambos: idéntico a hoy.
        // ⚠️ Debe reflejar EXACTAMENTE la matemática de calcularDesglose (src/cod/order.js),
        // que es la autoritativa: el server recalcula el desglose con los precios del
        // metafield y la orden se crea con ESE total.
        var marcados = ticksMarcados();
        var tickPrecio = 0;
        var tickBase = 0;
        var filasTick = [];
        marcados.forEach(function (m) {
          var p = Number(m.t.precio) || 0;
          var c = Number(m.t.comparacion) || 0;
          tickPrecio += p;
          tickBase += (c > p ? c : p);
          filasTick.push({ titulo: m.t.titulo || 'Extra', precio: p });
        });
        subtotal += tickBase;
        var total = precioTier + totalUpsells + tickPrecio;
        var descuentos = Math.max(0, subtotal - total);
        return {
          precioTier: precioTier, subtotal: subtotal, total: total, descuentos: descuentos,
          filasUpsell: filasUpsell,
          tickActivo: marcados.length > 0, tickPrecio: tickPrecio, filasTick: filasTick,
        };
      }

      // Pinta el desglose vivo + el CTA con el total.
      function pintarDesglose() {
        var d = calcDesglose();
        var filas = '';
        filas += '<div class="lb2-resumen__fila"><span>Subtotal</span><span>' + esc(formatearMoneda(d.subtotal)) + '</span></div>';
        filas += '<div class="lb2-resumen__fila"><span>Envío</span><span class="lb2-free">Gratis</span></div>';
        if (d.descuentos > 0.009) {
          filas += '<div class="lb2-resumen__fila"><span>Descuentos 🏷️</span><span class="lb2-desc">-' + esc(formatearMoneda(d.descuentos)) + '</span></div>';
        }
        (d.filasTick || []).forEach(function (ft) {
          filas += '<div class="lb2-resumen__fila"><span>' + esc(ft.titulo) + '</span><span>' + (ft.precio > 0 ? esc('+' + formatearMoneda(ft.precio)) : '<span class="lb2-free">Gratis</span>') + '</span></div>';
        });
        d.filasUpsell.forEach(function (f) {
          filas += '<div class="lb2-resumen__fila"><span>' + esc(f.titulo) + (f.qty > 1 ? ' ×' + f.qty : '') + '</span><span>' + esc(formatearMoneda(f.precioFinal)) + '</span></div>';
        });
        filas += '<div class="lb2-resumen__sep"></div>';
        filas += '<div class="lb2-resumen__fila lb2-resumen__total"><span>TOTAL</span><span>' + esc(formatearMoneda(d.total)) + '</span></div>';
        if (e2.resumen) e2.resumen.innerHTML = filas;
        // CASO 7 (dueño 27-jul, "no sé si en los precios incluir MXN… acepto tus
        // sugerencias"): la moneda va SÓLO aquí, en el botón donde el cliente decide
        // pagar. Repetir "MXN" en los ~20 precios de la página (packs, comparativas,
        // resumen, ofertas flash) ensucia y no aporta: el cliente ya sabe en qué
        // moneda compra; lo que necesita sin ambigüedad es la cifra QUE VA A PAGAR
        // en la puerta. Un solo punto = cero ruido y cero contradicciones.
        // `nowrap`: con totales de 4 cifras el renglón ya no cabe en 375px y, sin esto,
        // el "MXN" caía HUÉRFANO en la línea siguiente. Amarrados, si hay que romper se
        // rompe antes del precio y el importe queda entero ("… COMPRA! -" / "$1,299.00 MXN").
        if (e2.ctaTotal) {
          e2.ctaTotal.innerHTML = '<span class="lb2-cta__monto">' + esc(formatearMoneda(d.total)) +
            ' <span class="lb2-cta__cur">' + esc(lbMonedaTienda()) + '</span></span>';
        }
      }

      // Refresca la card ABIERTA del modal desde el estado VIVO del widget: precio/
      // comparación (data-tier-*-money) + el número del stepper (data-tier-unidades).
      // Muestra/oculta el stepper de cada card según sea la activa+abierta.
      function refrescarCardsAbiertas() {
        if (!e2.tiers) return;
        e2.tiers.querySelectorAll('[data-lb2-tier]').forEach(function (card) {
          var cn = Number(card.getAttribute('data-lb2-tier')) || 1;
          var meta = null;
          for (var i = 0; i < tiersPagina.length; i++) if (tiersPagina[i].n === cn) { meta = tiersPagina[i]; break; }
          var st = card.querySelector('[data-lb2-stepper]');
          var esAbierta = !!(meta && meta.abierto);
          var activa = card.classList.contains('is-active');
          if (st) st.hidden = !(esAbierta && activa);
          if (esAbierta && meta && meta.el) {
            var nowEl = card.querySelector('[data-lb2-now]');
            var wasEl = card.querySelector('[data-lb2-was]');
            var pMoney = meta.el.getAttribute('data-tier-precio-money') || '';
            var cMoney = meta.el.getAttribute('data-tier-comp-money') || '';
            if (nowEl) nowEl.textContent = pMoney;
            if (wasEl) { if (cMoney) { wasEl.textContent = cMoney; wasEl.hidden = false; } else { wasEl.hidden = true; } }
            var nEl = st ? st.querySelector('[data-lb2-step-n]') : null;
            if (nEl) nEl.textContent = String(Number(meta.el.getAttribute('data-tier-unidades')) || meta.min);
          }
        });
      }

      // ── Sincroniza el tier del modal con el widget de la página ─────────────
      function seleccionarTierModal(n) {
        activoN = n;
        // Refleja en las cards del modal.
        if (e2.tiers) {
          e2.tiers.querySelectorAll('[data-lb2-tier]').forEach(function (card) {
            var cn = Number(card.getAttribute('data-lb2-tier')) || 1;
            var on = cn === n;
            card.classList.toggle('is-active', on);
            var radio = card.querySelector('input[type="radio"]');
            if (radio) radio.checked = on;
          });
        }
        // Refleja también en el widget de la página (dispara el mismo selectTier v1
        // por click programático → mantiene qtyInput/precio de la página sincronizados
        // y RESETEA el stepper del tier abierto a su mínimo).
        var ta = tierActivo();
        if (ta && ta.el && !ta.el.classList.contains('is-active')) {
          try { ta.el.click(); } catch (e) {}
        }
        // Estado del stepper (mostrar/ocultar) + precios vivos de la card abierta.
        refrescarCardsAbiertas();
        // Re-lee la selección (variantes por unidad) para el payload.
        currentSel2 = leerSeleccion();
        pintarDesglose();
        // ta.el.click() → selectTier RESETEA el stepper abierto a su mínimo y re-prefilla
        // el bloque de unidades del widget → pintamos el espejo POST-reset.
        pintarUnidadesModal();
      }

      // Aplica un paso al stepper de la card abierta ACTIVA: dispara el − / + del
      // WIDGET (fuente única de verdad; reescribe data-tier-*-money + data-tier-unidades
      // + crece las filas de variante), luego re-lee y re-pinta el modal.
      function pasoStepperModal(delta) {
        var ta = tierActivo();
        if (!ta || !ta.abierto || !ta.el) return;
        var sel = delta < 0 ? '[data-stepper-dec]' : '[data-stepper-inc]';
        var btn = ta.el.querySelector(sel);
        if (btn) { try { btn.click(); } catch (e) {} }
        refrescarCardsAbiertas();
        currentSel2 = leerSeleccion();
        pintarDesglose();
        // El stepper del widget creció/recortó las filas de unidad → re-pinta el espejo.
        pintarUnidadesModal();
      }

      // ── CASO 13/14: espejo de selectores de variante por unidad en el modal ──
      // El WIDGET de la página es la ÚNICA fuente de verdad. El modal pinta una UI
      // ESPEJO (label prominente + un <select> por opción) por cada fila .lb-tier-unit
      // del tier ACTIVO del widget, prefillada con el value actual de cada select del
      // widget. Un cambio en un select del modal se ESCRIBE al select del widget
      // (dispatch 'change' → syncUnitProps del widget) y re-lee la selección para el
      // payload; el espejo NO se re-pinta ahí (evita feedback loop con ese 'change').
      // initBuyBox no es accesible desde aquí → réplicas locales mínimas del gate y del
      // sibling-walk (misma lógica que leerSeleccion js:943-950 / el flag js:262).
      function packsVariantesActivo() { return !!form.querySelector('[data-lb-packs-variantes]'); }
      // FEATURE thumb por-unidad (17-jul) en el ESPEJO del modal. MISMA fuente que el
      // widget (<script data-lb-variant-imgs>). El widget es la verdad: el thumb del
      // espejo se deriva del value ACTUAL de los selects de la fila del widget.
      var modalVariantImgs = {};
      (function () {
        var n = document.querySelector('[data-lb-variant-imgs]');
        if (n) { try { modalVariantImgs = JSON.parse(n.textContent || '{}') || {}; } catch (e) { modalVariantImgs = {}; } }
      })();
      var hasModalVimgs = modalVariantImgs && typeof modalVariantImgs === 'object' && Object.keys(modalVariantImgs).length > 0;
      function unitThumbUrlDeFila(filaWidget) {
        if (!hasModalVimgs || !filaWidget) return '';
        var url = '';
        [].forEach.call(filaWidget.querySelectorAll('[data-unit-select]'), function (sw) {
          if (url) return;
          if (sw.value && modalVariantImgs[sw.value]) url = modalVariantImgs[sw.value];
        });
        return url;
      }
      function unitsBlockActivoWidget() {
        var activeTier = form.querySelector('.lb-tier.is-active') || form.querySelector('.lb-tier');
        if (!activeTier) return null;
        var el = activeTier.nextElementSibling;
        while (el) {
          if (el.hasAttribute && el.hasAttribute('data-tier-units')) return el;
          if (el.classList && el.classList.contains('lb-tier')) return null;
          el = el.nextElementSibling;
        }
        return null;
      }
      function pintarUnidadesModal() {
        if (!e2.units) return;
        var block = packsVariantesActivo() ? unitsBlockActivoWidget() : null;
        var filas = block ? [].slice.call(block.querySelectorAll('.lb-tier-unit')) : [];
        // Sin flag o sin filas (producto de variante única) → oculto, cero comportamiento.
        if (!filas.length) { e2.units.hidden = true; e2.units.innerHTML = ''; return; }
        var lbl0 = filas[0].querySelector('.lb-tier-unit__label');
        var etiquetaBase = lbl0 ? (lbl0.textContent || 'Unidad').replace(/\s*\d+\s*$/, '').trim() : 'Unidad';
        // Plural español simple: vocal→+s, consonante→+es ("Unidad"→"Unidades",
        // "Collar"→"Collares", "Llavero"→"Llaveros") — escéptico 16-jul: +s pelado
        // producía "Unidads".
        var plural = /[aeiouáéíóú]$/i.test(etiquetaBase) ? (etiquetaBase + 's') : (etiquetaBase + 'es');
        var titulo = filas.length >= 2 ? ('Elige tus ' + plural) : ('Elige tu ' + etiquetaBase);
        var html = '<div class="lb2-units__title">' + esc(titulo) + '</div>';
        filas.forEach(function (filaWidget, i) {
          var etiquetaFila = filaWidget.querySelector('.lb-tier-unit__label');
          var etiquetaTxt = etiquetaFila ? (etiquetaFila.textContent || (etiquetaBase + ' ' + (i + 1))).trim() : (etiquetaBase + ' ' + (i + 1));
          var selectsHtml = '';
          [].forEach.call(filaWidget.querySelectorAll('[data-unit-select]'), function (sw, j) {
            var optName = sw.getAttribute('data-option-name') || '';
            var cur = sw.value || '';
            var opts = '';
            [].forEach.call(sw.options, function (o) {
              opts += '<option value="' + esc(o.value) + '"' + (o.value === cur ? ' selected' : '') + '>' + esc(o.textContent) + '</option>';
            });
            selectsHtml += '<select class="lb2-unit__select" data-lb2-unit-select data-unit-row="' + i + '" data-unit-opt="' + j + '" aria-label="' + esc(optName + ' — ' + etiquetaTxt) + '">' + opts + '</select>';
          });
          // Thumb de la fila = foto del valor de color actual (fuente: selects del widget).
          var thumbUrl = unitThumbUrlDeFila(filaWidget);
          var thumbHtml = hasModalVimgs
            ? ('<img class="lb2-unit__thumb" alt="" aria-hidden="true"' + (thumbUrl ? (' src="' + esc(thumbUrl) + '"') : ' hidden') + '>')
            : '';
          html += '<div class="lb2-unit" data-lb2-unit="' + i + '">' +
                    '<span class="lb2-unit__head">' + thumbHtml + '<span class="lb2-unit__label">' + esc(etiquetaTxt) + '</span></span>' +
                    '<span class="lb2-unit__selects">' + selectsHtml + '</span>' +
                  '</div>';
        });
        e2.units.innerHTML = html;
        e2.units.hidden = false;
        // Cablear los selects del espejo → escriben al WIDGET (fuente de verdad).
        [].forEach.call(e2.units.querySelectorAll('[data-lb2-unit-select]'), function (sm) {
          sm.addEventListener('change', function () {
            var b = packsVariantesActivo() ? unitsBlockActivoWidget() : null;
            if (!b) return;
            var filaW = b.querySelectorAll('.lb-tier-unit')[Number(sm.getAttribute('data-unit-row'))];
            if (!filaW) return;
            var selW = filaW.querySelectorAll('[data-unit-select]')[Number(sm.getAttribute('data-unit-opt'))];
            if (!selW) return;
            selW.value = sm.value;
            try { selW.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
            currentSel2 = leerSeleccion(); // re-lee variantesPorUnidad para el payload
            pintarDesglose();
            // Refresca el thumb LOCAL del espejo (el del widget ya se actualizó por el
            // 'change' despachado arriba). Fuente: la fila del widget (ya con el value nuevo).
            var cont = sm.closest ? sm.closest('.lb2-unit') : null;
            var img = cont ? cont.querySelector('.lb2-unit__thumb') : null;
            if (img) {
              var u = unitThumbUrlDeFila(filaW);
              if (u) { img.setAttribute('src', u); img.removeAttribute('hidden'); }
              else { img.removeAttribute('src'); img.setAttribute('hidden', ''); }
            }
            // NO re-pintar el espejo aquí: el value ya está en este select y evita el
            // feedback loop con el 'change' que acabamos de despachar al widget.
          });
          // Un click en el select NO debe burbujear (namespaced dentro del overlay).
          sm.addEventListener('click', function (ev) { ev.stopPropagation(); });
        });
      }

      // ── FASE B (26-jul): tarjetas PREMIUM de upsell tick ────────────────────
      // El dueño llamó MEDIOCRE al recuadro chiquito de la app anterior (.lb2-tick:
      // 64px de foto, checkbox 22px, precio en negrita dentro del título). Esta es la
      // versión buena: FOTO GRANDE 92px con anillo dorado y sello de % de ahorro,
      // título bold, línea de beneficio, precio grande en el acento de marca con el
      // comparativo TACHADO al lado, y un check GRANDE (30px, área táctil 44px) que
      // al marcarse enciende toda la tarjeta.
      // UNA sola fuente de markup para las DOS ubicaciones dictadas: (a) en la landing
      // tras el bloque de packs/2x1, (b) en el overlay tras la Nota, antes de FINALIZAR.
      // El checkbox escribe en ticksState (fuente de verdad) y se refleja en TODOS los
      // checkboxes gemelos → mismo estado de checks en landing y overlay.

      // % de ahorro DERIVADO de comparacion vs precio, con FLOOR (regla del dueño:
      // jamás prometer más descuento del real; 62.58% → "62%"). Sin comparación
      // válida (ausente, <= precio, o precio 0) → 0 = no se pinta sello.
      function tickAhorroPct(t) {
        var precio = Number(t.precio) || 0;
        var comp = Number(t.comparacion) || 0;
        if (!(comp > precio) || !(precio > 0)) return 0;
        var pct = Math.floor((1 - (precio / comp)) * 100);
        return (pct > 0 && pct < 100) ? pct : 0;
      }
      // ── CASO 1A + CASO 4 (dueño 28-jul) · el bloque pasa a ser PROTAGONISTA ──
      //   "Los productos adicionales son muy pequeños, poco llamativos… hacerlo más
      //    llamativo, SIMILAR A COMO SE HACEN LOS DESCUENTOS ARRIBA" + "textos más
      //    grandes, que me parecen muy pequeños".
      //   La referencia que él mismo dio son las tarjetas de descuento (.lb-tier) que
      //   están justo encima: píldora que sobresale del borde, borde de marca SIEMPRE,
      //   precio grande y —lo que más le gustó— la tarjeta ENTERA se tiñe al elegirla.
      //   Cambios de estructura respecto de FASE B:
      //     · La fila (foto + textos) y el CHECK se separan: el check deja de ser una
      //       columna angosta a la derecha y pasa a ser una BARRA de ancho completo
      //       ("Agregar a mi pedido" / "✓ Agregado a tu pedido"). El dueño diagnosticó
      //       el problema exacto: "el casillero de la derecha es un cuadro vacío que no
      //       invita a tocarse". Además libera ~50px de ancho para el texto → el título
      //       y el precio pueden crecer sin romper a 375px.
      //     · Píldora de oferta (.lb2-tickcard__flag) sobresaliendo del borde superior,
      //       misma gramática que .lb-tier__popular.
      //   ⚠️ El <label> sigue envolviendo TODO → tocar cualquier parte de la tarjeta
      //   marca/desmarca. El contrato con el server (data-lb-tick-idx = índice REAL
      //   del array del metafield) NO se toca.
      //
      // ── CASO 4 · encabezado y línea de calidad CABLEADOS ────────────────────
      //   El dueño pidió un encabezado más llamativo y "aclarar que todo es acero
      //   inoxidable más baño de oro 18K… en toda la colección", y sobre todo que
      //   quede CABLEADO para los productos que vengan.
      //   Contrato que lee este render (lo escribe el generador en landing.data):
      //     upsellTickBloque: { titulo, subtitulo, calidad }
      //   Alias equivalentes (por si el generador prefiere claves planas):
      //     upsellTickTitulo · upsellTickSubtitulo · upsellTickCalidad
      //   🔒 REGLA DE MATERIALES HONESTOS: `calidad` NO tiene valor por defecto. Es
      //   una afirmación sobre el producto físico y el cliente COD abre el paquete
      //   antes de pagar: si el metafield no la trae, la línea NO se pinta. Jamás se
      //   inventa aquí un material. (titulo/subtitulo sí tienen default: son copy de
      //   oferta, no una afirmación verificable.)
      function textoCfg(v) {
        return (typeof v === 'string' && v.trim()) ? v.trim() : '';
      }
      var tickBloque = (cfg.upsellTickBloque && typeof cfg.upsellTickBloque === 'object')
        ? cfg.upsellTickBloque : {};
      var tickBloqueTitulo = textoCfg(tickBloque.titulo) || textoCfg(cfg.upsellTickTitulo);
      var tickBloqueSub = textoCfg(tickBloque.subtitulo) || textoCfg(cfg.upsellTickSubtitulo);
      var tickBloqueCalidad = textoCfg(tickBloque.calidad) || textoCfg(cfg.upsellTickCalidad);

      function tickCardHtml(t, i) {
        var on = ticksState[i] === true;
        var precio = Number(t.precio) || 0;
        var comp = Number(t.comparacion) || 0;
        var pct = tickAhorroPct(t);
        // Píldora de la tarjeta (sobresale del borde, como "Más popular" del tier):
        // el `badge` del metafield manda; si no hay, el % de ahorro DERIVADO (floor).
        var flag = (t.badge && String(t.badge).trim())
          ? String(t.badge).trim()
          : (pct > 0 ? '-' + pct + '% HOY' : '');
        // Si hay badge Y hay % derivado, el % sigue viviendo sobre la foto (no se
        // pierde información: uno va arriba, el otro sobre la imagen).
        var sello = (t.badge && String(t.badge).trim() && pct > 0) ? '-' + pct + '%' : '';
        var media = t.imagen
          ? '<span class="lb2-tickcard__media">' +
              '<img class="lb2-tickcard__img" src="' + esc(t.imagen) + '" alt="" loading="lazy" width="104" height="104">' +
              (sello ? '<span class="lb2-tickcard__off">' + esc(sello) + '</span>' : '') +
            '</span>'
          : '';
        // Precio: acento grande + comparativo tachado. Gratis (precio 0) → verde.
        var precioHtml = precio > 0
          ? '<span class="lb2-tickcard__now">+' + esc(formatearMoneda(precio)) + '</span>' +
            (comp > precio ? '<span class="lb2-tickcard__was">' + esc(formatearMoneda(comp)) + '</span>' : '')
          : '<span class="lb2-tickcard__now lb2-tickcard__now--free">GRATIS</span>';
        var etiquetaAria = 'Agregar ' + (t.titulo || 'extra') +
          (precio > 0 ? ' por ' + formatearMoneda(precio) : ' gratis');
        return '<label class="lb2-tickcard' + (on ? ' is-on' : '') + '" data-lb-tickcard="' + i + '">' +
          (flag ? '<span class="lb2-tickcard__flag">' + esc(flag) + '</span>' : '') +
          '<span class="lb2-tickcard__row">' +
            media +
            '<span class="lb2-tickcard__body">' +
              '<span class="lb2-tickcard__title">' + esc(t.titulo) + '</span>' +
              (t.texto ? '<span class="lb2-tickcard__desc">' + esc(t.texto) + '</span>' : '') +
              '<span class="lb2-tickcard__prices">' + precioHtml + '</span>' +
            '</span>' +
          '</span>' +
          // BARRA de acción: el <input> real queda transparente ENCIMA de toda la barra
          // (objetivo táctil enorme) y .lb2-tickcard__box dibuja el ✓ con CSS → se ve
          // igual en iOS/Android/desktop, sin depender de accent-color.
          '<span class="lb2-tickcard__check">' +
            '<input type="checkbox" data-lb-tick-idx="' + i + '"' + (on ? ' checked' : '') +
              ' aria-label="' + esc(etiquetaAria) + '">' +
            '<span class="lb2-tickcard__box" aria-hidden="true"></span>' +
            '<span class="lb2-tickcard__cta" aria-hidden="true">' +
              '<span class="lb2-tickcard__cta-off">Agregar a mi pedido</span>' +
              '<span class="lb2-tickcard__cta-on">Agregado a tu pedido</span>' +
            '</span>' +
          '</span>' +
        '</label>';
      }
      function ticksBlockHtml(inline) {
        var cuantos = ticksCuantos();
        if (!cuantos) return '';
        var cards = '';
        // Se recorre por ÍNDICE REAL (los huecos inválidos se saltan sin renumerar).
        ticks2.forEach(function (t, i) { if (tickValido(t)) cards += tickCardHtml(t, i); });
        var titulo = tickBloqueTitulo ||
          ((cuantos > 1) ? 'Completa tu colección' : 'Agrega a tu pedido');
        var sub = tickBloqueSub || 'Solo con tu pedido de hoy · se suma al mismo envío GRATIS';
        return '<div class="lb2-ticks lb2-ticks--v3' + (inline ? ' lb2-ticks--inline' : '') + '" data-lb2-ticks>' +
          '<div class="lb2-ticks__head">' +
            '<span class="lb2-ticks__t">✨ ' + esc(titulo) + '</span>' +
            '<span class="lb2-ticks__s">' + esc(sub) + '</span>' +
            // Línea de calidad: SOLO si el metafield la trae (regla de honestidad).
            (tickBloqueCalidad
              ? '<span class="lb2-ticks__cal"><span class="lb2-ticks__cal-ico" aria-hidden="true">✦</span>' +
                  esc(tickBloqueCalidad) + '</span>'
              : '') +
          '</div>' + cards + '</div>';
      }
      // Escribe en la FUENTE DE VERDAD y refleja en todos los checkboxes gemelos
      // (landing + overlay). Si el overlay ya existe, repinta desglose y CTA.
      function setTickState(i, on) {
        ticksState[i] = on === true;
        document.querySelectorAll('[data-lb-tick-idx="' + i + '"]').forEach(function (cb) {
          if (cb.checked !== ticksState[i]) cb.checked = ticksState[i];
          var card = cb.closest ? cb.closest('.lb2-tickcard') : null;
          if (card) card.classList.toggle('is-on', ticksState[i] === true);
        });
        if (overlay2) pintarDesglose();
        // CASO 2: el botón de la PÁGINA se mueve AL INSTANTE con cada casilla.
        lbRepintarSticky();
      }
      function wireTicks(container) {
        if (!container) return;
        container.querySelectorAll('[data-lb-tick-idx]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            setTickState(Number(cb.getAttribute('data-lb-tick-idx')) || 0, cb.checked);
          });
        });
      }
      // Ubicación (a): tarjetas EN la landing, bajo el bloque de packs. Si el theme
      // (snippet offers-inline) ya pintó [data-lb-tickcards] en Liquid, se RE-RENDERIZA
      // por JS (markup/estado garantizados idénticos al overlay); si no existe (p.ej.
      // template landing-buda-main), se INYECTA después de .lb-packs — el nodo del
      // form/packs existe en el DOM de la landing. aplicarSkin pone los tokens --lb2-*
      // también fuera del overlay (las cards usan el skin de marca en ambos contextos).
      function initTicksPagina() {
        if (!ticksCuantos()) return;
        var cont = document.querySelector('[data-lb-tickcards]');
        if (!cont) {
          // Sin ancla del theme: inyectamos justo DESPUÉS del bloque de packs/2x1
          // (ubicación dictada). Si la landing no tiene packs, caemos a "justo antes
          // del CTA" — nunca queda huérfano al final del <body>.
          var ancla = form.querySelector('.lb-packs');
          var cta = form.querySelector('[data-lb-cod-cta]');
          cont = document.createElement('div');
          cont.setAttribute('data-lb-tickcards', '');
          if (ancla && ancla.parentNode) ancla.parentNode.insertBefore(cont, ancla.nextSibling);
          else if (cta && cta.parentNode) cta.parentNode.insertBefore(cont, cta);
          else return;
        }
        cont.innerHTML = ticksBlockHtml(true);
        // ⚠️ AQUÍ **NO** se llama aplicarSkin(): el skin es el del MODAL (codSkin, que
        // en el Sagrado es CLARO) y pintaría tarjetas cremas sobre el altar OSCURO de
        // la landing. El bloque .lb2-ticks--inline remapea los --lb2-* a los tokens de
        // MARCA de la página (--lb-*) por CSS → las tarjetas hablan el idioma de los
        // packs que tienen justo encima. El overlay sí usa aplicarSkin (su casa).
        wireTicks(cont);
      }

      // ── Construcción del overlay v2 ─────────────────────────────────────────
      function buildOverlay2() {
        if (overlay2) return overlay2;
        tiersPagina = leerTiersPagina();
        var thumb = thumbProducto();

        overlay2 = document.createElement('div');
        overlay2.className = 'lb2-overlay';
        overlay2.setAttribute('data-lb2-overlay', '');
        overlay2.hidden = true;
        aplicarSkin(overlay2);

        // Cards de tier del modal. El tier ABIERTO lleva su propio stepper (− N +)
        // que aparece SOLO cuando la card está seleccionada (seleccionarTierModal), con
        // min/cap del widget. Los nodos de precio llevan [data-lb2-now]/[data-lb2-was]
        // para refrescarlos en vivo al mover el stepper.
        var tiersHtml = tiersPagina.map(function (t) {
          var thumbHtml = thumb ? '<span class="lb2-tier__thumb"><img src="' + esc(thumb) + '" alt=""></span>' : '';
          var badgeHtml = t.badge ? '<span class="lb2-tier__badge">' + esc(t.badge) + '</span>' : '';
          var wasHtml = '<span class="lb2-tier__was" data-lb2-was' + (t.compMoney ? '' : ' hidden') + '>' + esc(t.compMoney || '') + '</span>';
          // El ahorro del modal se COPIA de la card de la página (no se recalcula):
          // una sola fuente, así el formulario no puede prometer un descuento distinto
          // al que el cliente acaba de ver arriba. Si la card no lo trae, aquí tampoco.
          var saveSrc = t.el ? t.el.querySelector('[data-lb-save]') : null;
          var saveAmtEl = saveSrc ? saveSrc.querySelector('[data-lb-save-amt]') : null;
          var savePctEl = saveSrc ? saveSrc.querySelector('[data-lb-save-pct]') : null;
          var saveHtml = saveSrc
            ? '<span class="lb2-tier__meta" data-lb2-save>' +
                '<span class="lb2-tier__save-amt" data-lb2-save-amt>' + esc(saveAmtEl ? (saveAmtEl.textContent || '').trim() : '') + '</span>' +
                (savePctEl && !savePctEl.hidden
                  ? '<span class="lb2-tier__save-pct" data-lb2-save-pct>' + esc((savePctEl.textContent || '').trim()) + '</span>'
                  : '') +
              '</span>'
            : '';
          var stepperHtml = t.abierto
            ? '<div class="lb2-stepper" data-lb2-stepper data-lb2-min="' + t.min + '" data-lb2-cap="' + t.cap + '" hidden>' +
                '<button type="button" class="lb2-stepper__btn" data-lb2-step-dec aria-label="Quitar una unidad">−</button>' +
                '<span class="lb2-stepper__n" data-lb2-step-n aria-live="polite">' + t.min + '</span>' +
                '<button type="button" class="lb2-stepper__btn" data-lb2-step-inc aria-label="Agregar una unidad">+</button>' +
                '<span class="lb2-stepper__lbl">unidades</span>' +
              '</div>'
            : '';
          return '<label class="lb2-tier' + (t.abierto ? ' lb2-tier--abierto' : '') + '" data-lb2-tier="' + t.n + '">' +
            '<input type="radio" name="lb2-pack" value="' + t.n + '">' +
            '<span class="lb2-tier__radio"></span>' +
            thumbHtml +
            '<span class="lb2-tier__mid"><span class="lb2-tier__name">' + esc(t.label) + '</span>' + badgeHtml + stepperHtml + '</span>' +
            '<span class="lb2-tier__right"><span class="lb2-tier__now" data-lb2-now>' + esc(t.precioMoney) + '</span>' + wasHtml + '</span>' +
            saveHtml +
          '</label>';
        }).join('');

        // Tarjetas de upsell tick (FASE B): van DENTRO del form, tras la Nota y antes
        // de FINALIZAR (ubicación dictada). El markup sale del renderer compartido
        // (tickCardHtml) — idéntico al de las cards de la landing.
        var tickHtml = ticksBlockHtml(false);

        // campo() — layout LABELS ARRIBA (réplica app Releasit, corrección dueño 2026-07-11):
        //   <label.lb2-field data-lb2-field=NAME>
        //     <span.lb2-label>Label <b.lb2-req>*</b></span>   ← label ARRIBA, bold, asterisco rojo
        //     <span.lb2-input …>[icon-box negra/gris]? control</span>  ← control a ancho completo
        //   </label>
        // INPUTS/TEXTAREA: icon-box a la izquierda (fondo gris claro, ícono NEGRO). SELECTS:
        // SIN icon-box (icon === null) → .lb2-input--select con chevron custom por CSS
        // (appearance:none + SVG). El estado de error (.lb2-field--error) se ajusta a este
        // layout en el CSS: borde rojo del control + label/asterisco rojos.
        function campo(name, label, req, tipo, icon) {
          var esSelect = (icon == null);
          var inner = esSelect
            ? tipo                                              // select: control desnudo (chevron por CSS)
            : '<i class="lb2-ic">' + icon + '</i>' + tipo;      // input/textarea: cajita de ícono + control
          return '<label class="lb2-field" data-lb2-field="' + esc(name) + '">' +
            '<span class="lb2-label">' + esc(label) + (req ? ' <b class="lb2-req">*</b>' : '') + '</span>' +
            '<span class="lb2-input' + (esSelect ? ' lb2-input--select' : '') + '">' + inner + '</span>' +
          '</label>';
        }
        var selPh = '<option value="">Selecciona…</option>';

        overlay2.innerHTML =
          // A5 (ronda 6.5): el backdrop YA NO lleva data-lb2-close — click fuera NO
          // cierra (Releasit tampoco). ✕ y Escape siguen cerrando (y con la cadena en
          // vuelo caen en el path A1: enviar la orden, no abortarla).
          '<div class="lb2-backdrop"></div>' +
          '<div class="lb2-panel" role="dialog" aria-modal="true" aria-label="Pago contra entrega">' +
            '<button type="button" class="lb2-x" data-lb2-close aria-label="Cerrar">×</button>' +
            '<div class="lb2-body" data-lb2-formwrap>' +
              '<div class="lb2-head">' +
                '<h2 class="lb2-h2">PAGO CONTRA ENTREGA 🚚' + esc(lbPaisCod()) + '</h2>' +
                '<p class="lb2-sub">LLENA TUS DATOS FÁCIL Y REALIZA UNA COMPRA GARANTIZADA</p>' +
                '<p class="lb2-oferta">¡OBTENER OFERTA!</p>' +
              '</div>' +
              (tiersHtml ? '<div class="lb2-tiers" data-lb2-tiers>' + tiersHtml + '</div>' : '') +
              // CASO 13/14: espejo de selectores de variante por unidad (pintarUnidadesModal
              // lo llena por JS desde el WIDGET). Vive DENTRO de [data-lb2-formwrap] entre
              // tiers y resumen → la cadena flash que oculta el formwrap lo oculta con él.
              '<div class="lb2-units" data-lb2-units hidden></div>' +
              '<div class="lb2-resumen" data-lb2-resumen></div>' +
              '<div class="lb2-banner">¡Genial! Tu envío es GRATIS 🎉</div>' +
              '<form class="lb2-form" data-lb2-form novalidate>' +
                campo('nombre', 'Nombre', true, '<input type="text" name="nombre" placeholder="Nombre" autocomplete="given-name" required>', ICON.persona) +
                campo('apellido', 'Apellido', true, '<input type="text" name="apellido" placeholder="Apellido" autocomplete="family-name" required>', ICON.persona) +
                // A4 (ronda 6.5): autocomplete='tel-national' (el autofill del navegador
                // ofrece el número SIN +52) y SIN maxlength — el saneo en la entrada
                // (sanearWhatsApp2) deja solo los 10 dígitos nacionales aunque peguen
                // '+52 1 55 1234 5678' (un maxlength=10 TRUNCABA el pegado antes de sanear).
                campo('whatsapp', 'WhatsApp', true, '<input type="tel" name="whatsapp" placeholder="10 Dígitos (sin el +52)" inputmode="numeric" autocomplete="tel-national" required>', ICON.tel) +
                // SELECTS sin icon-box (icon=null → chevron custom por CSS). Placeholder = 1ª opción
                // ("Estado", "Municipio/Delegación", "Código postal") en negrita oscura (réplica app).
                campo('estado', 'Estado', true, '<select name="estado" data-lb2-estado required><option value="">Estado</option></select>', null) +
                campo('municipio', 'Municipio / Alcaldía', true, '<select name="municipio" data-lb2-municipio required disabled><option value="">Municipio / Delegación</option></select>', null) +
                '<p class="lb2-cobertura">Si tu código postal NO aparece en las opciones siguientes, es porque no tenemos cobertura.</p>' +
                campo('cp', 'Código postal', true, '<select name="cp" data-lb2-cp required disabled><option value="">Código postal</option></select>', null) +
                // COLONIA v2: INPUT de texto (no cascada) — sin fetch de colonias del CP.
                // El PATH v1 conserva su <select> en cascada. datosDelForm2 la lee igual.
                // OBLIGATORIA (corrección dueño 2026-07-11): asterisco rojo + validación cliente + server.
                campo('colonia', 'Colonia', true, '<input type="text" name="colonia" placeholder="Colonia" autocomplete="address-level3" required>', ICON.pin) +
                campo('direccion', 'Dirección', true, '<input type="text" name="direccion" placeholder="Calle, número y referencias" autocomplete="street-address" required>', ICON.pinmas) +
                campo('email', 'Correo', false, '<input type="email" name="email" placeholder="Correo electrónico (opcional)" autocomplete="email">', ICON.arroba) +
                campo('nota', 'Nota', false, '<textarea name="nota" rows="2" placeholder="Nota del pedido (opcional)"></textarea>', ICON.nota) +
                // FASE B (ubicación dictada b): las tarjetas de upsell tick van AQUÍ —
                // tras la Nota, antes del botón FINALIZAR. Los checkboxes no llevan
                // `name` → no ensucian datosDelForm2 ni el submit.
                tickHtml +
                '<div class="lb2-hp" aria-hidden="true"><label>No llenar<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
                '<div class="lb2-error" data-lb2-error hidden></div>' +
                '<button type="submit" class="lb2-cta" data-lb2-submit>' +
                  '<span class="lb2-cta__l1">🚚 ¡FINALIZA TU COMPRA! - <span data-lb2-cta-total></span></span>' +
                  '<span class="lb2-cta__l2">' + esc(lbSubPago()) + '</span>' +
                '</button>' +
              '</form>' +
            '</div>' +
            '<div class="lb2-thanks" data-lb2-thanks hidden></div>' +
            '<div class="lb2-flash" data-lb2-flash hidden></div>' +
          '</div>';

        document.body.appendChild(overlay2);

        e2.panel = overlay2.querySelector('.lb2-panel');
        e2.formwrap = overlay2.querySelector('[data-lb2-formwrap]');
        e2.tiers = overlay2.querySelector('[data-lb2-tiers]');
        e2.resumen = overlay2.querySelector('[data-lb2-resumen]');
        e2.units = overlay2.querySelector('[data-lb2-units]'); // CASO 13/14: espejo por-unidad
        e2.form = overlay2.querySelector('[data-lb2-form]');
        e2.estado = overlay2.querySelector('[data-lb2-estado]');
        e2.municipio = overlay2.querySelector('[data-lb2-municipio]');
        e2.cp = overlay2.querySelector('[data-lb2-cp]');
        // v2: colonia es un <input> de texto (sin cascada) → se lee por [name="colonia"] en datosDelForm2.
        e2.error = overlay2.querySelector('[data-lb2-error]');
        e2.submit = overlay2.querySelector('[data-lb2-submit]');
        e2.ctaTotal = overlay2.querySelector('[data-lb2-cta-total]');
        e2.thanks = overlay2.querySelector('[data-lb2-thanks]');
        e2.flash = overlay2.querySelector('[data-lb2-flash]');

        // Cerrar
        overlay2.querySelectorAll('[data-lb2-close]').forEach(function (c) { c.addEventListener('click', closeOverlay2); });
        document.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape' && overlay2 && !overlay2.hidden) closeOverlay2();
        });
        // Candado de scroll iOS (fix móvil #2): el touchmove FUERA del panel (sobre el
        // backdrop) mueve la página de atrás en iOS → preventDefault. Dentro del panel
        // se deja pasar (el panel scrollea con -webkit-overflow-scrolling). El listener
        // es no-pasivo a propósito (preventDefault requiere passive:false).
        var bd = overlay2.querySelector('.lb2-backdrop');
        if (bd) {
          bd.addEventListener('touchmove', function (ev) {
            try { ev.preventDefault(); } catch (e) {}
          }, { passive: false });
        }

        // Radios de tier del modal.
        if (e2.tiers) {
          e2.tiers.querySelectorAll('[data-lb2-tier]').forEach(function (card) {
            card.addEventListener('click', function () {
              seleccionarTierModal(Number(card.getAttribute('data-lb2-tier')) || 1);
            });
          });
          // Stepper del tier abierto en el modal: − / +. stopPropagation → el clic NO
          // burbujea al label (que re-seleccionaría el tier y reseteato a min).
          e2.tiers.querySelectorAll('[data-lb2-stepper]').forEach(function (st) {
            var dec = st.querySelector('[data-lb2-step-dec]');
            var inc = st.querySelector('[data-lb2-step-inc]');
            if (dec) dec.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); pasoStepperModal(-1); });
            if (inc) inc.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); pasoStepperModal(+1); });
          });
        }
        // Ticks del overlay: escriben al estado compartido (setTickState repinta el
        // desglose/CTA y sincroniza las cards gemelas de la landing).
        wireTicks(overlay2);

        wireCascada2();
        // Limpieza inmediata del estado de error al escribir/cambiar (fix móvil #2).
        wireLimpiezaErrores();
        // A4 (ronda 6.5): saneo del WhatsApp EN LA ENTRADA — solo dígitos, strip del
        // prefijo 52/521/+52 → quedan los 10 nacionales. Pegar '+52 1 55 1234 5678'
        // deja '5512345678'. Solo re-asigna si cambió (no rompe el caret al teclear).
        var waCtrl2 = e2.form.querySelector('[name="whatsapp"]');
        if (waCtrl2) {
          waCtrl2.addEventListener('input', function () {
            var limpio = sanearWhatsApp2(waCtrl2.value);
            if (String(waCtrl2.value || '') !== limpio) waCtrl2.value = limpio;
          });
        }

        e2.form.addEventListener('submit', function (ev) { ev.preventDefault(); onSubmit2(); });

        return overlay2;
      }

      // ── Abrir / cerrar ──────────────────────────────────────────────────────
      function openOverlay2() {
        lbSalud('apertura');
        buildOverlay2();
        enviado2 = false;
        aceptados = [];
        // Reabrió el formulario: lo que aceptó antes se borró → si reintenta, la cadena corre.
        if (reintento2) reintento2.cadenaHecha = false;
        cadenaAbortada = false;
        procesando2 = false;
        datosPendientes2 = null;   // A1: sin FINALIZAR válido aún, nada que flushear
        postEnVuelo2 = false;
        limpiarTimers();
        currentSel2 = leerSeleccion();
        // Sincroniza el tier activo con el que la página tiene marcado.
        var actEl = form.querySelector('.lb-tier.is-active') || form.querySelector('.lb-tier');
        var nInit = actEl ? (Number(actEl.getAttribute('data-tier-n')) || 1) : (tiersPagina[0] ? tiersPagina[0].n : 1);
        e2.formwrap.hidden = false;
        e2.thanks.hidden = true; e2.thanks.innerHTML = '';
        e2.flash.hidden = true; e2.flash.innerHTML = '';
        e2.error.hidden = true;
        limpiarErroresCampos(); // sin estado de error residual de una apertura previa (fix móvil #2)
        e2.submit.disabled = false;
        e2.submit.classList.remove('is-loading');
        seleccionarTierModal(nInit);
        pintarUnidadesModal(); // CASO 13/14: espejo por-unidad al abrir (idempotente)
        cargarEstados2();
        overlay2.hidden = false;
        // Sticky adhesivo: ocúltalo mientras el overlay está abierto (corrección dueño).
        ocultarStickyOffers();
        // Candado de scroll iOS (fix móvil #2): fija el body en su posición.
        bloquearScrollIOS();
        // El panel SIEMPRE abre arriba del todo (fix móvil #1): se ve el header
        // "PAGO CONTRA ENTREGA…" + las ofertas, nunca a mitad del formulario.
        if (e2.panel) { try { e2.panel.scrollTop = 0; } catch (e) {} }
        // Foco al primer campo SOLO en desktop (fix móvil #1): en iOS focus()
        // abre el teclado y "aterriza" al cliente a mitad del form → se pierde.
        if (!esMovilAncho(900)) {
          var first = e2.form.querySelector('input[name="nombre"]');
          if (first) { try { first.focus(); } catch (e) {} }
        }
        // A2 (ronda 6.5): Meta Pixel — InitiateCheckout al abrir el checkout COD,
        // con el total actual del desglose. Sin fbq (harness/tests) → silencio total.
        if (typeof fbq === 'function') {
          try { fbq('track', 'InitiateCheckout', { currency: lbMonedaTienda(), value: calcDesglose().total }); } catch (e) {}
        } else {
          // Velocidad 21-oct: con el botón conectado ANTES de DOMContentLoaded, el
          // formulario puede abrirse antes de que exista el pixel (fbq llega con
          // fbevents.js, medido ~DOMContentLoaded). El evento no se pierde: sale en
          // cuanto fbq exista (una vez por apertura, con el total de ESTE momento).
          var icValor = 0;
          try { icValor = calcDesglose().total; } catch (e) {}
          lbCuandoFbq(function () { fbq('track', 'InitiateCheckout', { currency: lbMonedaTienda(), value: icValor }); });
        }
      }

      function closeOverlay2() {
        if (!overlay2) return;
        // A1 (ronda 6.5): si el cliente YA pulsó FINALIZAR con datos válidos y la
        // orden aún no salió (cadena de upsells corriendo o a medio camino), cerrar
        // (✕/Escape) NO aborta la orden: se envía con los upsells aceptados hasta
        // este momento y se muestra la pantalla de gracias. El overlay se queda
        // abierto ("Enviando…" → gracias). El "No, gracias" y el timer-cero NO
        // pasan por aquí: siguen avanzando la cadena normal.
        if (cadenaEnVuelo2()) {
          limpiarTimers();
          onCadenaFin = null;
          restaurarFormFullscreen(); // móvil: vuelve a mostrar el form (con "Enviando…")
          if (e2.flash) { e2.flash.hidden = true; e2.flash.classList.remove('lb2-flash--full'); }
          devolverFlashAlPanel();
          enviarOrden2(datosPendientes2);
          return;
        }
        // A3 (ronda 6.5): cierre SIN orden en vuelo → si ya escribió un WhatsApp
        // válido (10 dígitos), reporta el parcial YA (no solo al morir la página).
        // Va ANTES de ocultar el overlay (reportarParcial2 exige overlay abierto).
        try { reportarParcial2(); } catch (e) {}
        overlay2.hidden = true;
        // MATA todos los timers y aborta la cadena SIN enviar orden.
        cadenaAbortada = true;
        procesando2 = false;
        limpiarTimers();
        onCadenaFin = null;
        flashFullscreen = false;
        if (e2.flash) { e2.flash.hidden = true; e2.flash.classList.remove('lb2-flash--full'); }
        devolverFlashAlPanel();
        if (e2.formwrap) e2.formwrap.hidden = false; // deja el form listo para la próxima apertura
        // Restaura el scroll de la página al punto exacto (fix móvil #2/#7).
        restaurarScrollIOS();
        // Sticky adhesivo: re-muéstralo al cerrar el overlay (corrección dueño).
        mostrarStickyOffers();
      }

      // ── Saneo del WhatsApp (A4, ronda 6.5) ──────────────────────────────────
      // Solo dígitos; si sobran 10 y empieza con el prefijo de México (521 del
      // formato WhatsApp o 52 del E.164), se lo quitamos → 10 nacionales. Corta a 10
      // (reemplaza al maxlength que truncaba pegados con prefijo).
      function sanearWhatsApp2(valor) {
        var dig = String(valor == null ? '' : valor).replace(/\D/g, '');
        if (dig.length > 10 && dig.slice(0, 3) === '521') dig = dig.slice(3);
        else if (dig.length > 10 && dig.slice(0, 2) === '52') dig = dig.slice(2);
        return dig.slice(0, 10);
      }

      // ── Datos + validación (idénticos a v1) ────────────────────────────────
      function datosDelForm2() {
        var f = e2.form;
        var get = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? String(el.value || '').trim() : ''; };
        return {
          nombre: get('nombre'), apellido: get('apellido'),
          whatsapp: get('whatsapp').replace(/\D/g, '').slice(-10),
          estado: get('estado'), municipio: get('municipio'), cp: get('cp'), colonia: get('colonia'),
          direccion: get('direccion'), email: get('email'), nota: get('nota'),
          website: get('website'),
        };
      }
      // Validación VISIBLE por campo (corrección dueño 2026-07-11): en vez de una sola
      // línea genérica, recolecta TODOS los faltantes/ inválidos y devuelve
      // { faltantes:[{name, label}], emailMalo:bool }. onSubmit2 pinta cada campo en rojo,
      // hace auto-scroll al primero y arma "Te faltan estos datos: …". Orden = orden visual
      // del form (incluye la cascada estado/municipio/cp). El server revalida TODO.
      // A6 (ronda 6.5): cada faltante lleva su MENSAJE inline (aparece debajo del
      // campo en rojo, doble señal junto al mensaje global — como Releasit):
      // vacíos → 'Este dato es obligatorio'; WhatsApp con formato malo → sus 10
      // dígitos; correo malo → 'Revisa tu correo'.
      var MSG_OBLIGATORIO = 'Este dato es obligatorio';
      function validarCliente2(d) {
        var faltantes = [];
        var add = function (name, label, msg) { faltantes.push({ name: name, label: label, msg: msg || MSG_OBLIGATORIO }); };
        if (!d.nombre) add('nombre', 'Nombre');
        if (!d.apellido) add('apellido', 'Apellido');
        if (!/^\d{10}$/.test(d.whatsapp)) {
          add('whatsapp', 'WhatsApp (10 dígitos)', d.whatsapp ? 'Escribe tus 10 dígitos de WhatsApp' : MSG_OBLIGATORIO);
        }
        if (!d.estado) add('estado', 'Estado');
        if (!d.municipio) add('municipio', 'Municipio');
        if (!d.cp) add('cp', 'Código postal');
        if (!d.colonia) add('colonia', 'Colonia');
        if (!d.direccion) add('direccion', 'Dirección');
        var emailMalo = !!(d.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.email));
        if (emailMalo) add('email', 'Correo', 'Revisa tu correo');
        return { faltantes: faltantes, emailMalo: emailMalo };
      }
      function showError2(msg) { if (e2.error) { e2.error.textContent = msg; e2.error.hidden = false; } }
      // (22-oct) Tras un envío que no salió, el aviso vive JUSTO encima del botón: los dos
      // tienen que quedar a la vista. `restaurarFormFullscreen` sube el panel arriba del todo
      // (scrollTop = 0) y, en el celular, dejaba el aviso y el botón fuera de la pantalla.
      function verBotonEnvio2() {
        try { if (e2.submit && e2.submit.scrollIntoView) e2.submit.scrollIntoView({ block: 'nearest' }); } catch (e) {}
      }
      function hideError2() { if (e2.error) e2.error.hidden = true; }

      // ── Estado de error por-campo (corrección dueño 2026-07-11) ──────────────
      // Marca los wrappers .lb2-field de los campos faltantes con .lb2-field--error
      // (borde rojo del input + cajita del ícono + label en rojo), limpia el resto, y
      // hace auto-scroll al PRIMER faltante. Al escribir/cambiar en un campo con error
      // se le quita el estado (wireLimpiezaErrores, una sola vez).
      function fieldWrap(name) {
        return e2.form ? e2.form.querySelector('[data-lb2-field="' + name + '"]') : null;
      }
      function limpiarErroresCampos() {
        if (!e2.form) return;
        e2.form.querySelectorAll('.lb2-field--error').forEach(function (w) {
          w.classList.remove('lb2-field--error');
        });
      }
      function marcarErroresCampos(faltantes) {
        limpiarErroresCampos();
        var primero = null;
        (faltantes || []).forEach(function (f) {
          var w = fieldWrap(f.name);
          if (w) {
            w.classList.add('lb2-field--error');
            // A6 (ronda 6.5): mini-mensaje inline debajo del campo. El nodo se crea
            // UNA vez y persiste; el CSS solo lo muestra con .lb2-field--error →
            // se limpia junto con el rojo del campo (wireLimpiezaErrores intacto).
            var msgEl = w.querySelector('.lb2-field__msg');
            if (!msgEl) {
              msgEl = document.createElement('span');
              msgEl.className = 'lb2-field__msg';
              w.appendChild(msgEl);
            }
            msgEl.textContent = f.msg || MSG_OBLIGATORIO;
            if (!primero) primero = w;
          }
        });
        if (primero) {
          try { primero.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {
            try { primero.scrollIntoView(); } catch (e2e) {}
          }
        }
      }
      // Cablea la limpieza inmediata del error de un campo al escribir/cambiar. Se
      // llama UNA vez al construir el overlay (los inputs/selects ya existen).
      // Corrección dueño 2026-07-11 (bug validación residual): al corregir un campo
      // se le quita el rojo Y —si ya NO queda NINGÚN campo en error— se OCULTA también
      // el mensaje global "Te faltan estos datos…" (y cualquier error del server que
      // siguiera pegado). Antes el aviso se quedaba aunque el cliente ya lo hubiera
      // llenado todo. hideError2 es no-op si el error ya está oculto.
      var limpiezaCableada = false;
      function noQuedanCamposEnError() {
        return !!(e2.form && e2.form.querySelectorAll('.lb2-field--error').length === 0);
      }
      function wireLimpiezaErrores() {
        if (limpiezaCableada || !e2.form) return;
        limpiezaCableada = true;
        e2.form.querySelectorAll('[data-lb2-field]').forEach(function (w) {
          var quitar = function () {
            if (w.classList.contains('lb2-field--error')) w.classList.remove('lb2-field--error');
            // Si el cliente ya no tiene ningún campo en rojo, el mensaje global sobra.
            if (noQuedanCamposEnError()) hideError2();
          };
          w.querySelectorAll('input, select, textarea').forEach(function (ctrl) {
            ctrl.addEventListener('input', quitar);
            ctrl.addEventListener('change', quitar);
          });
        });
      }

      // ── CADENA DE UPSELLS ───────────────────────────────────────────────────
      // Recorre `chain` en orden. Un solo timer activo. Aceptar → push {id,qty} y
      // siguiente. No/timeout → siguiente. Fin de cadena → enviarOrden2. Cerrar el
      // overlay aborta SIN enviar.
      function correrCadena(onFin) {
        onCadenaFin = onFin;
        flashIdx = 0;
        siguienteOferta();
      }
      function siguienteOferta() {
        if (cadenaAbortada) return;
        if (flashIdx >= chain.length) {
          e2.flash.hidden = true;
          var fin = onCadenaFin; onCadenaFin = null;
          if (fin) fin();
          return;
        }
        var of = chain[flashIdx];
        flashIdx += 1;
        // Oferta inválida (sin id) → saltar.
        if (!of || of.id == null) { siguienteOferta(); return; }
        mostrarOferta(of);
      }
      function mostrarOferta(of) {
        limpiarTimers();
        // CASO 10 (24-jul): beacon de impresión — avisa al server que ESTA oferta se
        // mostró (denominador de la tasa de aceptación en /api/flash-stats). Misma
        // técnica que el beacon de /parcial: fetch keepalive fire-and-forget, jamás
        // bloquea ni rompe la UI. flashIdx ya avanzó en siguienteOferta → pos 1-based.
        try {
          fetch(endpoint + '/flash-vista', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
            body: JSON.stringify({
              tienda: String(cfg.tienda || '').trim() || undefined,
              productGid: productGid || undefined,
              ufId: of.id != null ? String(of.id) : '',
              pos: flashIdx,
            }),
            keepalive: true,
          }).catch(function () {});
        } catch (e) {}
        // Selector de cantidad POR DEFECTO en toda oferta flash (dueño 14-jul: "tiene
        // que tener el selector"). Default 5 ALINEADO con el server (router.js ~300) para
        // que la qty elegida se cobre/agregue de verdad; una oferta que quiera 1 sola
        // unidad pone qtyMax:1 explícito.
        var qtyMax = Math.max(1, Math.trunc(Number(of.qtyMax) || 5));
        var qty = 1;
        var seg = Math.max(1, Math.trunc(Number(of.countdownSeg) || 60));
        var pb = Number(of.precioBase) || 0;
        var pf = Number(of.precioFinal) || 0;
        // Full-screen en móvil (fix #5): la oferta ocupa TODO el viewport (imagen
        // grande, textos centrados, botones cómodos abajo). En desktop es modal.
        // REPARENT: el panel tiene animación con transform → un `position:fixed`
        // hijo del panel se anclaría al panel (que scrollea, height variable) y
        // colapsaría. Movemos el flash a la raíz del overlay (fixed inset:0, sin
        // transform) para que cubra el viewport de verdad. Volverá al panel al salir.
        if (flashFullscreen) {
          e2.flash.classList.add('lb2-flash--full');
          if (e2.flash.parentNode !== overlay2) overlay2.appendChild(e2.flash);
        } else {
          e2.flash.classList.remove('lb2-flash--full');
        }
        var qtyCtl = qtyMax > 1
          ? '<div class="lb2-qty"><button type="button" class="lb2-qty__btn" data-lb2-qty-dec>−</button><span class="lb2-qty__n" data-lb2-qty-n>1</span><button type="button" class="lb2-qty__btn" data-lb2-qty-inc>+</button></div>'
          : '';
        // La píldora "✨ Todas las unidades…" se ELIMINÓ (dictado dueño 26-jul, replay
        // iPhone 11 Pro): robaba el alto que necesitaba el selector de cantidad — y el
        // selector es el que sube el ticket. El descuento ya lo grita la píldora -N%.
        // Estructura (corrección dueño 2026-07-11, fix móvil #5): la zona de contenido
        // (imagen/textos/countdown) va en .lb2-flash__scroll (scrollea si no cabe) y
        // los DOS botones en .lb2-flash__actions (footer FUERA del scroll → SIEMPRE
        // visibles). El ✕ táctil queda absoluto sobre la card (independiente).
        // FOTOS: slider deslizable ‹ › cuando la oferta trae 2+ imagenes (calcado de la
        // app anterior, 14-jul: swipe nativo por scroll-snap + flechas). Con 1 foto,
        // la <img> simple de siempre. Las slides reusan .lb2-flash__img → heredan los
        // topes de alto y object-fit:contain (jamás recortan).
        var imgsFlash = (Array.isArray(of.imagenes) ? of.imagenes : [])
          .filter(function (u) { return typeof u === 'string' && /^https?:\/\//i.test(u); }).slice(0, 6);
        var imgHtml = '';
        if (imgsFlash.length >= 2) {
          imgHtml =
            '<div class="lb2-flash__slider" data-lb2-slider>' +
              '<div class="lb2-flash__slider-track" data-lb2-slider-track>' +
                imgsFlash.map(function (u, i) {
                  return '<img class="lb2-flash__img lb2-flash__slider-slide" src="' + esc(u) + '" alt="" ' + (i > 0 ? 'loading="lazy"' : '') + '>';
                }).join('') +
              '</div>' +
              '<button type="button" class="lb2-flash__slider-arrow lb2-flash__slider-arrow--prev" data-lb2-slider-prev aria-label="Foto anterior"></button>' +
              '<button type="button" class="lb2-flash__slider-arrow lb2-flash__slider-arrow--next" data-lb2-slider-next aria-label="Foto siguiente"></button>' +
            '</div>';
        } else if (imgsFlash[0] || of.imagen) {
          imgHtml = '<img class="lb2-flash__img" src="' + esc(imgsFlash[0] || of.imagen) + '" alt="">';
        }
        // SELECTOR DE VARIANTE en el flash (CASO 5, 22-jul): pills con miniatura + label,
        // una por variante. Solo si la oferta trae `of.variantes` con 2+ válidas. La
        // variante[0] es la DEFAULT (la que se muestra primero). Al ABRIR mutamos
        // of.variantId a la default → el payload lleva la variante correcta de una.
        var variantesFlash = (Array.isArray(of.variantes) ? of.variantes : []).filter(function (v) {
          return v && typeof v.variantId === 'string' && v.variantId &&
                 typeof v.imagen === 'string' && /^https?:\/\//i.test(v.imagen);
        });
        var varsHtml = '';
        if (variantesFlash.length >= 2) {
          of.variantId = variantesFlash[0].variantId; // default = primera variante
          // Con `variantes` la foto principal SIEMPRE es la de la variante default (aunque
          // no haya slider ni of.imagen sueltos) → el default se ve coherente al abrir.
          // `--var` (CASO 2 dueño 24-jul): la foto de variante LLENA el marco (object-fit
          // cover + alto protegido) — la imagen es la protagonista, no un thumbnail.
          if (imgsFlash.length < 2) {
            imgHtml = '<img class="lb2-flash__img lb2-flash__img--var" src="' + esc(variantesFlash[0].imagen) + '" alt="">';
          }
          varsHtml =
            '<div class="lb2-flash__vars" data-lb2-flash-vars>' +
              variantesFlash.map(function (v, i) {
                // Chip de SOLO texto (corrección dueño 22-jul): la miniatura robaba alto y
                // encogía la foto principal → ahora la foto grande de arriba es la protagonista
                // y muestra la variante elegida; el chip solo etiqueta el motivo.
                return '<button type="button" class="lb2-flash__var' + (i === 0 ? ' is-on' : '') + '" ' +
                         'data-lb2-flash-var="' + i + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">' +
                         '<span class="lb2-flash__var-lbl">' + esc(String(v.label || '')) + '</span>' +
                       '</button>';
              }).join('') +
            '</div>';
        }
        // NOMBRE del producto: NO renderizar si está vacío o si es "¡OFERTA FLASH!" (o
        // variantes) — eso duplicaría el título de arriba (bug visto en vivo 14-jul:
        // ofertas con titulo mal guardado = "¡OFERTA FLASH!"). Se compara normalizado.
        var nombreFlash = String(of.titulo || '').trim();
        var nombreNorm = nombreFlash.toLowerCase().replace(/[^a-z0-9]/g, '');
        var nombreRedundante = !nombreNorm || nombreNorm.indexOf('ofertaflash') === 0;
        // CASO 14: material entre paréntesis + desplegable de detalle. Sólo cuando el
        // producto tiene ficha revisada (fichaFlash); sin ficha el nombre se pinta
        // EXACTAMENTE como hoy y no hay desplegable → cero regresión.
        var ficha = fichaFlash(of.productGid);
        var nombreBase = ficha ? tituloSinParentesisFinal(nombreFlash) : nombreFlash;
        var detId = 'lb2-flash-det-' + flashIdx;
        var nombreHtml = '';
        if (!nombreRedundante && ficha) {
          // La FILA del nombre es el disparador del desplegable (área táctil = el ancho
          // completo del nombre, sin gastar ni un píxel de alto extra en un botón
          // propio: la línea roja del modal es que la foto no encoja).
          //
          // ── CASO 3 (dueño 28-jul) · que se NOTE que se puede hundir ──────────
          //   "Está difícil que el cliente hunda esa flecha — yo, que ya sabía que lo
          //    habías hecho, me costó descifrar que esa flechita daba más información.
          //    Mi sugerencia: que titile y que tenga un texto corto tipo 'más
          //    información'. ¿Qué piensas?"
          //   El dato que manda: el propio dueño, SABIENDO que existía, no la encontró.
          //   Pero la causa no es el tamaño del blanco (la fila entera ya era tocable):
          //   es AFFORDANCE — un chevrón suelto al lado de un título se lee como
          //   adorno, no como control.
          //   Contrapropuesta aceptada, 3 partes:
          //     (1) chip con BORDE y TEXTO ("Ver detalles ˅") → se lee como botón;
          //     (2) UN SOLO empujón de atención: late 2 veces al abrir el modal y se
          //         queda quieto. Un titileo permanente le robaría atención al CTA
          //         naranja, que es donde está el dinero (el modal ya compite con el
          //         countdown y el sello -62%);
          //     (3) `prefers-reduced-motion` apaga el latido (se respeta en el CSS).
          //   El chip se re-crea con cada oferta → el latido ocurre una vez por modal.
          nombreHtml =
            '<div class="lb2-flash__name lb2-flash__name--det" data-lb2-flash-namerow ' +
                 'role="button" tabindex="0" aria-expanded="false" aria-controls="' + detId + '">' +
              '<span class="lb2-flash__name-txt">' + esc(nombreBase) +
                ' <span class="lb2-flash__mat">(' + esc(ficha.m) + ')</span>' +
              '</span>' +
              '<span class="lb2-flash__detchip lb2-flash__detchip--hint" data-lb2-flash-detchip>' +
                '<span class="lb2-flash__detchip-txt" data-lb2-flash-detchip-txt>Ver detalles</span>' +
                '<span class="lb2-flash__detchev" aria-hidden="true"></span>' +
              '</span>' +
            '</div>';
        } else if (!nombreRedundante) {
          nombreHtml = '<div class="lb2-flash__name">' + esc(nombreFlash) + '</div>';
        }
        // Desplegable: NACE CERRADO ([hidden] → 0px) → en estado cerrado no le quita
        // NADA a la foto más allá de la 2ª línea del nombre. Al abrirse crece DENTRO
        // de .lb2-flash__scroll: la foto (único hijo flex:1 1 auto) cede hasta su piso
        // 38vh y a partir de ahí el scroll scrollea. El pie .lb2-flash__actions
        // (selector de cantidad + CTA) vive FUERA del scroll → sigue visible SIEMPRE.
        var detHtml = (ficha && !nombreRedundante && ficha.d && ficha.d.length)
          ? '<div class="lb2-flash__det" id="' + detId + '" data-lb2-flash-det hidden>' +
              '<ul class="lb2-flash__det-list">' +
                ficha.d.map(function (li) { return '<li>' + esc(String(li)) + '</li>'; }).join('') +
              '</ul>' +
            '</div>'
          : '';
        // Píldora de descuento (v3): SOLO si hay precio base > final > 0. floor → nunca
        // prometemos de más. El % es constante con qty (was y now escalan igual) → estático.
        var dtoPct = (pb > pf && pf > 0) ? Math.floor((1 - pf / pb) * 100) : null;
        e2.flash.innerHTML =
          '<div class="lb2-flash__card">' +
            '<button type="button" class="lb2-flash__x" data-lb2-flash-no aria-label="Cerrar oferta">×</button>' +
            '<div class="lb2-flash__scroll">' +
              '<div class="lb2-flash__title">¡OFERTA FLASH!</div>' +
              (of.subtitulo ? '<div class="lb2-flash__sub">' + esc(of.subtitulo) + '</div>' : '') +
              imgHtml +
              varsHtml +
              nombreHtml +
              detHtml +
              (of.copy ? '<div class="lb2-flash__copy">' + esc(of.copy) + '</div>' : '') +
              (of.badgeText ? '<div class="lb2-flash__badge">' + esc(of.badgeText) + '</div>' : '') +
              // Bloque precio ANCLA (v3): was tachado arriba + now enorme + píldora -N%.
              '<div class="lb2-flash__precio">' +
                (pb > 0 ? '<span class="lb2-flash__was">' + esc(formatearMoneda(pb)) + '</span>' : '') +
                '<span class="lb2-flash__now">' + esc(formatearMoneda(pf)) + '</span>' +
                (dtoPct != null ? '<span class="lb2-flash__dto">-' + dtoPct + '%</span>' : '') +
              '</div>' +
              // G3 · URGENCIA (LOTE 2 CASO 1): la etiqueta y los dígitos son UNA
              // sola idea → viajan en un grupo REAL, no como dos hermanos sueltos.
              // El scroll es flex-column (v10) y blockifica a sus hijos: sin este
              // wrapper la etiqueta se comía un renglón entero (16px medidos) y el
              // ojo leía "termina en:" y "00:14:32" como dos bloques distintos.
              // ⚠️ .lb2-flash__cd sigue siendo el ancla de medirReservaFlash
              // (lo busca con querySelector DENTRO del scroll → el wrapper no estorba).
              '<div class="lb2-flash__urg">' +
                '<div class="lb2-flash__cdlbl">⏰ La oferta termina en:</div>' +
                '<div class="lb2-flash__cd" data-lb2-cd></div>' +
              '</div>' +
            '</div>' +
            '<div class="lb2-flash__actions">' +
              // SELECTOR DE CANTIDAD EN EL FOOTER (dictado dueño 26-jul, replay iPhone
              // 11 Pro): dentro del scroll quedaba BAJO el pliegue con las barras de
              // Safari y nadie lo veía — y es el control que sube el ticket. El footer
              // está FUERA del scroll → el selector es visible SIEMPRE, en cualquier
              // viewport, estructuralmente (no por presupuesto de píxeles).
              qtyCtl +
              // Botón principal en el lenguaje del CTA de la landing (corrección dueño
              // 2026-07-13): FONDO NEGRO + BORDE NARANJA, 2 líneas (título + sublínea
              // "Paga al recibir · Envío gratis"). El total vivo (data-lb2-flash-yes-total)
              // refleja pf×qty cuando hay selector — solo DISPLAY, sin lógica de precios nueva.
              '<button type="button" class="lb2-flash__yes" data-lb2-flash-yes>' +
                '<span class="lb2-flash__yes-l1">🛍 Agregar a tu pedido<span data-lb2-flash-yes-total></span></span>' +
                '<span class="lb2-flash__yes-l2">' + esc(lbSubPago()) + '</span>' +
              '</button>' +
              // ✕ táctil (fix revisión 2026-07-10): en móvil no hay tecla Escape y el
              // flash tapa la X del panel — "No, gracias." equivale a rechazar.
              '<button type="button" class="lb2-flash__no" data-lb2-flash-no>No, gracias.</button>' +
            '</div>' +
          '</div>';
        e2.flash.hidden = false;

        // Caso 15: sólo en fullscreen, medir la reserva real para que la foto ocupe
        // el máximo espacio sin hueco (ver medirReservaFlash). rAF → layout ya aplicado.
        // Cada foto que aún cargue re-dispara la medición al load (offsetHeight puede
        // ser 0 mientras carga). En desktop (modal centrado) NO se toca nada.
        if (flashFullscreen) {
          // Doble rAF: 1ª pasada mide/aplica; 2ª (tras el reflow) cierra el residuo de
          // redondeo (±1px) → hueco final ≤ buffer. Converge en un paso (deadbeat).
          requestAnimationFrame(function () { medirReservaFlash(); requestAnimationFrame(medirReservaFlash); });
          e2.flash.querySelectorAll('.lb2-flash__img').forEach(function (im) {
            if (im.complete && im.offsetHeight) return;
            im.addEventListener('load', function () { requestAnimationFrame(medirReservaFlash); }, { once: true });
          });
          initReservaListeners();
        }

        // Flechas del slider de fotos (swipe nativo ya viene del scroll-snap; las
        // flechas dan el mismo gesto en desktop y refuerzan que HAY más fotos).
        var sTrack = e2.flash.querySelector('[data-lb2-slider-track]');
        if (sTrack) {
          // Corrección dueño 20-jul: el carrusel SIEMPRE abre en la foto 1 (la más
          // relevante = tarjeta branded). La navegación vive en el handler delegado.
          //
          // Corrección dueño 21-jul (BUG "primera imagen aleatoria en el cel"): fijar
          // scrollLeft=0 UNA sola vez no basta. En móvil fullscreen las fotos cargan
          // async y cada `load` dispara medirReservaFlash → reflow; con snap mandatory +
          // scroll-anchoring de Chrome el track se corría a otro slide ("a veces sí, a
          // veces no"). Solución: RE-FIJAR el 0 en cada momento de reflow (rAF, load de
          // cada foto, y un barrido corto anti-reflow-tardío por fuente/fullscreen),
          // hasta que el USUARIO deslice/toque una flecha. `data-lb2-usermoved` es la
          // señal compartida con el handler de flechas (delegado) para no pelear con él.
          (function pinFirst(track) {
            var pin = function () { if (!track.hasAttribute('data-lb2-usermoved')) track.scrollLeft = 0; };
            // Corrección escéptico 21-jul (hallazgo MEDIO): armar usermoved con
            // touchstart/pointerdown lo dispararía un TAP sin deslizar (el cliente toca
            // la foto para verla, un swipe abortado) → desactivaría el pin para siempre.
            // En iOS/WKWebView (WhatsApp iPhone) donde overflow-anchor es no-op, el pin
            // JS es la ÚNICA defensa → reaparecería el drift. Usamos señales de
            // MOVIMIENTO real: touchmove/pointermove sólo disparan cuando el dedo se
            // desplaza (swipe genuino) → cede el pin; un tap ya NO lo desactiva.
            ['touchmove', 'pointermove', 'wheel', 'keydown'].forEach(function (ev) {
              track.addEventListener(ev, function () { track.setAttribute('data-lb2-usermoved', '1'); }, { passive: true, once: true });
            });
            pin();
            requestAnimationFrame(function () { pin(); requestAnimationFrame(pin); });
            track.querySelectorAll('img').forEach(function (im) {
              if (im.complete && im.naturalWidth) return;
              im.addEventListener('load', function () { requestAnimationFrame(pin); }, { once: true });
            });
            // Barrido anti-reflow-tardío: ~1.2s a 100ms. Se auto-detiene si el usuario
            // deslizó (usermoved) o al agotar los intentos. Costo despreciable.
            var tries = 0;
            var iv = setInterval(function () {
              pin();
              if (track.hasAttribute('data-lb2-usermoved') || ++tries >= 12) clearInterval(iv);
            }, 100);
          })(sTrack);
        }
        // Flechas por DELEGACIÓN a nivel documento (fix 20-jul, visto en E2E real):
        // los listeners atados al nodo del botón morían cuando la card se re-renderiza
        // (quedaban flechas "sordas" → el carrusel parecía roto). Un único handler
        // delegado sobrevive a cualquier re-render; el índice se calcula del scroll
        // REAL al momento del click (no de una variable capturada), así jamás queda
        // a mitad entre fotos.
        if (!window.__lb2SliderDelegado) {
          window.__lb2SliderDelegado = true;
          document.addEventListener('click', function (ev) {
            var btn = ev.target && ev.target.closest ? ev.target.closest('[data-lb2-slider-prev],[data-lb2-slider-next]') : null;
            if (!btn) return;
            ev.preventDefault();
            var cont = btn.closest('[data-lb2-slider]');
            var track = cont && cont.querySelector('[data-lb2-slider-track]');
            if (!track || !track.children.length) return;
            var w = track.clientWidth || 1;
            var idx = Math.round(track.scrollLeft / w) + (btn.hasAttribute('data-lb2-slider-next') ? 1 : -1);
            if (idx < 0) idx = 0;
            if (idx > track.children.length - 1) idx = track.children.length - 1;
            var target = track.children[idx];
            if (!target) return;
            // El usuario navegó a mano → el pin del 0 (init) debe soltar este track
            // (21-jul), si no el barrido anti-reflow lo devolvería a la foto 1.
            track.setAttribute('data-lb2-usermoved', '1');
            // Scroll INSTANTÁNEO a propósito (verificado en vivo 20-jul): Chrome
            // descarta el scrollTo smooth en este track con scroll-snap mandatory
            // (la animación muere en el primer frame y la foto no avanza). El salto
            // directo siempre aterriza en la foto exacta; el snap CSS lo suaviza.
            track.scrollLeft = target.offsetLeft;
          }, true);
        }

        // Cableado del SELECTOR DE VARIANTE (CASO 5): click en pill → marca activa, cambia
        // la imagen principal del flash y MUTA of.variantId (el submit lee ese valor VIVO).
        var varsWrap = e2.flash.querySelector('[data-lb2-flash-vars]');
        if (varsWrap && variantesFlash.length >= 2) {
          varsWrap.querySelectorAll('[data-lb2-flash-var]').forEach(function (pill) {
            pill.addEventListener('click', function () {
              var i = Number(pill.getAttribute('data-lb2-flash-var')) || 0;
              var v = variantesFlash[i];
              if (!v) return;
              // Activa esta pill, apaga las demás (visual + a11y).
              varsWrap.querySelectorAll('[data-lb2-flash-var]').forEach(function (p) {
                var on = p === pill;
                p.classList.toggle('is-on', on);
                p.setAttribute('aria-pressed', on ? 'true' : 'false');
              });
              // Cambia la imagen principal. Con slider: reemplaza el track por 1 foto de la
              // variante y marca data-lb2-usermoved (cambio de variante = interacción
              // legítima → no pelea con el pin de la primera foto). Con img simple: cambia src.
              var track = e2.flash.querySelector('[data-lb2-slider-track]');
              if (track) {
                track.setAttribute('data-lb2-usermoved', '1');
                track.innerHTML = '<img class="lb2-flash__img lb2-flash__img--var lb2-flash__slider-slide" src="' + esc(v.imagen) + '" alt="">';
              } else {
                var mainImg = e2.flash.querySelector('.lb2-flash__img');
                if (mainImg) mainImg.src = v.imagen;
              }
              // MUTACIÓN del variantId vivo → aceptados.push({... variantId: of.variantId}).
              of.variantId = v.variantId;
              // La nueva foto puede tener otro alto → re-medir la reserva en fullscreen.
              if (flashFullscreen) requestAnimationFrame(medirReservaFlash);
            });
          });
        }

        // CASO 14 · cableado del desplegable de detalle (no destructivo por diseño):
        //   · Sólo togglea el atributo `hidden` de un bloque que vive DENTRO del scroll
        //     y por encima del ancla del medidor (.lb2-flash__cd sigue siendo el último
        //     contenido real del scroll) → medirReservaFlash mide lo mismo que antes.
        //   · NO llama a medirReservaFlash: con el desplegable abierto el contenido
        //     puede pasar del pie y el medidor vería hueco NEGATIVO → inflaría
        //     --lb2-flash-reserva y esa inflación NO se desharía al cerrar. Como en
        //     fullscreen el alto de la foto lo gobierna el layout v10 (flex:1 1 auto,
        //     piso 38vh / techo 62vh) y ya NO la variable, no medir es correcto Y
        //     mantiene la reserva exactamente donde estaba (sin saturación ni bucle).
        var detWrap = e2.flash.querySelector('[data-lb2-flash-det]');
        var nameRow = e2.flash.querySelector('[data-lb2-flash-namerow]');
        if (detWrap && nameRow) {
          var detChip = nameRow.querySelector('[data-lb2-flash-detchip]');
          var detChipTxt = nameRow.querySelector('[data-lb2-flash-detchip-txt]');
          var toggleDetalle = function () {
            var abrir = detWrap.hidden;
            detWrap.hidden = !abrir;
            nameRow.setAttribute('aria-expanded', abrir ? 'true' : 'false');
            nameRow.classList.toggle('is-open', abrir);
            // CASO 3: el chip dice qué va a pasar si lo tocas, no qué estado tiene.
            if (detChipTxt) detChipTxt.textContent = abrir ? 'Ocultar detalles' : 'Ver detalles';
            // Un toque = el cliente ya descubrió el control → se corta el latido (si
            // aún corriera) para no seguir robándole atención al CTA.
            if (detChip) detChip.classList.remove('lb2-flash__detchip--hint');
            if (abrir) {
              // Trae el detalle a la vista scrolleando DENTRO del scroll del flash
              // ('nearest' nunca mueve el viewport de la página ni el pie).
              requestAnimationFrame(function () {
                try { detWrap.scrollIntoView({ block: 'nearest' }); } catch (e) {}
              });
            }
          };
          nameRow.addEventListener('click', toggleDetalle);
          nameRow.addEventListener('keydown', function (ev) {
            var k = ev.key;
            if (k === 'Enter' || k === ' ' || k === 'Spacebar') { ev.preventDefault(); toggleDetalle(); }
          });
        }

        var nEl = e2.flash.querySelector('[data-lb2-qty-n]');
        var dec = e2.flash.querySelector('[data-lb2-qty-dec]');
        var inc = e2.flash.querySelector('[data-lb2-qty-inc]');
        var nowEl = e2.flash.querySelector('.lb2-flash__now');
        var yesTotalEl = e2.flash.querySelector('[data-lb2-flash-yes-total]');
        // DISPLAY vivo del total al mover el selector (corrección dueño 2026-07-13):
        // el precio grande y la etiqueta del botón muestran pf×qty. NO es lógica de
        // precios nueva — el server ya calcula precioFinal×qty (aceptados.push lleva qty).
        var wasEl = e2.flash.querySelector('.lb2-flash__was');
        function pintaQty() {
          if (nEl) nEl.textContent = String(qty);
          if (nowEl) nowEl.textContent = formatearMoneda(pf * qty);
          // Tachado HONESTO (pulido escéptico v5): con los precios ahora EN LÍNEA, el
          // tachado también se multiplica por qty — si no, con 3 uds el "antes" ($799)
          // quedaría MENOR que el final ($897) y el descuento parecería falso.
          if (wasEl && pb > 0) wasEl.textContent = formatearMoneda(pb * qty);
          if (yesTotalEl) yesTotalEl.textContent = qty > 1 ? ' · ' + formatearMoneda(pf * qty) : '';
        }
        pintaQty();
        if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); pintaQty(); });
        if (inc) inc.addEventListener('click', function () { qty = Math.min(qtyMax, qty + 1); pintaQty(); });

        // GUARD anti-carrera (fix 2026-07-10 COD Total): si el countdown llega a 0 en el
        // MISMO instante del clic del cliente, el interval encolado y el click disparan
        // decidir() DOS veces → la cadena avanzaba de más y podía ordenar saltándose
        // ofertas. Cada oferta decide UNA sola vez; llamadas tardías (timer viejo en la
        // cola de eventos) mueren aquí.
        var decidido = false;
        function decidir(acepta) {
          if (decidido) return;
          decidido = true;
          limpiarTimers();
          e2.flash.hidden = true;
          if (acepta) {
            // variantId VIVO: si el cliente eligió variante (CASO 5) of.variantId ya está
            // mutado a la elegida → viaja en el payload. Sin variantes queda undefined y el
            // server resuelve por id desde el metafield (comportamiento legacy intacto).
            aceptados.push({ id: String(of.id), qty: qty, variantId: of.variantId });
            pintarDesglose();
          }
          siguienteOferta();
        }
        e2.flash.querySelector('[data-lb2-flash-yes]').addEventListener('click', function () { decidir(true); });
        // querySelectorAll: el "No, gracias." Y el ✕ táctil comparten el atributo.
        e2.flash.querySelectorAll('[data-lb2-flash-no]').forEach(function (b) {
          b.addEventListener('click', function () { decidir(false); });
        });

        // Countdown por DELTA de reloj (fix revisión adversaria 2026-07-10): los
        // navegadores throttlean setInterval en pestañas ocultas (Chrome hasta 1
        // tick/min) → el decremento -1 por tick congelaba la oferta. Con finTs el
        // tiempo mostrado es SIEMPRE real, aunque los ticks lleguen tarde.
        var finTs = Date.now() + seg * 1000;
        var cdEl = e2.flash.querySelector('[data-lb2-cd]');
        // v3 "Joya Nocturna": dígitos en 3 chips (HH : MM : SS) con separadores dorados.
        // Se rellena el MISMO nodo data-lb2-cd que ya referencia el JS (medirReservaFlash
        // sigue anclando a .lb2-flash__cd) → sólo cambia su contenido a spans, el tick
        // escribe en cada chip en vez de un textContent con el string completo.
        var cdChips = [];
        if (cdEl) {
          cdEl.innerHTML =
            '<span class="lb2-flash__cd-chip">00</span>' +
            '<span class="lb2-flash__cd-sep">:</span>' +
            '<span class="lb2-flash__cd-chip">00</span>' +
            '<span class="lb2-flash__cd-sep">:</span>' +
            '<span class="lb2-flash__cd-chip">00</span>';
          cdChips = cdEl.querySelectorAll('.lb2-flash__cd-chip');
        }
        function pintaCd(rest) {
          // Formato HH:MM:SS de la app anterior (medido en vivo 14-jul): "00 : 00 : 58".
          var h = Math.floor(rest / 3600), m = Math.floor((rest % 3600) / 60), s = rest % 60;
          var p2 = function (n) { return String(n).padStart(2, '0'); };
          if (cdChips[0]) cdChips[0].textContent = p2(h);
          if (cdChips[1]) cdChips[1].textContent = p2(m);
          if (cdChips[2]) cdChips[2].textContent = p2(s);
          // URGENCIA: ≤30s → .is-urgent (chips/dígitos rojos + pulso; el CSS gatea el
          // pulso por prefers-reduced-motion). Toggle en el tick, donde ya hay el restante.
          if (cdEl) cdEl.classList.toggle('is-urgent', rest <= 30);
        }
        pintaCd(seg);
        flashTimer2 = setInterval(function () {
          var rest = Math.ceil((finTs - Date.now()) / 1000);
          if (rest <= 0) { decidir(false); return; }
          pintaCd(rest);
        }, 1000);
      }

      // ── Envío ────────────────────────────────────────────────────────────────
      // GUARD de re-entrada (revisión adversaria 2026-07-10): un 2º Enter/click
      // mientras la cadena corre o el POST vuela re-disparaba correrCadena →
      // reiniciaba flashIdx SIN limpiar `aceptados` → upsell duplicado (sobrecobro).
      var procesando2 = false;
      function onSubmit2() {
        if (procesando2 || enviado2) return;
        var d = datosDelForm2();
        if (d.website) { mostrarGracias2(null, null); return; } // honeypot
        var v = validarCliente2(d);
        if (v.faltantes.length) {
          // Corrección dueño 2026-07-11: valida TODOS los campos, pinta cada faltante en
          // rojo, mensaje claro arriba del CTA con nombres humanos y auto-scroll al 1º.
          marcarErroresCampos(v.faltantes);
          var soloEmail = v.faltantes.length === 1 && v.faltantes[0].name === 'email' && v.emailMalo;
          var nombres = v.faltantes.map(function (f) { return f.label; }).join(', ');
          var msg = soloEmail ? 'El correo no parece válido.' : ('Te faltan estos datos: ' + nombres + '.');
          showError2(msg);
          return;
        }
        limpiarErroresCampos();
        hideError2();
        procesando2 = true;
        // A1: desde AQUÍ la orden ya no se puede perder — cualquier salida durante
        // la cadena (✕, Escape, cierre, pagehide, pestaña oculta) la envía con los
        // upsells aceptados hasta ese momento (closeOverlay2 / flushOrden2).
        datosPendientes2 = d;
        // D2: id de dedupe pixel↔CAPI, estable para esta orden. El reintento del MISMO
        // pedido tras un envío sin respuesta definitiva conserva el suyo (ver reintento2).
        var esReintento2 = !!(reintento2 && reintento2.clave === claveEnvio2(d));
        eventId2 = esReintento2 ? reintento2.eventId : uuidV4();
        e2.submit.disabled = true;
        // ⏱️ (22-oct) Reintento del MISMO pedido tras un envío sin respuesta: el cliente ya
        // decidió las ofertas en esta apertura (siguen en `aceptados`) → se manda el MISMO
        // pedido sin volver a enseñarle la cadena. Si reabrió el formulario, la cadena corre.
        if (esReintento2 && reintento2.cadenaHecha) { enviarOrden2(d); return; }
        // Cadena de upsells → luego POST.
        if (chain.length) {
          // Full-screen de la oferta en móvil (fix #5): oculta el formulario para
          // que la oferta SEA la pantalla. En desktop (≥640px) sigue como modal
          // sobre el panel (formwrap visible detrás).
          if (esMovilAncho(640)) {
            flashFullscreen = true;
            e2.formwrap.hidden = true;
            if (e2.panel) { try { e2.panel.scrollTop = 0; } catch (e) {} }
          }
          correrCadena(function () { enviarOrden2(d); });
        } else {
          enviarOrden2(d);
        }
      }

      // Payload del POST /ordenar — extraído (A1) para que enviarOrden2 (camino
      // visible) y flushOrden2 (página muriendo) manden EXACTAMENTE lo mismo.
      function payloadOrden2(d) {
        // lbConMedicion: `ab`/`codm` en la raíz SOLO si la página los trae (A/B, E2).
        return lbConMedicion({
          productGid: productGid || undefined,
          // TIER ABIERTO: n = tier del metafield (=3), unidades = N elegido en el
          // stepper (≥3). El server elige el pack por n y escala el precio × unidades.
          // Para tiers normales n===unidades → payload idéntico al de antes. `abierto`
          // le dice al server si el tier ADMITE escalar (clave idem diverge solo si sí).
          tier: { n: currentSel2.n, unidades: currentSel2.unidades, abierto: currentSel2.abierto === true },
          variantesPorUnidad: currentSel2.variantesPorUnidad,
          upsells: {
            // FASE B: mapa índice→bool de TODOS los ticks (server-authoritative: el
            // precio jamás viaja). `tick` legacy = el primero — compat con el router
            // viejo del VPS hasta el deploy (solo cobraría el tick 0).
            tick: ticksState[0] === true,
            ticks: (function () {
              var m = {};
              ticks2.forEach(function (t, i) { m[i] = ticksState[i] === true; });
              return m;
            })(),
            flashAceptados: aceptados.slice(),
          },
          datos: {
            nombre: d.nombre, apellido: d.apellido, whatsapp: d.whatsapp,
            estado: d.estado, municipio: d.municipio, cp: d.cp, colonia: d.colonia,
            direccion: d.direccion, email: d.email, nota: d.nota,
          },
          website: d.website,
          // D2 (CAPI): fbp/fbc/url/eventId para el match de Conversions API + dedupe.
          attr: construirAttr(eventId2),
        });
      }

      // A2 (ronda 6.5) + D2 (CAPI): Meta Pixel Purchase con eventID = eventId2, el id
      // generado al FINALIZAR. ES EL MISMO en el camino visible y en el flush → Meta
      // dedupe este Purchase del pixel contra el Purchase server-side (CAPI, que usa
      // el mismo eventId del payload). Sin fbq (harness/tests) → silencio total.
      function trackPurchase2(orderName, total) {
        if (typeof fbq !== 'function') return;
        try {
          var data = { currency: lbMonedaTienda(), value: Number(total) || 0 };
          if (eventId2) fbq('track', 'Purchase', data, { eventID: eventId2 });
          else fbq('track', 'Purchase', data);
        } catch (e) {}
      }

      function enviarOrden2(d) {
        if (cadenaAbortada) return; // el overlay se cerró SIN FINALIZAR válido
        if (enviado2 || postEnVuelo2) return; // A1: guard anti doble POST /ordenar
        postEnVuelo2 = true;
        e2.submit.disabled = true;
        e2.submit.classList.add('is-loading');
        var payload = payloadOrden2(d);
        // ⏱️ (22-oct) Tiempo límite de 25 s y textos honestos: ver «EL ENVÍO DEL PEDIDO»
        // en initCod. `noDefinitivo` = el pedido PUDO crearse (colgado, red, 5xx, 429): el
        // reintento del mismo pedido conserva su eventId y no repite la cadena de ofertas.
        var respondio = false;
        var noDefinitivo = function () {
          reintento2 = { clave: claveEnvio2(d), eventId: eventId2, cadenaHecha: true };
        };
        lbEnviarConPlazo(endpoint + '/ordenar', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'ngrok-skip-browser-warning': 'true' },
          body: JSON.stringify(payload),
          // A1: si la pestaña muere con el POST recién disparado, keepalive lo deja
          // terminar en background (la orden no se pierde por cerrar rápido).
          keepalive: true,
        })
          .then(function (res) {
            respondio = true;
            if (res.ok && res.j && res.j.ok) {
              enviado2 = true;
              reintento2 = null;
              datosPendientes2 = null; // orden creada: nada pendiente de flush
              lbSalud('envio_ok');
              var totalFinal = (res.j.desglose && res.j.desglose.total != null)
                ? Number(res.j.desglose.total) : calcDesglose().total;
              trackPurchase2(res.j.orderName || null, totalFinal);
              mostrarGracias2(res.j.orderName || null, res.j.desglose || null);
            } else {
              lbSalud('envio_fallido:' + lbCodigoEnvio(res.status));
              // 400/409/403…: el servidor DECIDIÓ (no creó nada). 5xx/429: pudo crearse.
              if (res.status >= 500 || res.status === 429 || !res.status) noDefinitivo();
              else reintento2 = null;
              restaurarFormFullscreen(); // vuelve a mostrar el form (fix #5) con el error arriba del CTA
              showError2(lbTextoFallo(res.status, res.j));
              verBotonEnvio2();
              procesando2 = false; // permite reintentar tras corregir datos
              postEnVuelo2 = false;
              // El server RECHAZÓ estos datos → no re-flushearlos en pagehide (el
              // cliente debe corregir y re-FINALIZAR; eso re-arma datosPendientes2).
              datosPendientes2 = null;
              e2.submit.disabled = false; e2.submit.classList.remove('is-loading');
            }
          })
          .catch(function (err) {
            if (enviado2) return; // el pedido salió: lo que lanzó fue pintar las gracias
            restaurarFormFullscreen();
            if (err && err.plazo) { lbSalud('envio_colgado'); showError2(LB_TXT_COLGADO); }
            else { if (!respondio) lbSalud('envio_fallido:red'); showError2(LB_TXT_FALLO); }
            verBotonEnvio2();
            if (!respondio) noDefinitivo();
            procesando2 = false; // permite reintentar tras el fallo de red
            postEnVuelo2 = false;
            // Respuesta perdida ≠ orden no creada: el POST pudo llegar al server.
            // NO auto-reintentar en pagehide (riesgo de orden DUPLICADA en Shopify);
            // el reintento es manual (botón) como hasta ahora.
            datosPendientes2 = null;
            e2.submit.disabled = false; e2.submit.classList.remove('is-loading');
          });
      }

      // A1(b) (ronda 6.5): la página está MURIENDO (pagehide / pestaña oculta en iOS)
      // con una orden pendiente → se envía YA con fetch keepalive y el payload
      // idéntico al camino visible. NO navigator.sendBeacon con JSON: el Blob
      // application/json es bloqueado por CORS sin preflight (y ngrok exige header
      // custom). Si la pestaña revive (tab switch), el cliente ve la pantalla de
      // gracias y la cadena muerta ya no puede re-enviar (enviado2 + timers limpios).
      function flushOrden2() {
        if (!cadenaEnVuelo2() || postEnVuelo2) return;
        postEnVuelo2 = true;
        enviado2 = true; // guard doble POST: exactamente 1 POST /ordenar por orden
        limpiarTimers();
        onCadenaFin = null;
        var payload = payloadOrden2(datosPendientes2);
        datosPendientes2 = null;
        try {
          fetch(endpoint + '/ordenar', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'ngrok-skip-browser-warning': 'true' },
            body: JSON.stringify(payload),
            keepalive: true,
          }).catch(function () {});
        } catch (e) {}
        trackPurchase2(null, calcDesglose().total); // sin orderName: el server no alcanzó a responder
        try { mostrarGracias2(null, null); } catch (e) {}
      }

      // Devuelve el nodo flash al panel (tras el reparent del full-screen). Así el
      // modal de desktop y la próxima apertura lo tienen en su sitio original.
      function devolverFlashAlPanel() {
        if (e2.flash && e2.panel && e2.flash.parentNode !== e2.panel) {
          try { e2.panel.appendChild(e2.flash); } catch (e) {}
        }
      }

      // Restaura el formulario tras el modo full-screen de ofertas en móvil (fix #5):
      // usado en el path de ERROR del POST (para mostrar el error arriba del CTA) y
      // al abortar. Idempotente. Sube el panel para que el error sea visible.
      function restaurarFormFullscreen() {
        if (!flashFullscreen) return;
        flashFullscreen = false;
        if (e2.flash) { e2.flash.hidden = true; e2.flash.classList.remove('lb2-flash--full'); }
        devolverFlashAlPanel();
        if (e2.formwrap) e2.formwrap.hidden = false;
        if (e2.panel) { try { e2.panel.scrollTop = 0; } catch (e) {} }
      }

      function mostrarGracias2(orderName, desglose) {
        enviado2 = true;
        flashFullscreen = false;
        e2.formwrap.hidden = true;
        e2.flash.hidden = true;
        e2.flash.classList.remove('lb2-flash--full');
        devolverFlashAlPanel();
        e2.thanks.hidden = false;
        // Panel arriba del todo para la pantalla de gracias (fix móvil #7).
        if (e2.panel) { try { e2.panel.scrollTop = 0; } catch (e) {} }
        // Mini-desglose final: usa el del server si vino; si no, el local.
        var d = desglose || calcDesglose();
        var total = (desglose && desglose.total != null) ? Number(desglose.total) : d.total;
        var mini =
          '<div class="lb2-thanks__mini">' +
            '<div class="lb2-resumen__fila"><span>Envío</span><span class="lb2-free">Gratis</span></div>' +
            '<div class="lb2-resumen__fila lb2-resumen__total"><span>TOTAL</span><span>' + esc(formatearMoneda(total)) + '</span></div>' +
          '</div>';
        e2.thanks.innerHTML =
          '<div class="lb2-thanks__ico">✓</div>' +
          '<div class="lb2-thanks__title">¡Pedido confirmado!</div>' +
          '<div class="lb2-thanks__msg">Gracias por tu compra.' +
            (orderName ? ' Tu número de orden es <b>' + esc(orderName) + '</b>.' : '') +
            ' Pagas al recibir.</div>' +
          // Frase de WhatsApp DESTACADA en una cajita verde suave (corrección dueño 2026-07-11).
          '<div class="lb2-thanks__wa">' +
            '<span class="lb2-thanks__wa-ico" aria-hidden="true">📲</span>' +
            '<span class="lb2-thanks__wa-txt">Te contactaremos por <b>WhatsApp</b> para coordinar la entrega.</span>' +
          '</div>' +
          mini +
          '<button type="button" class="lb2-cta lb2-thanks__close" data-lb2-close><span class="lb2-cta__l1">Entendido</span></button>';
        e2.thanks.querySelectorAll('[data-lb2-close]').forEach(function (c) { c.addEventListener('click', closeOverlay2); });
      }

      // ── Interceptores (CTA + sticky + submit nativo) ────────────────────────
      // FASE B: pinta/cablea las tarjetas de tick EN LA LANDING (bajo el bloque de
      // packs) al iniciar v2 — la otra ubicación (overlay) se pinta en buildOverlay2.
      try { initTicksPagina(); } catch (e) {}
      var cta2 = form.querySelector('[data-lb-cod-cta]');
      if (cta2) cta2.addEventListener('click', function (ev) { ev.preventDefault(); openOverlay2(); });
      var stickyBtn2 = document.querySelector('[data-lb-sticky-btn]');
      if (stickyBtn2) stickyBtn2.addEventListener('click', function (ev) { ev.preventDefault(); openOverlay2(); });
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (overlay2 && !overlay2.hidden) return;
        openOverlay2();
      });
      // Cola de toques (velocidad 21-oct): el botón YA está conectado. Si el cliente lo
      // tocó antes, se abre ahora — una sola vez (ver lbColaListo).
      lbColaListo(openOverlay2);

      // Beacon de parcial (idéntico a v1, sobre e2). Ronda 6.5 (A3): además de
      // pagehide/beforeunload, se dispara al CERRAR con ✕ (closeOverlay2, path sin
      // orden en vuelo) y en visibilitychange→hidden con overlay abierto (iOS Safari
      // mata pestañas sin pagehide). ONE-SHOT (parcialEnviado2): el server APPENDEA
      // cada POST /parcial al archivo (no upserta por teléfono) → re-enviar
      // duplicaría el registro para el agente de carritos.
      var parcialEnviado2 = false;
      function reportarParcial2() {
        if (parcialEnviado2 || enviado2 || !overlay2 || overlay2.hidden) return;
        // A1: si hay una orden COMPLETA pendiente de flush, el que sale es el POST
        // /ordenar (flushOrden2) — un parcial además duplicaría el contacto.
        if (cadenaEnVuelo2()) return;
        var wEl = e2.form && e2.form.querySelector('[name="whatsapp"]');
        var whats = wEl ? String(wEl.value || '').replace(/\D/g, '').slice(-10) : '';
        if (!/^\d{10}$/.test(whats)) return;
        var d = datosDelForm2();
        if (d.website) return;
        var productosTxt = '', valorNum = 0;
        if (currentSel2) {
          productosTxt = 'Pack ' + currentSel2.unidades + ' × ' + (productoTitulo || 'producto');
          valorNum = precioNumerico(currentSel2.precioMoney);
        }
        var body = { phone: whats, nombre: d.nombre || '', productos: productosTxt, valor: valorNum, cp: d.cp || '', tienda: (String(cfg.tienda || '').trim() || undefined), fuente: 'cod-form' };
        agregarDatosEntrega(body, d); // apellido/estado/municipio/colonia/dirección (si los hay)
        lbConMedicion(body); // A/B (E2): `ab`/`codm` solo si la página los trae
        try {
          fetch(endpoint + '/parcial', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'true' },
            body: JSON.stringify(body), keepalive: true,
          }).catch(function () {});
          parcialEnviado2 = true;
        } catch (e) {}
      }
      window.addEventListener('pagehide', reportarParcial2);
      window.addEventListener('beforeunload', reportarParcial2);
      // A1(b): la orden pendiente sale ANTES que cualquier parcial (reportarParcial2
      // ya se salta el caso cadenaEnVuelo2 → nunca hay parcial + orden a la vez).
      window.addEventListener('pagehide', flushOrden2);
      window.addEventListener('beforeunload', flushOrden2);
      // A1(b) + A3(b): iOS Safari mata pestañas SIN pagehide → visibilitychange→hidden
      // es la última señal confiable. Orden en vuelo → flush del /ordenar; si no,
      // overlay abierto con WhatsApp válido → parcial (one-shot).
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState !== 'hidden') return;
        if (cadenaEnVuelo2()) { flushOrden2(); return; }
        reportarParcial2();
      });
    }
  }

  ready(function () {
    try { initAnnouncement(); } catch (e) {}
    try { initBuyBox(); } catch (e) {}
    // CASO 1: DESPUÉS de initBuyBox — el plan del carrito lee el tier activo, que
    // initBuyBox acaba de marcar (aunque el cableado sólo corre en el submit).
    try { initCartForm(); } catch (e) {}
    try { initCountdown(); } catch (e) {}
    try { initGallery(); } catch (e) {}
    try { initCarousels(); } catch (e) {}
    try { initReviewsCarousel(); } catch (e) {}
    try { initStickyAtc(); } catch (e) {}
    // initStickyOffers ANTES de initCod: si el guard borra el sticky del snippet
    // (porque el theme ya trae [data-lb-sticky]), initCod no cablea un botón muerto.
    try { initStickyOffers(); } catch (e) {}
    try { initCod(); } catch (e) {}
    // A10: al final y en su propio try — si algo aquí explota, la página ya está
    // completa y visible (el gate por dato hace que sea un no-op en toda landing
    // que no traiga codSkin.revelarAlScroll).
    try { initRevealOnScroll(); } catch (e) {}
    // CASO 6: al FINAL — initStickyOffers/initCod ya reescribieron los textos del
    // botón COD (píldora + adhesivo); aquí sólo se remata la sublínea con 🇲🇽.
    try { asegurarBanderaCOD(); } catch (e) {}
  });

  // ══ ARRANQUE TEMPRANO DE LA ZONA DE COMPRA (velocidad MX, encargo de CORDI con ══
  // ══ OK del dueño, 21-oct-2026)                                                 ══
  //   ANTES todo esperaba a DOMContentLoaded, y DOMContentLoaded espera a que se
  //   bajen y ejecuten TODOS los scripts `defer` de la página (apps incluidas).
  //   Medido en celular 4G: el botón se veía 0,6-3,7 s antes de funcionar, y una
  //   app colgada lo dejó muerto 13-45 s.
  //   AHORA la zona de compra (initBuyBox → initCartForm → initStickyOffers →
  //   initCod, el MISMO orden de ready()) corre EN CUANTO este archivo se ejecuta,
  //   SI su HTML ya está parseado: el <script> va al FINAL del snippet offers-inline
  //   (y de landing-buda-main v1), así que el formulario de packs, la config, el
  //   botón y el adhesivo están ARRIBA de él. Lo demás (galería, contadores,
  //   carruseles, reveal, anuncio) sigue en DOMContentLoaded, como siempre.
  //   🔒 Cada init tiene su guard lbYaCorrio: cuando ready() los vuelve a llamar en
  //   DOMContentLoaded, no enlazan nada dos veces.
  //   🔒 Si el HTML de compra NO está antes de este <script> (otro template, otra
  //   posición, script diferido), no se adelanta nada: todo corre en
  //   DOMContentLoaded exactamente como antes.
  //   ⚠️ Va DESPUÉS de ready() y toma cada init con `typeof`: la copia de Varelú
  //   (projects/tienda-general-co/theme-overlay/build-varelu-cod-zip.sh) recorta de
  //   este archivo el controlador contra entrega y el carrito, y exige que no quede
  //   ninguna llamada literal a ellos. Allá el script va `defer`, así que esto ni corre.
  //   🔒 Exige la COLA DE TOQUES (window.__lbCola): el snippet solo la emite en
  //   las tiendas de México (moneda de la tienda). En Colombia este archivo convive con puente-landing-co.js, que
  //   intercepta la píldora para abrir el formulario CO: adelantar aquí el overlay
  //   mexicano abriría el formulario EQUIVOCADO si el puente aún no cargó. Sin cola
  //   → todo en DOMContentLoaded, como antes.
  function lbDomCompraListo() {
    try {
      if (!window.__lbCola) return false;
      if (document.readyState !== 'loading') return false; // ready() corre ya mismo
      var s = document.currentScript;
      if (!s || !s.parentNode) return false;
      var f = document.querySelector('[data-lb-form]');
      var c = document.querySelector('[data-lb-cod-config]');
      if (!f || !c) return false;
      var SIGUE = 4; // Node.DOCUMENT_POSITION_FOLLOWING: el script va DESPUÉS del nodo
      return !!(f.compareDocumentPosition(s) & SIGUE) && !!(c.compareDocumentPosition(s) & SIGUE);
    } catch (e) { return false; }
  }
  //   En DOMContentLoaded (DESPUÉS del ready() de arriba) se rematan las dos cosas
  //   que dependían de tener la página completa:
  //     · los residuos de Releasit que un app-embed inyectó entre medias;
  //     · el adhesivo: se vuelve a colgar al FINAL del <body> (orden final idéntico
  //       al de antes) y, si un sticky del theme ([data-lb-sticky]) apareció MÁS
  //       ABAJO del script, se retira el del snippet, como hacía el guard original.
  function lbRematarArranqueTemprano() {
    lbOcultarRestosReleasit();
    var bar = _lbStickyOffersBar;
    if (!bar) return;
    if (document.querySelector('[data-lb-sticky]')) {
      try { if (_lbStickyOffersEval) window.removeEventListener('scroll', _lbStickyOffersEval); } catch (e) {}
      try { if (bar.parentNode) bar.parentNode.removeChild(bar); } catch (e) {}
      try {
        var b = document.body;
        if (b && b.getAttribute('data-lb-sticky-pad') === '1' && _lbStickyPadPrev !== null) {
          b.style.paddingBottom = _lbStickyPadPrev;
          b.removeAttribute('data-lb-sticky-pad');
        }
      } catch (e) {}
      _lbStickyOffersBar = null;
      _lbStickyOffersEval = null;
      return;
    }
    try { if (document.body && document.body.lastElementChild !== bar) document.body.appendChild(bar); } catch (e) {}
  }
  try {
    if (lbDomCompraListo()) {
      var zona = [
        typeof initBuyBox === 'function' ? initBuyBox : null,
        // CASO 1: DESPUÉS de initBuyBox (el plan del carrito lee el tier activo).
        typeof initCartForm === 'function' ? initCartForm : null,
        // initStickyOffers ANTES de initCod (si borra el adhesivo, initCod no cablea un botón muerto).
        typeof initStickyOffers === 'function' ? initStickyOffers : null,
        typeof initCod === 'function' ? initCod : null,
        // Si initCod no conectó el botón (sin config/endpoint/form, o falló), la cola
        // se suelta YA: un toque guardado no puede quedar esperando.
        typeof lbColaSoltar === 'function' ? lbColaSoltar : null,
        typeof asegurarBanderaCOD === 'function' ? asegurarBanderaCOD : null
      ];
      for (var zi = 0; zi < zona.length; zi++) {
        if (zona[zi]) { try { zona[zi](); } catch (e) {} }
      }
      document.addEventListener('DOMContentLoaded', function () {
        try { lbRematarArranqueTemprano(); } catch (e) {}
      });
    }
  } catch (e) {}
  // Y SIEMPRE, después del ready() de arriba (mismo evento, registrado después): si
  // en DOMContentLoaded nadie conectó el botón, la cola de toques se suelta (quita el
  // indicador). Si initCod lo conectó, lbColaListo ya la cerró y esto es un no-op.
  // (Función con NOMBRE a propósito: el ready() anónimo de arriba tiene que seguir
  // siendo el ÚNICO — la copia de Varelú corta este archivo justo en él.)
  ready(function lbSoltarColaAlFinal() {
    if (typeof lbColaSoltar === 'function') { try { lbColaSoltar(); } catch (e) {} }
  });
})();
